(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5938,9564,1275,6035,2426],{

/***/ 55120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27812);
/* harmony import */ var _BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89744);
/* harmony import */ var _BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _Redux_actionTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var BreadCrumb = function BreadCrumb(_ref) {
  var list = _ref.list,
      title = _ref.title,
      replacePageTitle = _ref.replacePageTitle;
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .componentResize */ .Y4)();
  var itemsBefore = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.items_display_before_collapser_mbl */ .Z.BreadCrumbLabels.items_display_before_collapser_mbl;
  var itemsAfter = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.items_display_after_collapser_mbl */ .Z.BreadCrumbLabels.items_display_after_collapser_mbl;
  var breadcrumbList = [];
  var currentPage = {};
  var lastItem;
  var router = (0,_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var dispatch = (0,_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useDispatch)();
  var isMiniApp = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getCookieValue */ .Do)("miniApp") === "true";

  var handleClick = function handleClick(url) {
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
    dispatch({
      type: _Redux_actionTypes__WEBPACK_IMPORTED_MODULE_4__/* .BREADCRUMB_SELECT */ .T1,
      payload: true
    });

    if ((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .internalUrl */ .az)(url).url === "/") {
      if (true) {
        var origin = window.location.origin; // .then(()=>{

        window.location.assign(origin);
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)(); // window.lo
        // })
      }
    } else {
      router.push((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .internalUrl */ .az)(url).url).then(function () {
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
      });
    }
  };

  function handleBreadCrumbMobile(breadcrumbList) {
    if (isMobile && breadcrumbList.length > _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.max_display_items_mbl */ .Z.BreadCrumbLabels.max_display_items_mbl) {
      breadcrumbList.splice.apply(breadcrumbList, [0, breadcrumbList.length].concat((0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(breadcrumbList.slice(0, itemsBefore)), [{
        title: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_hidden_breadCrumb_for_mobile */ .Z.BreadCrumbLabels.lbl_hidden_breadCrumb_for_mobile
      }], (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(breadcrumbList.slice(breadcrumbList.length - itemsAfter, breadcrumbList.length))));
    }

    lastItem = breadcrumbList.length - 1;
    return breadcrumbList;
  }

  if (list) {
    var totalKeys = Object.keys(list).length; // Mapping current page object into currentPage

    if (totalKeys > 0) {
      currentPage = Object.values(list)[totalKeys - 1];
    }

    Object.entries(list).forEach(function (value) {
      var replacedTitle = title && value[1].url === currentPage.url ? title : null;
      var replacePageTitleBool = replacePageTitle && value[1].url === currentPage.url ? true : false;
      var matchedRoute = {
        url: value[1].url,
        title: value[0],
        replacedTitle: replacedTitle,
        replacePageTitle: replacePageTitleBool
      };
      breadcrumbList.push(matchedRoute);
    });
    lastItem = breadcrumbList.length - 1;
  }

  return isMiniApp || breadcrumbList.length === 0 || breadcrumbList.length === 1 && breadcrumbList[0].url == "/" ? "" : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Nav, {
    className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-wrapper"])),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ol", {
      className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-list"])),
      children: handleBreadCrumbMobile(breadcrumbList).map(function (bcrumb, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
          className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-item"])),
          id: "".concat(index, "_").concat(bcrumb.title),
          children: lastItem !== index && bcrumb.url ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
            id: "".concat(index, "_").concat(bcrumb.replacePageTitle ? bcrumb.replacedTitle : bcrumb.title),
            onClick: function onClick() {
              return handleClick(bcrumb.url);
            },
            children: ["                    ", bcrumb.replacePageTitle ? bcrumb.replacedTitle : bcrumb.title]
          }) : bcrumb.replacePageTitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            id: "".concat(index, "_").concat(bcrumb.replacedTitle),
            children: bcrumb.replacedTitle
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            id: "".concat(index, "_").concat(bcrumb.title),
            children: bcrumb.title
          })
        }, index);
      })
    })
  });
};

BreadCrumb.defaultProps = {
  list: null,
  title: "",
  replacePageTitle: false
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 42130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56209);
/* harmony import */ var _upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79549);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var UpgradeCheckBar = function UpgradeCheckBar(props) {
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].imagePrefix;
  var imgUrl = props.btnLabel ? "".concat(imagePrefix, "/assets/images/upgrade-info.svg") : "".concat(imagePrefix, "/assets/images/success-circle-2.svg");
  var imgSize = 30;

  var renderType = function renderType() {
    switch (props.type) {
      case "info":
        return (_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["upgrade-check-bar-info"]);

      default:
        return (_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["upgrade-check-bar-success"]);
    }
  };

  var bannerTypeClass = renderType();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: "d-flex ".concat((_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["upgrade-check-bar"]), " ").concat(bannerTypeClass, " ").concat(props.className ? " " + props.className : ""),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "d-flex",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
        src: imgUrl,
        width: imgSize,
        height: imgSize
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        className: "".concat((_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default().message)),
        children: props.message
      })]
    }), props.btnLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_1__["default"], {
      className: "".concat((_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ctaBtn), " p-0"),
      variant: "link white",
      handleClick: props.btnHandler,
      id: props.id,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        className: "d-none d-md-inline-block",
        children: props.btnLabel
      })
    })]
  });
};

UpgradeCheckBar.defaultProps = {
  className: "",
  type: "success"
};
/* harmony default export */ __webpack_exports__["Z"] = (UpgradeCheckBar);

/***/ }),

/***/ 29567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _upgradeInfoBar_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44472);
/* harmony import */ var _upgradeInfoBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_upgradeInfoBar_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79549);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var UpgradeInfoBar = function UpgradeInfoBar(props) {
  var imgSize = 17.5;
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .componentResize */ .Y4)();

  var renderType = function renderType() {
    switch (props.type) {
      case "info":
        return (_upgradeInfoBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["upgrade-check-bar-info"]);

      default:
        return (_upgradeInfoBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["upgrade-check-bar-success"]);
    }
  };

  var bannerTypeClass = renderType();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: "d-flex ".concat((_upgradeInfoBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["upgrade-check-bar"]), " ").concat(bannerTypeClass, " ").concat(props.className ? " " + props.className : ""),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "d-flex",
      children: [!isMobile && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: imgSize,
        height: imgSize,
        fill: "none",
        viewBox: "0 0 40 41",
        className: (_upgradeInfoBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["info-img"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M36.634 20.5c0 9.187-7.447 16.634-16.634 16.634-9.186 0-16.633-7.447-16.633-16.634 0-9.186 7.447-16.633 16.633-16.633 9.187 0 16.634 7.447 16.634 16.633zM21.2 13.21c0 .893-.724 1.617-1.617 1.617s-1.617-.724-1.617-1.617.724-1.617 1.617-1.617 1.617.724 1.617 1.617zM18.8 26.8v-7.6h-.467c-.663 0-1.2-.537-1.2-1.2 0-.662.537-1.2 1.2-1.2H20c.663 0 1.2.538 1.2 1.2v8.8h.467c.663 0 1.2.538 1.2 1.2 0 .663-.537 1.2-1.2 1.2h-3.333c-.663 0-1.2-.537-1.2-1.2 0-.662.537-1.2 1.2-1.2h.466z",
          clipRule: "evenodd"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("mask", {
          id: "nauuhkizpa",
          width: "34",
          height: "35",
          x: "3",
          y: "3",
          maskUnits: "userSpaceOnUse",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M36.634 20.5c0 9.187-7.447 16.634-16.634 16.634-9.186 0-16.633-7.447-16.633-16.634 0-9.186 7.447-16.633 16.633-16.633 9.187 0 16.634 7.447 16.634 16.633zM21.2 13.21c0 .893-.724 1.617-1.617 1.617s-1.617-.724-1.617-1.617.724-1.617 1.617-1.617 1.617.724 1.617 1.617zM18.8 26.8v-7.6h-.467c-.663 0-1.2-.537-1.2-1.2 0-.662.537-1.2 1.2-1.2H20c.663 0 1.2.538 1.2 1.2v8.8h.467c.663 0 1.2.538 1.2 1.2 0 .663-.537 1.2-1.2 1.2h-3.333c-.663 0-1.2-.537-1.2-1.2 0-.662.537-1.2 1.2-1.2h.466z",
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
          mask: "url(#nauuhkizpa)",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
            fill: "#ffffff",
            d: "M0 0.5H40V40.5H0z"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        className: "".concat((_upgradeInfoBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default().message)),
        children: props.message
      })]
    }), props.btnLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_0__["default"], {
      className: "".concat((_upgradeInfoBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ctaBtn)),
      variant: "link white",
      handleClick: props.btnHandler,
      id: props.id,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        className: "d-sm-inline-block d-md-none d-lg-none",
        children: props.btnLabel
      })
    })]
  });
};

UpgradeInfoBar.defaultProps = {
  className: "",
  type: "success"
};
/* harmony default export */ __webpack_exports__["Z"] = (UpgradeInfoBar);

/***/ }),

/***/ 76035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41898);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99599);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








var ButtonGroup = function ButtonGroup(props) {
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_4___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_4___default().envConfigs)[env].imagePrefix;
  var toggleVal = props.filterType ? props.filterType : "filter";

  var generateImageUrl = function generateImageUrl() {
    switch (props.filterType) {
      case "filter":
        return "".concat(imagePrefix, "/assets/images/filter.svg");

      case "search":
        return "".concat(imagePrefix, "/assets/images/search.svg");

      default:
        return "".concat(imagePrefix, "/assets/images/filter.svg");
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash),
    children: [props.hide ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "hide",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "d-block d-lg-none",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("button", {
          onClick: function onClick() {
            return props.toggleComps(toggleVal);
          },
          className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "left-btn",
          children: "Filter"
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("button", {
          onClick: function onClick() {
            return props.toggleComps(toggleVal);
          },
          id: "".concat(_config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_filter_products */ .Z.lbl_filter_products, "-fiter-arrow"),
          className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "filters-mobile-button ".concat(props.noShadow ? "no-shadow" : "", " left-btn-md pl-0"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
            src: generateImageUrl(),
            alt: "filter",
            className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "button-image"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("span", {
            className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "button-label",
            children: [" ", props.buttonLabel ? props.buttonLabel : _config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_filter_products */ .Z.lbl_filter_products]
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: _ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash,
      children: _ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle */ .Y
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ButtonGroup);

/***/ }),

/***/ 41898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ButtonGroupStyle; }
/* harmony export */ });
/* harmony import */ var _config_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93957);
/* harmony import */ var _config_fonts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78198);


var ButtonGroupStyle = [".left-btn.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].bold */ .Z.bold, " !important;font-weight:500;font-size:1rem;float:left;width:50%;border:solid 0.6px ").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey20 */ .Z.Grey20, ";height:50px;text-align:center;background-color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].White0 */ .Z.White0, ";}"), ".right-btn.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].bold */ .Z.bold, " !important;font-weight:700;font-size:1rem;float:right;border:solid 0.6px ").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey20 */ .Z.Grey20, ";border-left:none;width:50%;height:50px;text-align:center;background-color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].White0 */ .Z.White0, ";}"), ".left-btn-md.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].medium */ .Z.medium, " !important;font-weight:700;font-size:1rem;float:left;padding-left:1rem;width:48%;box-shadow:0 0.5rem 1rem 0 rgba(0,0,0,0.2);border:solid 0.6px ").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey20 */ .Z.Grey20, ";height:3.125rem;text-align:left;background-color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].White0 */ .Z.White0, ";border-radius:4px;padding-right:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}"), ".right-btn-md.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].medium */ .Z.medium, " !important;font-weight:700;font-size:1rem;padding-left:1rem;float:right;box-shadow:0 0.5rem 1rem 0 rgba(0,0,0,0.2);border:solid 0.6px ").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey20 */ .Z.Grey20, ";min-width:48%;height:3.125rem;text-align:left;background-color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].White0 */ .Z.White0, ";border-radius:4px;padding-right:0;}"), ".right-arrow.jsx-2226485967{margin-top:0.4rem;width:0.6875rem;height:0.6875rem;float:right;margin-right:0.9375rem;}", ".button-text.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].regular */ .Z.regular, ";font-weight:400;color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey70 */ .Z.Grey70, ";}"), ".button-image.jsx-2226485967{width:1.1875rem;height:1.1875rem;}", ".button-label.jsx-2226485967{color:".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Black40 */ .Z.Black40, ";font-family:").concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].medium */ .Z.medium, ";font-size:1rem;font-weight:500;margin:0 0.3rem 0 0.5rem;}"), ".button-grid-gutter.jsx-2226485967{margin-left:-1rem !important;margin-right:-1rem !important;}", ".no-shadow.jsx-2226485967{box-shadow:none;border-color:".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Black40 */ .Z.Black40, ";padding-left:0rem;text-align:center;}"), "@media screen and (max-width:576px){.left-btn-md.jsx-2226485967,.right-btn-md.jsx-2226485967{width:100%;float:none;text-align:center;}.right-btn-md.jsx-2226485967{margin-top:0.5rem;}}", "@media screen and (max-width:320px){.right-arrow.jsx-2226485967{padding-right:0;}}", "@media screen and (min-width:768px){.right-btn-md.jsx-2226485967,.left-btn-md.jsx-2226485967{width:21.75rem;}}"];
ButtonGroupStyle.__hash = "2226485967";

/***/ }),

/***/ 19312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64036);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _atoms_slider_Slider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30832);
/* harmony import */ var _filterItems_FilterItems__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67629);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58223);
/* harmony import */ var _DealSliderFilter_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40658);
/* harmony import */ var _DealSliderFilter_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_DealSliderFilter_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var DealSliderFilter = function DealSliderFilter(props) {
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .componentResize */ .Y4)();
  var isTablet = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .componentCheckSize */ .Qj)() <= 992;
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_1___default().envConfigs)[(_config_index__WEBPACK_IMPORTED_MODULE_1___default().env)].imagePrefix;
  var infoIconPath = "".concat(imagePrefix, "/assets/images/icon-info-grey.svg");

  var onSliderChange = function onSliderChange(value) {
    if (props.type === "price") {
      props.selectPrice(value);
    }

    if (props.type === "budget") {
      props.handlePrice(value);
    }

    if (props.type === "data" || props.type === "datavmairtime") {
      props.selectData(value);
    }

    if (props.type === "airtime") {
      props.selectAirTime(value);
    }

    if (props.type === "vm") {
      props.selectVoiceMinutes(value);
    }
  };

  var displayDataVmAirtime = function displayDataVmAirtime() {
    var str = "";

    if (props !== null && props !== void 0 && props.dispalyDataValue) {
      str += "".concat(props.min, "GB-").concat(props.max, "GB");
    }

    if (props !== null && props !== void 0 && props.dispalyVmValue) {
      var rightLabel = props.maxVm == props.maxValueVm ? "Unlimited" : "".concat(props.maxVm, "min");
      str += str !== "" ? " / ".concat(props.minVm, "min-").concat(rightLabel) : "".concat(props.minVm, "min-").concat(rightLabel);
    }

    if (props !== null && props !== void 0 && props.dispalyAirtimeValue) {
      str += str !== "" ? " / R".concat(props.minAir, "-R").concat(props.maxAir) : "R".concat(props.minAir, "-R").concat(props.maxAir);
    }

    return str;
  };

  var handleDisplayValue = function handleDisplayValue(type) {
    var maxVm = "Unlimited";
    var maxAirtime = _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_AIRTIME */ .Vr;

    if ((type == "vm" || type == "Voice") && props.max == props.maxValue) {
      return "".concat(props.min, "min-").concat(maxVm);
    } else {
      maxVm = props.max;
    }

    if (type == "airtime" && props.max == props.maxValue) {
      return "R".concat(props.min, "-R").concat(maxAirtime);
    } else {
      maxAirtime = props.max;
    }

    switch (type) {
      case "data":
        return "".concat(props.min, "GB-").concat(props.max, "GB");

      case "vm":
        return "".concat(props.min, "min-").concat(maxVm, "min");

      case "airtime":
        return "R".concat(props.min, "-R").concat(maxAirtime);

      case "datavmairtime":
        return displayDataVmAirtime();

      default:
        return "R".concat(props.min, " PM - R").concat(props.max, " PM");
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    children: [isMobile || isTablet ? null : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
      className: props.heading ? (_DealSliderFilter_module_scss__WEBPACK_IMPORTED_MODULE_6___default().priceHeading) : "",
      children: props.heading
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: props.isDealSelectionPage ? (_DealSliderFilter_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hideSliderDeal) : (_DealSliderFilter_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hideSlider),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_slider_Slider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        min: Math.round(props.min),
        max: Math.round(props.max),
        minValue: Math.round(props.minValue),
        maxValue: Math.round(props.maxValue),
        sliderChange: onSliderChange,
        sliderType: props.type,
        valueRange: props.valueRange,
        missingValueRange: props.missingValueRange,
        step: 1,
        label1: props.type == "price" || props.type == "budget" ? "R" : props.type == "airtime" ? "R" : "",
        label2: "",
        rightLabel: props.type == "price" || props.type == "budget" ? "PM" : props.type == "data" ? "GB" : props.type == "vm" ? "min" : props.type == "airtime" ? "" : "",
        unlimited: props.type === "vm" || props.sliderType === "vm" || props.type === "Voice"
      })
    }), props.type !== "budget" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_filterItems_FilterItems__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      heading: props.heading,
      handleClick: props.price,
      id: (props === null || props === void 0 ? void 0 : props.displaySlider) == true && props.type ? "filtered_".concat(props.type) : null,
      renderFun: handleDisplayValue(props.type)
    }) : "", props.showQualifyDeals && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: (_DealSliderFilter_module_scss__WEBPACK_IMPORTED_MODULE_6___default().info),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
        src: infoIconPath,
        className: (_DealSliderFilter_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["info-icon"])
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("label", {
        className: (_DealSliderFilter_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["info-label"]),
        children: props.qualifyLabel
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DealSliderFilter);

/***/ }),

/***/ 52441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90609);
/* harmony import */ var _ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69152);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var ErrorCard = function ErrorCard(_ref) {
  var errorMsg = _ref.errorMsg,
      fullWidth = _ref.fullWidth;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].imagePrefix;
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (errorMsg) {
      if (fullWidth === 1) {
        var heading = errorMsg.heading ? errorMsg.heading + ". " : "";
        var subHeading1 = errorMsg.subHeading1 ? errorMsg.subHeading1 + ". " : "";
        var subHeading2 = errorMsg.subHeading2 ? errorMsg.subHeading2 + ". " : "";
        _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU("".concat(heading).concat(subHeading1).concat(subHeading2));
      } else {
        _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU(errorMsg);
      }
    }
  }, []);

  var errorBlock = function errorBlock() {
    switch (fullWidth) {
      case 1:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/close-black-icon.svg"),
            width: 66,
            height: 66
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card__heading"]),
            children: errorMsg && errorMsg.heading ? errorMsg.heading : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card__subheading"]),
            children: errorMsg && errorMsg.subHeading1 ? errorMsg.subHeading1 : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card__subheading"]),
            children: errorMsg && errorMsg.subHeading2 ? errorMsg.subHeading2 : ''
          })]
        });

      default:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card-block"]),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card-image"]),
            xs: 1,
            md: 1,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: "".concat(imagePrefix, "/assets/images/close-black-icon.svg"),
              width: 27,
              height: 27
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-sub-text"]),
            xs: 11,
            md: 11,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              children: errorMsg ? errorMsg : ''
            })
          })]
        });
    }
  };

  return errorBlock();
};

/* harmony default export */ __webpack_exports__["Z"] = (ErrorCard);

/***/ }),

/***/ 59564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _productRange_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67161);
/* harmony import */ var _productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _services_filterService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75887);
/* harmony import */ var _services_filterDealService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var ProductRangeContainer = function ProductRangeContainer(props) {
  var _props$selectedFilter, _props$selectedFilter2, _props$selectedFilter3, _props$selectedFilter8, _props$selectedFilter9, _props$categoryList;

  var heading = props.heading ? props.heading : "Explore our product range";
  var newCategoryList = props === null || props === void 0 ? void 0 : props.categoryList;

  var getSortOrder = function getSortOrder(position) {
    return function (a, b) {
      if (a[position] > b[position]) {
        return 1;
      } else if (a[position] < b[position]) {
        return -1;
      }

      return 0;
    };
  };

  newCategoryList === null || newCategoryList === void 0 ? void 0 : newCategoryList.sort(getSortOrder("position"));
  var defaultSelectedValue = props !== null && props !== void 0 && (_props$selectedFilter = props.selectedFilter) !== null && _props$selectedFilter !== void 0 && _props$selectedFilter.selectedProductRange ? props.selectedFilter.selectedProductRange : props !== null && props !== void 0 && (_props$selectedFilter2 = props.selectedFilter) !== null && _props$selectedFilter2 !== void 0 && _props$selectedFilter2.selectedCategory ? props === null || props === void 0 ? void 0 : (_props$selectedFilter3 = props.selectedFilter) === null || _props$selectedFilter3 === void 0 ? void 0 : _props$selectedFilter3.selectedCategory : null;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.emptyCategories ? null : defaultSelectedValue),
      selectedProductID = _useState[0],
      setSelectedProduct = _useState[1];

  var filterByRange = /*#__PURE__*/function () {
    var _ref = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(selectedProductID) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!props.page) {
                _context.next = 9;
                break;
              }

              _context.t0 = props.page;
              _context.next = _context.t0 === "deal-grid" ? 4 : _context.t0 === "buy-bundle" ? 5 : 7;
              break;

            case 4:
              return _context.abrupt("return", (0,_services_filterDealService__WEBPACK_IMPORTED_MODULE_3__/* .getDealFilterByRange */ .fC)(selectedProductID));

            case 5:
              props.setBundleData(selectedProductID ? selectedProductID : "All");
              return _context.abrupt("break", 7);

            case 7:
              _context.next = 10;
              break;

            case 9:
              return _context.abrupt("return", (0,_services_filterService__WEBPACK_IMPORTED_MODULE_2__/* .getProductsFilterByRange */ .uF)(selectedProductID));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function filterByRange(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleProductSelect = function handleProductSelect(productID) {
    if (selectedProductID != productID) {
      setSelectedProduct(selectedProductID = productID);
    } else {
      setSelectedProduct(selectedProductID = null);
    }

    filterByRange(selectedProductID);
    props.handleSelected(productID);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _props$selectedFilter4, _props$selectedFilter6;

    if (props !== null && props !== void 0 && (_props$selectedFilter4 = props.selectedFilter) !== null && _props$selectedFilter4 !== void 0 && _props$selectedFilter4.selectedProductRange) {
      var _props$selectedFilter5;

      setSelectedProduct(Number(props === null || props === void 0 ? void 0 : (_props$selectedFilter5 = props.selectedFilter) === null || _props$selectedFilter5 === void 0 ? void 0 : _props$selectedFilter5.selectedProductRange));
    } else if (props !== null && props !== void 0 && (_props$selectedFilter6 = props.selectedFilter) !== null && _props$selectedFilter6 !== void 0 && _props$selectedFilter6.selectedCategory) {
      var _props$selectedFilter7;

      setSelectedProduct(Number(props === null || props === void 0 ? void 0 : (_props$selectedFilter7 = props.selectedFilter) === null || _props$selectedFilter7 === void 0 ? void 0 : _props$selectedFilter7.selectedCategory));
    } else if (props.emptyCategories) {
      setSelectedProduct(null);
    } else {
      setSelectedProduct(null);
    }
  }, [(props === null || props === void 0 ? void 0 : (_props$selectedFilter8 = props.selectedFilter) === null || _props$selectedFilter8 === void 0 ? void 0 : _props$selectedFilter8.selectedProductRange) || (props === null || props === void 0 ? void 0 : (_props$selectedFilter9 = props.selectedFilter) === null || _props$selectedFilter9 === void 0 ? void 0 : _props$selectedFilter9.selectedCategory)]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: "".concat(props.hide ? (_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hide) : (_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["product-range-container"]), " ").concat(props.customClassName),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
      className: (_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["product-section-title"]),
      id: "product_range_header",
      children: heading
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "".concat((_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["product-card-container"]), " ").concat(props.customcardClassName),
      children: props === null || props === void 0 ? void 0 : (_props$categoryList = props.categoryList) === null || _props$categoryList === void 0 ? void 0 : _props$categoryList.map(function (product) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          id: product.id,
          onClick: function onClick() {
            handleProductSelect(product.id);
          },
          className: "".concat((_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["product-range-card"]), " ").concat(Number(product.id) === Number(selectedProductID) ? (_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["product-range-card-selected"]) : ""),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            className: (_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["product-card-body-icon"]),
            children: !selectedProductID || Number(product.id) !== Number(selectedProductID) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              className: (_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image),
              src: product.imageUrl,
              alt: "Category"
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              className: (_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image),
              src: product.imageUrl,
              alt: "Category"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "".concat((_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["product-card-label"]), " \n\t\t\t\t\t\t").concat(product.name != "Phones & SIM" ? (_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["productlabel-card-styling"]) : "", " "),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              id: product.name,
              className: "".concat(Number(product.id) === Number(selectedProductID) ? (_productRange_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["product-card-label-selected"]) : ""),
              children: product.name
            })
          })]
        }, product.id);
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ProductRangeContainer);

/***/ }),

/***/ 3304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _atoms_checkBox_Checkbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51707);
/* harmony import */ var _AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41708);
/* harmony import */ var _AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var AffordabilityFilterToggle = function AffordabilityFilterToggle(props) {
  var handleCheck = function handleCheck(flag) {
    props.handleCheck(flag);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
    className: props.boxClass ? props.boxClass : (_AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["wrapper-checkbox"]),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_checkBox_Checkbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      isChecked: props.check,
      id: props.id,
      check: props.checkboxLabel,
      count: "0",
      isBrand: "false",
      handleCheck: handleCheck,
      checkBoxLabelStyling: "brandLabelStyling"
    }), props.check && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["item-label"]),
      children: props.checkboxSubtext
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AffordabilityFilterToggle);

/***/ }),

/***/ 11275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var _BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78626);
/* harmony import */ var _BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var BrowseContainer = function BrowseContainer(props) {
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .componentResize */ .Y4)();
  var tabletSize = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .componentCheckSize */ .Qj)();
  var isTablet = tabletSize < 992 && !isMobile;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
    className: props.hide ? (_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hide) : (_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["browse-container"]),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
      className: "".concat(props === null || props === void 0 ? void 0 : props.containerStyling, " ").concat((_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["browse-bar"])),
      children: [isTablet && !props.selectionFlag && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
        className: "".concat(!props.selectionFlag ? '' : (_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default().line))
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "d-flex",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "".concat((_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["browse-heading"]), " mb-0\n\t\t\t\t\t\t").concat(props.heading != "Phones & SIM" ? (_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["browse-heading-styling"]) : ""),
          id: "browse-heading",
          children: props.heading
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
            className: "".concat((_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["filter-button-tablet"])),
            children: props.filterButton
          }), props.searchFilterButton && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
            className: "".concat((_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["filter-button-tablet"]), " ").concat((_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["search-filter-tablet"])),
            children: props.searchFilterButton
          })]
        })]
      }), !isTablet && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
        className: props.isDeal ? (_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["browse-deal-sub-heading"]) : (_BrowseContainer_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["browse-sub-heading"]),
        id: "filter-subheader",
        children: props.shortDescription
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BrowseContainer);

/***/ }),

/***/ 71030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ deals; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./config/types.js
var types = __webpack_require__(69842);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./services/filterDealService.js
var filterDealService = __webpack_require__(4945);
// EXTERNAL MODULE: ./services/filterService.js
var filterService = __webpack_require__(75887);
// EXTERNAL MODULE: ./services/productListService.js + 1 modules
var productListService = __webpack_require__(98776);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/organisms/BrowseContainer/BrowseContainer.jsx
var BrowseContainer = __webpack_require__(11275);
// EXTERNAL MODULE: ./Redux/actions/footerAction.js
var footerAction = __webpack_require__(55382);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./components/molecules/brands/Brands.jsx + 2 modules
var Brands = __webpack_require__(27130);
// EXTERNAL MODULE: ./components/molecules/Products/Products.jsx + 1 modules
var Products = __webpack_require__(10393);
// EXTERNAL MODULE: ./components/molecules/dealSliderFilter/DealSliderFilter.jsx
var DealSliderFilter = __webpack_require__(19312);
// EXTERNAL MODULE: ./components/molecules/filterNav/FilterNav.jsx + 1 modules
var FilterNav = __webpack_require__(71881);
// EXTERNAL MODULE: ./components/organisms/searchItemContainer/SearchItemContainer.jsx
var SearchItemContainer = __webpack_require__(89884);
// EXTERNAL MODULE: ./components/organisms/searchItemContainer/PromoMobile.jsx
var PromoMobile = __webpack_require__(15729);
// EXTERNAL MODULE: ./components/organisms/searchItemContainer/SearchItemContainer.module.scss
var SearchItemContainer_module = __webpack_require__(55636);
var SearchItemContainer_module_default = /*#__PURE__*/__webpack_require__.n(SearchItemContainer_module);
// EXTERNAL MODULE: ./components/atoms/buttonBox/ButtonBox.jsx
var ButtonBox = __webpack_require__(68986);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/searchItemContainer/contractTypeMobile.js









var ContractTypeMobile = function ContractTypeMobile(props) {
  var _props$contracttypes, _props$contracttypes$;

  var imagePrefix = (config_default()).envConfigs[(config_default()).env].imagePrefix;

  var _useState = (0,react.useState)(''),
      selectedContract = _useState[0],
      setSelectedContract = _useState[1];

  var _useState2 = (0,react.useState)({}),
      contractSelectMobile = _useState2[0],
      setContractSelectMobile = _useState2[1];

  var resetContractType = function resetContractType() {
    props.setSelectedFilter(props.tempSelectedFilter);
  };

  var handleBack = function handleBack() {
    resetContractType();
    props.hideContractType();
  };

  (0,react.useEffect)(function () {
    if (props !== null && props !== void 0 && props.filteredContractType && props !== null && props !== void 0 && props.filteredContractType[0].label) {
      setSelectedContract(props === null || props === void 0 ? void 0 : props.filteredContractType[0].label);
    } else {
      setSelectedContract('');
    }
  }, [props.filteredContractType]);

  var handleContractSelectMobileClick = function handleContractSelectMobileClick(flag, itemValue, itemLabel, item) {
    setContractSelectMobile({
      flag: flag,
      itemValue: itemValue,
      itemLabel: itemLabel
    });
    props.contracttypeClickHandler(true, item);
  };

  var getDescription = function getDescription(label) {
    for (var i = 0; i <= (props === null || props === void 0 ? void 0 : (_props$contractsList = props.contractsList) === null || _props$contractsList === void 0 ? void 0 : _props$contractsList.length); i++) {
      var _props$contractsList, _props$contractsList$;

      if ((props === null || props === void 0 ? void 0 : (_props$contractsList$ = props.contractsList[i]) === null || _props$contractsList$ === void 0 ? void 0 : _props$contractsList$.contract_type_option_label.toLowerCase()) === label.toLowerCase()) {
        var _props$contractsList$2;

        return props === null || props === void 0 ? void 0 : (_props$contractsList$2 = props.contractsList[i]) === null || _props$contractsList$2 === void 0 ? void 0 : _props$contractsList$2.contract_type_desc;
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SearchItemContainer_module_default()).navGutter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Contract type",
      backbtn: handleBack,
      resetClickHandler: props.resetClickHandler,
      selectedFilter: props.filteredContractType
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (SearchItemContainer_module_default())["contract-type"],
      children: (props === null || props === void 0 ? void 0 : props.contracttypes) && (props === null || props === void 0 ? void 0 : (_props$contracttypes = props.contracttypes) === null || _props$contracttypes === void 0 ? void 0 : (_props$contracttypes$ = _props$contracttypes.sort(function (a, b) {
        return a.value - b.value;
      })) === null || _props$contracttypes$ === void 0 ? void 0 : _props$contracttypes$.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((SearchItemContainer_module_default())["contract-type__modal"], "\n                              ").concat((SearchItemContainer_module_default())[item.label === selectedContract ? "contract-type__modal_bgColor" : ""]),
          id: "".concat(item.label),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return handleContractSelectMobileClick(true, item.value, item.label, item);
            },
            className: (SearchItemContainer_module_default())["contract-type__modal__label"],
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
                xs: 10,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (SearchItemContainer_module_default())["contract-type__modal__label__title"],
                  children: item.label
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (SearchItemContainer_module_default())["contract-type__modal__label__description"],
                  children: [" ", getDescription(item.label)]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                xs: 2,
                className: (SearchItemContainer_module_default())["contract-type__modal__label__success-icon"],
                children: item.value === contractSelectMobile.itemValue || item.label === selectedContract && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "".concat(imagePrefix, "/assets/images/good.svg"),
                  alt: "selected",
                  className: (SearchItemContainer_module_default())["check-mark"]
                })
              })]
            })
          })
        }, "contract_type_".concat(index));
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonBox/* default */.Z, {
      children: "Save Selection",
      className: (SearchItemContainer_module_default())["botton-box"],
      click: props.hideContractType
    })]
  });
};

/* harmony default export */ var contractTypeMobile = (ContractTypeMobile);
// EXTERNAL MODULE: ./components/molecules/boxContainer/BoxContainer.jsx
var BoxContainer = __webpack_require__(30751);
;// CONCATENATED MODULE: ./components/organisms/searchItemContainer/planTypeMobile.js








var PlanTypeMobile = function PlanTypeMobile(props) {
  var _props$selectedFilter;

  var resetPlan = function resetPlan() {
    props.setSelectedFilter(props.tempSelectedFilter);
  };

  var handleBack = function handleBack() {
    resetPlan();
    props.hidePlanType();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SearchItemContainer_module_default()).navGutter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Plan type",
      backbtn: handleBack,
      resetClickHandler: props.resetClickHandler,
      selectedFilter: (0,helperServices/* isArrayNotEmpty */.wh)(props === null || props === void 0 ? void 0 : (_props$selectedFilter = props.selectedFilter) === null || _props$selectedFilter === void 0 ? void 0 : _props$selectedFilter.plantypes)
    }), props.plantype.map(function (promo) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxContainer/* default */.Z, {
        boxHeading: promo.label,
        selected: props.isPlanTypeChecked(promo),
        selectHandler: function selectHandler(flag) {
          return props.plantypeClickHandler(flag, promo);
        }
      }, promo.label);
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonBox/* default */.Z, {
      children: "Save Selection",
      className: (SearchItemContainer_module_default())["botton-box"],
      click: props.hidePlanType
    })]
  });
};

/* harmony default export */ var planTypeMobile = (PlanTypeMobile);
;// CONCATENATED MODULE: ./components/organisms/searchItemContainer/planNameMobile.js








var PlanNameMobile = function PlanNameMobile(props) {
  var _props$selectedFilter;

  var resetPlanName = function resetPlanName() {
    props.setSelectedFilter(props.tempSelectedFilter);
  };

  var handleBack = function handleBack() {
    resetPlanName();
    props.hidePlanName();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SearchItemContainer_module_default()).navGutter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Plan name",
      backbtn: handleBack,
      resetClickHandler: props.resetClickHandler,
      selectedFilter: (0,helperServices/* isArrayNotEmpty */.wh)(props === null || props === void 0 ? void 0 : (_props$selectedFilter = props.selectedFilter) === null || _props$selectedFilter === void 0 ? void 0 : _props$selectedFilter.plannames)
    }), props.planname.map(function (promo) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxContainer/* default */.Z, {
        boxHeading: promo.label,
        selected: props.isPlanNameChecked(promo),
        selectHandler: function selectHandler(flag) {
          return props.plannameClickHandler(flag, promo);
        }
      }, promo.id);
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonBox/* default */.Z, {
      children: "Save Selection",
      className: (SearchItemContainer_module_default())["botton-box"],
      click: props.hidePlanName
    })]
  });
};

/* harmony default export */ var planNameMobile = (PlanNameMobile);
;// CONCATENATED MODULE: ./components/organisms/searchItemContainer/accessoriesMobile.js






var accessoriesMobile_SearchItemContainer = function SearchItemContainer(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SearchItemContainer_module_default()).navGutter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Accessories",
      backbtn: props.hideAccessories,
      resetClickHandler: props.resetClickHandler,
      selectedFilter: props.selectedFilter
    }), props.accessoriesMob.map(function (promo) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxContainer/* default */.Z, {
        boxHeading: promo.label,
        selected: props.isAccessoriesChecked(promo),
        selectHandler: function selectHandler(flag) {
          return props.accessoriesClickHandler(flag, promo);
        }
      }, promo.id);
    })]
  });
};

/* harmony default export */ var accessoriesMobile = (accessoriesMobile_SearchItemContainer);
;// CONCATENATED MODULE: ./components/organisms/searchItemContainer/contractDurationMobile.js








var contractDurationMobile = function contractDurationMobile(props) {
  var _props$selectedFilter;

  var resetContractDuration = function resetContractDuration() {
    props.setSelectedFilter(props.tempSelectedFilter);
  };

  var handleBack = function handleBack() {
    resetContractDuration();
    props.hideContractDuraiton();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SearchItemContainer_module_default()).navGutter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Contract duration",
      backbtn: handleBack,
      resetClickHandler: props.resetClickHandler,
      selectedFilter: (0,helperServices/* isArrayNotEmpty */.wh)(props === null || props === void 0 ? void 0 : (_props$selectedFilter = props.selectedFilter) === null || _props$selectedFilter === void 0 ? void 0 : _props$selectedFilter.contractduration)
    }), props.contarctDuraitonMob.map(function (promo) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxContainer/* default */.Z, {
        boxHeading: "".concat(promo.label, " months"),
        selected: props.isContractDurationChecked(promo),
        selectHandler: function selectHandler(flag) {
          return props.contractdurationClickHandler(flag, promo);
        }
      }, promo.id);
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonBox/* default */.Z, {
      children: "Save Selection",
      className: (SearchItemContainer_module_default())["botton-box"],
      click: props.hideContractDuraiton
    })]
  });
};

/* harmony default export */ var searchItemContainer_contractDurationMobile = (contractDurationMobile);
// EXTERNAL MODULE: ./components/molecules/categoryItems/Categories.jsx + 1 modules
var Categories = __webpack_require__(17082);
// EXTERNAL MODULE: ./components/molecules/priceFilterMobile/PriceFilterMobile.jsx
var PriceFilterMobile = __webpack_require__(84033);
// EXTERNAL MODULE: ./components/atoms/slider/Slider.js + 1 modules
var Slider = __webpack_require__(30832);
// EXTERNAL MODULE: ./components/organisms/searchItemContainer/PriceMobileItem.module.scss
var PriceMobileItem_module = __webpack_require__(86295);
var PriceMobileItem_module_default = /*#__PURE__*/__webpack_require__.n(PriceMobileItem_module);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
;// CONCATENATED MODULE: ./components/organisms/searchItemContainer/DataVmAirtimeMobileItem.jsx








var DataVmAirtimeMobileItem = function DataVmAirtimeMobileItem(props) {
  var onSliderChangeData = function onSliderChangeData(value) {
    props.selectDataMobile(value);
  };

  var onSliderChangeVoiceMin = function onSliderChangeVoiceMin(value) {
    props.selectVMMobile(value);
  };

  var onSliderChangeAirTime = function onSliderChangeAirTime(value) {
    props.selectAirtimeMob(value);
  };

  var resetData = function resetData() {
    props.setSelectedFilter(props.tempSelectedFilter);
  };

  var handleBack = function handleBack() {
    resetData();
    props.hideDataVmAirtime();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (PriceMobileItem_module_default()).navGutter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Monthly data / voice minutes / airtime",
      backbtn: handleBack,
      resetClickHandler: props.resetClickHandler,
      selectedFilter: props.selectedFilter
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (PriceMobileItem_module_default()).priceContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        children: "Data"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PriceMobileItem_module_default()).slider,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Slider/* default */.Z, {
          sliderChange: function sliderChange(value) {
            return onSliderChangeData(value);
          },
          label1: "",
          label2: "",
          minValue: props.minValue,
          maxValue: props.maxValue,
          min: props.min,
          max: props.max,
          rightLabel: "GB",
          sliderType: "data",
          step: 30
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (PriceMobileItem_module_default()).priceContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        children: "Voice minutes"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PriceMobileItem_module_default()).slider,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Slider/* default */.Z, {
          sliderChange: function sliderChange(value) {
            return onSliderChangeVoiceMin(value);
          },
          label1: "min",
          minValue: props.minValueVm,
          maxValue: props.maxValueVm,
          min: props.minVm,
          max: props.maxVm,
          rightLabel: "min",
          sliderType: "Voice",
          unlimited: true
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (PriceMobileItem_module_default()).priceContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        children: "Airtime"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PriceMobileItem_module_default()).slider,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Slider/* default */.Z, {
          sliderChange: function sliderChange(value) {
            return onSliderChangeAirTime(value);
          },
          label1: "R",
          minValue: props.minValueAir,
          maxValue: props.maxValueAir,
          min: props.minAir,
          max: props.maxAir,
          rightLabel: "",
          sliderType: "airtime"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonBox/* default */.Z, {
      children: "Save Selection",
      className: (PriceMobileItem_module_default())["botton-box"],
      click: props.hideDataVmAirtime
    })]
  });
};

/* harmony default export */ var searchItemContainer_DataVmAirtimeMobileItem = (DataVmAirtimeMobileItem);
;// CONCATENATED MODULE: ./components/organisms/searchItemContainer/VoiceMobileItem.jsx






var VoiceMobileItem = function VoiceMobileItem(props) {
  var onSliderChange = function onSliderChange(value) {
    props.selectVMMobile(value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (PriceMobileItem_module_default()).navGutter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Voice minutes",
      backbtn: props.hideVoiceMinutes,
      resetClickHandler: props.resetClickHandler,
      selectedFilter: props.selectedFilter
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PriceMobileItem_module_default()).priceContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PriceMobileItem_module_default()).slider,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Slider/* default */.Z, {
          sliderChange: function sliderChange(value) {
            return onSliderChange(value);
          },
          label1: "min",
          minValue: props.minValue,
          maxValue: props.maxValue,
          min: props.min,
          max: props.max,
          rightLabel: "min",
          sliderType: "Voice" || 0,
          unlimited: "vm"
        })
      })
    })]
  });
};

/* harmony default export */ var searchItemContainer_VoiceMobileItem = (VoiceMobileItem);
;// CONCATENATED MODULE: ./components/organisms/searchItemContainer/AirtimeMobileItem.jsx






var AirtimeMobileItem = function AirtimeMobileItem(props) {
  var onSliderChange = function onSliderChange(value) {
    props.selectAirtimeMobile(value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (PriceMobileItem_module_default()).navGutter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Airtime",
      backbtn: props.hideAirtimeMob,
      resetClickHandler: props.resetClickHandler,
      selectedFilter: props.selectedFilter
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PriceMobileItem_module_default()).priceContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PriceMobileItem_module_default()).slider,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Slider/* default */.Z, {
          sliderChange: function sliderChange(value) {
            return onSliderChange(value);
          },
          label1: "R",
          minValue: props.minValue,
          maxValue: props.maxValue,
          min: props.min,
          max: props.max,
          rightLabel: "",
          sliderType: "airtime"
        })
      })
    })]
  });
};

/* harmony default export */ var searchItemContainer_AirtimeMobileItem = (AirtimeMobileItem);
// EXTERNAL MODULE: ./components/molecules/promotions/Promotions.js + 2 modules
var Promotions = __webpack_require__(75672);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(77521);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/atoms/checkBox/Checkbox.js
var Checkbox = __webpack_require__(51707);
// EXTERNAL MODULE: ./config/colors.js
var colors = __webpack_require__(93957);
// EXTERNAL MODULE: ./config/fonts.js
var fonts = __webpack_require__(78198);
;// CONCATENATED MODULE: ./components/molecules/planType/PlanTypeStyle.js


var PromotionStyle = [".filter-heading.jsx-3873717935{font-family:".concat(fonts/* default.bold */.Z.bold, " !important;font-size:1.125rem;font-weight:700;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:").concat(colors/* default.Black40 */.Z.Black40, ";margin-bottom:1rem;}"), "@media screen and (max-width:576px){ul.jsx-3873717935{display:none;}.filter-heading.jsx-3873717935{display:inline-block;font-family:".concat(fonts/* default.medium */.Z.medium, " !important;font-size:1rem;font-weight:500;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:").concat(colors/* default.Grey70 */.Z.Grey70, ";margin-bottom:0;}}")];
PromotionStyle.__hash = "3873717935";
;// CONCATENATED MODULE: ./components/molecules/planType/PlanTypeItem.js







var PlanTypeItem = function PlanTypeItem(props) {
  var _props$filteredPlanTy, _props$filteredPlanTy2;

  var _useState = (0,react.useState)(false),
      check = _useState[0],
      setCheck = _useState[1];

  var handlePlanTypeCheck = function handlePlanTypeCheck(event) {
    var flag = event.target.checked;
    setCheck(flag);
    props.plantypeClickHandler(flag);
  };

  var checkFilteredPromotion = function checkFilteredPromotion() {
    return props.filteredPlanType.filter(function (brand) {
      return brand.value === props.plantype.value;
    }).length > 0 ? true : false;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "jsx-".concat(PromotionStyle.__hash) + " " + 'list',
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: "jsx-".concat(PromotionStyle.__hash),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
        isChecked: (props === null || props === void 0 ? void 0 : (_props$filteredPlanTy = props.filteredPlanType) === null || _props$filteredPlanTy === void 0 ? void 0 : _props$filteredPlanTy.length) > 0 ? checkFilteredPromotion() : (props === null || props === void 0 ? void 0 : (_props$filteredPlanTy2 = props.filteredPlanType) === null || _props$filteredPlanTy2 === void 0 ? void 0 : _props$filteredPlanTy2.length) === 0 ? false : check,
        id: "".concat(props.plantype.label),
        check: "".concat(props.plantype.label, " "),
        click: handlePlanTypeCheck
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: PromotionStyle.__hash,
      children: PromotionStyle
    })]
  });
};

/* harmony default export */ var planType_PlanTypeItem = (PlanTypeItem);
// EXTERNAL MODULE: ./components/molecules/filterItems/FilterItems.jsx + 1 modules
var FilterItems = __webpack_require__(67629);
;// CONCATENATED MODULE: ./components/molecules/planType/PlanType.js









var PlanType = function PlanType(props) {
  var _props$planType, _props$filteredPlanTy, _props$filteredPlanTy2;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "jsx-".concat(PromotionStyle.__hash) + " " + "customFilter d-none d-lg-block",
      children: [props.planType && props.planType.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "jsx-".concat(PromotionStyle.__hash) + " " + "filter-heading",
        children: "Plan type"
      }), props === null || props === void 0 ? void 0 : (_props$planType = props.planType) === null || _props$planType === void 0 ? void 0 : _props$planType.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(planType_PlanTypeItem, {
          plantype: item,
          filteredPlanType: props.filteredPlanType ? props.filteredPlanType : [],
          plantypeClickHandler: function plantypeClickHandler(flag) {
            return props.handlePlanTypeSelect(flag, item);
          }
        }, "plan-type-".concat(item.id, "-").concat(index));
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterItems/* default */.Z, {
      heading: "Plan Type",
      handleClick: props.plan,
      id: (props === null || props === void 0 ? void 0 : props.displayPlanType) == true && props !== null && props !== void 0 && (_props$filteredPlanTy = props.filteredPlanType) !== null && _props$filteredPlanTy !== void 0 && _props$filteredPlanTy.length ? "filtered_brands_".concat(props === null || props === void 0 ? void 0 : props.filteredPlanType) : null,
      renderFun: props === null || props === void 0 ? void 0 : (_props$filteredPlanTy2 = props.filteredPlanType) === null || _props$filteredPlanTy2 === void 0 ? void 0 : _props$filteredPlanTy2.map(function (brand) {
        return brand.label;
      }).join(", ")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: PromotionStyle.__hash,
      children: PromotionStyle
    })]
  });
};

/* harmony default export */ var planType_PlanType = (PlanType);
;// CONCATENATED MODULE: ./components/molecules/planName/PlanNameStyle.js


var PlanNameStyle_PromotionStyle = [".filter-heading.jsx-3956054666{font-family:".concat(fonts/* default.bold */.Z.bold, " !important;font-size:1.125rem;font-weight:700;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:").concat(colors/* default.Black40 */.Z.Black40, ";margin-bottom:1rem;}"), "@media screen and (max-width:576px){ul.jsx-3956054666{display:none;}.filter-heading.jsx-3956054666{display:inline-block;font-family:".concat(fonts/* default.medium */.Z.medium, " !important;font-size:1rem;font-weight:500;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:").concat(colors/* default.Grey70 */.Z.Grey70, ";margin-bottom:0;}}")];
PlanNameStyle_PromotionStyle.__hash = "3956054666";
;// CONCATENATED MODULE: ./components/molecules/planName/PlanNameItem.js







var PlanNameItem_PlanTypeItem = function PlanTypeItem(props) {
  var _props$filteredPlanNa, _props$filteredPlanNa2;

  var _useState = (0,react.useState)(false),
      check = _useState[0],
      setCheck = _useState[1];

  var handlePlanNameCheck = function handlePlanNameCheck(event) {
    var flag = event.target.checked;
    setCheck(flag);
    props.plannameClickHandler(flag);
  };

  var checkFilteredPlanName = function checkFilteredPlanName() {
    return props.filteredPlanName.filter(function (brand) {
      return brand.value === props.planname.value;
    }).length > 0 ? true : false;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "jsx-".concat(PlanNameStyle_PromotionStyle.__hash) + " " + 'list',
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: "jsx-".concat(PlanNameStyle_PromotionStyle.__hash),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
        isChecked: (props === null || props === void 0 ? void 0 : (_props$filteredPlanNa = props.filteredPlanName) === null || _props$filteredPlanNa === void 0 ? void 0 : _props$filteredPlanNa.length) > 0 ? checkFilteredPlanName() : (props === null || props === void 0 ? void 0 : (_props$filteredPlanNa2 = props.filteredPlanName) === null || _props$filteredPlanNa2 === void 0 ? void 0 : _props$filteredPlanNa2.length) === 0 ? false : check,
        id: "".concat(props.planname.label),
        check: "".concat(props.planname.label, " "),
        click: handlePlanNameCheck
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: PlanNameStyle_PromotionStyle.__hash,
      children: PlanNameStyle_PromotionStyle
    })]
  });
};

/* harmony default export */ var PlanNameItem = (PlanNameItem_PlanTypeItem);
;// CONCATENATED MODULE: ./components/molecules/planName/PlanName.js









var PlanName = function PlanName(props) {
  var _props$planName, _props$filteredPlanNa, _props$filteredPlanNa2;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [" ", /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "jsx-".concat(PlanNameStyle_PromotionStyle.__hash) + " " + "customFilter d-none d-lg-block",
      children: [" ", (props === null || props === void 0 ? void 0 : props.planName) && (props === null || props === void 0 ? void 0 : props.planName.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "jsx-".concat(PlanNameStyle_PromotionStyle.__hash) + " " + "filter-heading",
        children: "Plan name"
      }), " ", "        ", props === null || props === void 0 ? void 0 : (_props$planName = props.planName) === null || _props$planName === void 0 ? void 0 : _props$planName.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PlanNameItem, {
          planname: item,
          filteredPlanName: props.filteredPlanName ? props.filteredPlanName : [],
          plannameClickHandler: function plannameClickHandler(flag) {
            return props.handlePlannameSelect(flag, item);
          }
        }, "plan-name-".concat(item.id, "-").concat(index));
      }), " "]
    }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(FilterItems/* default */.Z, {
      heading: "Plan name",
      handleClick: props.planNames,
      id: (props === null || props === void 0 ? void 0 : props.displayPlanName) == true && props !== null && props !== void 0 && (_props$filteredPlanNa = props.filteredPlanName) !== null && _props$filteredPlanNa !== void 0 && _props$filteredPlanNa.length ? "filtered_brands_".concat(props === null || props === void 0 ? void 0 : props.filteredPlanName) : null,
      renderFun: props === null || props === void 0 ? void 0 : (_props$filteredPlanNa2 = props.filteredPlanName) === null || _props$filteredPlanNa2 === void 0 ? void 0 : _props$filteredPlanNa2.map(function (brand) {
        return brand.label;
      }).join(", ")
    }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: PlanNameStyle_PromotionStyle.__hash,
      children: PlanNameStyle_PromotionStyle
    }), " "]
  });
};

/* harmony default export */ var planName_PlanName = (PlanName);
;// CONCATENATED MODULE: ./components/molecules/accessories/AccessoriesStyle.js


var AccessoriesStyle = [".filter-heading.jsx-3873717935{font-family:".concat(fonts/* default.bold */.Z.bold, " !important;font-size:1.125rem;font-weight:700;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:").concat(colors/* default.Black40 */.Z.Black40, ";margin-bottom:1rem;}"), "@media screen and (max-width:576px){ul.jsx-3873717935{display:none;}.filter-heading.jsx-3873717935{display:inline-block;font-family:".concat(fonts/* default.medium */.Z.medium, " !important;font-size:1rem;font-weight:500;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:").concat(colors/* default.Grey70 */.Z.Grey70, ";margin-bottom:0;}}")];
AccessoriesStyle.__hash = "3873717935";
;// CONCATENATED MODULE: ./components/molecules/accessories/AccessoriesItem.js







var AccessoriesItem = function AccessoriesItem(props) {
  var _props$filteredAccess, _props$filteredAccess2;

  var _useState = (0,react.useState)(false),
      check = _useState[0],
      setCheck = _useState[1];

  var handleAccessoriesCheck = function handleAccessoriesCheck(event) {
    var flag = event.target.checked;
    setCheck(flag);
    props.accessoriesClickHandler(flag);
  };

  var checkFilteredAccessories = function checkFilteredAccessories() {
    return props.filteredAccessories.filter(function (brand) {
      return brand.label === props.accessories.label;
    }).length > 0 ? true : false;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "jsx-".concat(AccessoriesStyle.__hash) + " " + 'list',
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: "jsx-".concat(AccessoriesStyle.__hash),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
        isChecked: (props === null || props === void 0 ? void 0 : (_props$filteredAccess = props.filteredAccessories) === null || _props$filteredAccess === void 0 ? void 0 : _props$filteredAccess.length) > 0 ? checkFilteredAccessories() : (props === null || props === void 0 ? void 0 : (_props$filteredAccess2 = props.filteredAccessories) === null || _props$filteredAccess2 === void 0 ? void 0 : _props$filteredAccess2.length) === 0 ? false : check,
        id: "".concat(props.accessories.label),
        check: "".concat(props.accessories.label, " "),
        click: handleAccessoriesCheck
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: AccessoriesStyle.__hash,
      children: AccessoriesStyle
    })]
  });
};

/* harmony default export */ var accessories_AccessoriesItem = (AccessoriesItem);
;// CONCATENATED MODULE: ./components/molecules/accessories/Accessories.js









var Accessories = function Accessories(props) {
  var _props$accessoriesLis, _props$accessoriesLis2, _props$filteredAccess, _props$filteredAccess2;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "jsx-".concat(AccessoriesStyle.__hash) + " " + "customFilter d-none d-lg-block",
      children: [(props === null || props === void 0 ? void 0 : (_props$accessoriesLis = props.accessoriesList) === null || _props$accessoriesLis === void 0 ? void 0 : _props$accessoriesLis.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "jsx-".concat(AccessoriesStyle.__hash) + " " + "filter-heading",
        children: "Accessories"
      }) : "", props === null || props === void 0 ? void 0 : (_props$accessoriesLis2 = props.accessoriesList) === null || _props$accessoriesLis2 === void 0 ? void 0 : _props$accessoriesLis2.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(accessories_AccessoriesItem, {
          accessories: item,
          filteredAccessories: props.filteredAccessories ? props.filteredAccessories : [],
          accessoriesClickHandler: function accessoriesClickHandler(flag) {
            return props.handleAccessoriesSelect(flag, item);
          }
        }, "accessory_".concat(item.id, "_").concat(index));
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterItems/* default */.Z, {
      heading: "Accessories",
      handleClick: props.Accessories,
      id: (props === null || props === void 0 ? void 0 : props.displayAccessories) == true && props !== null && props !== void 0 && (_props$filteredAccess = props.filteredAccessories) !== null && _props$filteredAccess !== void 0 && _props$filteredAccess.length ? "filtered_brands_".concat(props === null || props === void 0 ? void 0 : props.filteredAccessories) : null,
      renderFun: props === null || props === void 0 ? void 0 : (_props$filteredAccess2 = props.filteredAccessories) === null || _props$filteredAccess2 === void 0 ? void 0 : _props$filteredAccess2.map(function (brand) {
        return brand.label;
      }).join(", ")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: AccessoriesStyle.__hash,
      children: AccessoriesStyle
    })]
  });
};

/* harmony default export */ var accessories_Accessories = (Accessories);
;// CONCATENATED MODULE: ./components/molecules/contractDuration/ContractDurationStyle.js


var ContractDurationStyle_PromotionStyle = [".filter-heading.jsx-2374427087{font-family:".concat(fonts/* default.bold */.Z.bold, " !important;font-size:1.125rem;font-weight:700;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:").concat(colors/* default.Black40 */.Z.Black40, ";margin-bottom:1rem;}"), "@media screen and (max-width:576px){ul.jsx-2374427087{display:none;}.filter-heading.jsx-2374427087{display:inline-block;font-family:".concat(fonts/* default.medium */.Z.medium, " !important;font-size:1rem;font-weight:500;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:").concat(colors/* default.Grey70 */.Z.Grey70, ";margin-bottom:0;}}")];
ContractDurationStyle_PromotionStyle.__hash = "2374427087";
;// CONCATENATED MODULE: ./components/molecules/contractDuration/ContractDurationItem.js







var ContractDurationItem = function ContractDurationItem(props) {
  var _props$filteredContra, _props$filteredContra2;

  var _useState = (0,react.useState)(false),
      check = _useState[0],
      setCheck = _useState[1];

  var handleContractDurationCheck = function handleContractDurationCheck(event) {
    var flag = event.target.checked;
    setCheck(flag);
    props.contractdurationClickHandler(flag);
  };

  var checkFilteredContractDuration = function checkFilteredContractDuration() {
    return props.filteredContractDuration.filter(function (brand) {
      return brand.label === props.contractduration.label;
    }).length > 0 ? true : false;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "jsx-".concat(ContractDurationStyle_PromotionStyle.__hash) + " " + 'list',
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: "jsx-".concat(ContractDurationStyle_PromotionStyle.__hash),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
        isChecked: (props === null || props === void 0 ? void 0 : (_props$filteredContra = props.filteredContractDuration) === null || _props$filteredContra === void 0 ? void 0 : _props$filteredContra.length) > 0 ? checkFilteredContractDuration() : (props === null || props === void 0 ? void 0 : (_props$filteredContra2 = props.filteredContractDuration) === null || _props$filteredContra2 === void 0 ? void 0 : _props$filteredContra2.length) === 0 ? false : check,
        id: "".concat(props.contractduration.label),
        check: "".concat(props.contractduration.label, " months "),
        click: handleContractDurationCheck
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: ContractDurationStyle_PromotionStyle.__hash,
      children: ContractDurationStyle_PromotionStyle
    })]
  });
};

/* harmony default export */ var contractDuration_ContractDurationItem = (ContractDurationItem);
;// CONCATENATED MODULE: ./components/molecules/contractDuration/ContractDuration.js









var ContractDuration = function ContractDuration(props) {
  var _props$contractdurati, _props$filteredContra, _props$filteredContra2;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "jsx-".concat(ContractDurationStyle_PromotionStyle.__hash) + " " + "customFilter d-none d-lg-block",
      children: [(props === null || props === void 0 ? void 0 : props.contractdurationList) && (props === null || props === void 0 ? void 0 : props.contractdurationList.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "jsx-".concat(ContractDurationStyle_PromotionStyle.__hash) + " " + "filter-heading",
        children: "Contract duration"
      }), "    ", props === null || props === void 0 ? void 0 : (_props$contractdurati = props.contractdurationList) === null || _props$contractdurati === void 0 ? void 0 : _props$contractdurati.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(contractDuration_ContractDurationItem, {
          contractduration: item,
          filteredContractDuration: props.filteredContractDuration ? props.filteredContractDuration : [],
          contractdurationClickHandler: function contractdurationClickHandler(flag) {
            return props.handleContratcDurationSelect(flag, item);
          }
        }, "contact-duration-".concat(item.id, "-").concat(index));
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterItems/* default */.Z, {
      heading: "Contract duration",
      handleClick: props.ContractDuration,
      id: (props === null || props === void 0 ? void 0 : props.displayContractDuration) == true && props !== null && props !== void 0 && (_props$filteredContra = props.filteredContractDuration) !== null && _props$filteredContra !== void 0 && _props$filteredContra.length ? "filtered_brands_".concat(props === null || props === void 0 ? void 0 : props.filteredContractDuration) : null,
      renderFun: props === null || props === void 0 ? void 0 : (_props$filteredContra2 = props.filteredContractDuration) === null || _props$filteredContra2 === void 0 ? void 0 : _props$filteredContra2.map(function (brand) {
        return brand.label;
      }).join(", ")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: ContractDurationStyle_PromotionStyle.__hash,
      children: ContractDurationStyle_PromotionStyle
    })]
  });
};

/* harmony default export */ var contractDuration_ContractDuration = (ContractDuration);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./components/atoms/toolTip/Tooltip.jsx
var Tooltip = __webpack_require__(7971);
// EXTERNAL MODULE: ./components/molecules/contractType/Contracttype.module.scss
var Contracttype_module = __webpack_require__(1157);
var Contracttype_module_default = /*#__PURE__*/__webpack_require__.n(Contracttype_module);
;// CONCATENATED MODULE: ./components/molecules/contractType/ContractType.js










var ContractType = function ContractType(props) {
  var _props$contractsList, _props$contracttypes2, _props$filteredContra, _props$filteredContra2;

  var selectedKeys = Object.keys(props === null || props === void 0 ? void 0 : props.selectedFilter);

  var _useState = (0,react.useState)(false),
      selectedRadio = _useState[0],
      setSelectedRadio = _useState[1];

  var _useState2 = (0,react.useState)(),
      selectedContract = _useState2[0],
      setSelectedContract = _useState2[1];

  var tooltips = props === null || props === void 0 ? void 0 : (_props$contractsList = props.contractsList) === null || _props$contractsList === void 0 ? void 0 : _props$contractsList.filter(function (data) {
    var _props$contracttypes;

    return props === null || props === void 0 ? void 0 : (_props$contracttypes = props.contracttypes) === null || _props$contracttypes === void 0 ? void 0 : _props$contracttypes.sort(function (a, b) {
      return a.value - b.value;
    }).some(function (item) {
      return data.contract_type_option_label === item.label;
    });
  });

  var onRadioChange = function onRadioChange(value) {
    setSelectedContract(value.label);
    setSelectedRadio(!selectedRadio);
    props.onContractTypeChange(true, value);
  }; // useEffect(() => {
  //   setSelectedContract(props?.filteredContractType ?
  //     props?.filteredContractType?.map(item => item.label)[0] : '');
  //   props?.contracttypes?.map((item) => {
  //     if (selectedContract == item.label) {
  //       document.getElementById(item.label).checked = true;
  //     }
  //     else {
  //       document.getElementById(item.label).checked = false;
  //     }
  //   })
  // }, [props.filteredContractType, selectedContract, props?.contracttypes])


  (0,react.useEffect)(function () {
    var _props$selectedFilter;

    if (selectedKeys.length === 1 && selectedKeys[0] === "updateFilterCriteria") {
      setSelectedContract('');
      return;
    }

    if (!selectedKeys.includes(labels/* default.lbl_contractType.toLowerCase */.Z.lbl_contractType.toLowerCase())) {
      setSelectedContract('');
      return;
    }

    if (props !== null && props !== void 0 && (_props$selectedFilter = props.selectedFilter) !== null && _props$selectedFilter !== void 0 && _props$selectedFilter.contracttype) {
      var _ref = props.selectedFilter.contracttype || [],
          _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
          contract = _ref2[0];

      setSelectedContract(contract && (contract === null || contract === void 0 ? void 0 : contract.label));
      setSelectedRadio(!!contract);
    }
  }, [props === null || props === void 0 ? void 0 : props.selectedFilter]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "d-none d-lg-block",
      children: [(props === null || props === void 0 ? void 0 : props.contracttypes) && (props === null || props === void 0 ? void 0 : props.contracttypes.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "d-flex align-items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (Contracttype_module_default()).priceHeading,
          children: "Contract type"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: tooltips === null || tooltips === void 0 ? void 0 : tooltips.map(function (data, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (Contracttype_module_default()).description,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "d-flex ".concat((Contracttype_module_default()).title),
                  children: data === null || data === void 0 ? void 0 : data.contract_type_option_label
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "d-flex",
                  children: data === null || data === void 0 ? void 0 : data.contract_type_desc
                })]
              }, "contract_type_".concat(data === null || data === void 0 ? void 0 : data.contract_type_option_label, "_").concat(index));
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Contracttype_module_default()).radiobtn,
        children: props === null || props === void 0 ? void 0 : (_props$contracttypes2 = props.contracttypes) === null || _props$contracttypes2 === void 0 ? void 0 : _props$contracttypes2.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Contracttype_module_default()).radiobtnDiv,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
              className: (Contracttype_module_default()).radio,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                type: "radio",
                id: "rb_contract_type_".concat(item.label),
                value: item.label,
                checked: selectedContract === item.label,
                onClick: function onClick() {
                  return onRadioChange(item);
                },
                onChange: function onChange() {}
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                htmlFor: "rb_contract_type_".concat(item.label),
                children: item.label
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})]
            })
          }, "radio_contract_type_".concat(index));
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterItems/* default */.Z, {
      heading: "Contract type",
      handleClick: props.toggleContractTypes,
      id: (props === null || props === void 0 ? void 0 : props.displayContractType) == true && props !== null && props !== void 0 && (_props$filteredContra = props.filteredContractType) !== null && _props$filteredContra !== void 0 && _props$filteredContra.length ? "filtered_contracts_".concat(props === null || props === void 0 ? void 0 : props.filteredContractType) : null,
      renderFun: props === null || props === void 0 ? void 0 : (_props$filteredContra2 = props.filteredContractType) === null || _props$filteredContra2 === void 0 ? void 0 : _props$filteredContra2.map(function (contract) {
        return contract.label;
      }).join(", ")
    })]
  });
};

/* harmony default export */ var contractType_ContractType = (ContractType);
// EXTERNAL MODULE: ./components/organisms/subCategoryMobileItem/SubCategoryMobileItem.jsx
var SubCategoryMobileItem = __webpack_require__(3364);
// EXTERNAL MODULE: ./components/organisms/dealGridSearchContainer/DealGridSearchContainer.module.scss
var DealGridSearchContainer_module = __webpack_require__(89392);
var DealGridSearchContainer_module_default = /*#__PURE__*/__webpack_require__.n(DealGridSearchContainer_module);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./services/breadcrumbService.js
var breadcrumbService = __webpack_require__(74425);
// EXTERNAL MODULE: ./components/organisms/ProductFilter/ProductFilter.module.scss
var ProductFilter_module = __webpack_require__(22700);
var ProductFilter_module_default = /*#__PURE__*/__webpack_require__.n(ProductFilter_module);
// EXTERNAL MODULE: ./components/molecules/SearchBoxAutoSuggest/SearchBoxAutoSuggest.module.scss
var SearchBoxAutoSuggest_module = __webpack_require__(60741);
var SearchBoxAutoSuggest_module_default = /*#__PURE__*/__webpack_require__.n(SearchBoxAutoSuggest_module);
;// CONCATENATED MODULE: ./components/molecules/SearchBoxAutoSuggest/SearchBoxAutoSuggest.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var SearchBoxAutoSuggest = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$closeRequired = _ref.closeRequired,
      closeRequired = _ref$closeRequired === void 0 ? true : _ref$closeRequired,
      className = _ref.className,
      inputStyle = _ref.inputStyle,
      handleKeydown = _ref.handleKeydown,
      handleSearchSelect = _ref.handleSearchSelect,
      handleSearchClick = _ref.handleSearchClick,
      handleSearchTextChange = _ref.handleSearchTextChange,
      focus = _ref.focus,
      handleFilterError = _ref.handleFilterError,
      showAffordabilityLabel = _ref.showAffordabilityLabel,
      qualifyLabel = _ref.qualifyLabel;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var inputAutoFocus = /*#__PURE__*/react.createRef();

  var _useState = (0,react.useState)(''),
      searchText = _useState[0],
      setSearchText = _useState[1];

  var _useState2 = (0,react.useState)([]),
      filteredOptions = _useState2[0],
      setFilteredOptions = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showOptions = _useState3[0],
      setShowOptions = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      optionSelected = _useState4[0],
      setOptionSelected = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      inputFocus = _useState5[0],
      setInputFocus = _useState5[1];

  var _useState6 = (0,react.useState)("default"),
      searchIcon = _useState6[0],
      setSearchIcon = _useState6[1];

  var optionSize = 8;
  var infoIconPath = "".concat(imagePrefix, "/assets/images/icon-info-grey.svg");
  var isMobile = (0,helperServices/* componentResize */.Y4)();
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 768;
  var analyticsTags = ["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"];
  var pageName = (0,analyticsUtag/* getUtagData */.GS)(["page_name"]).page_name;
  (0,react.useImperativeHandle)(ref, function () {
    return {
      clearText: function clearText() {
        setShowOptions(false);
        setSearchText("");
        handleSearchTextChange("");
        inputAutoFocus.current.focus();
      }
    };
  });
  (0,react.useEffect)(function () {
    var abortCtrl = new AbortController();
    var opts = abortCtrl.signal;

    if (searchText.length > 2 && !optionSelected) {
      debounceSearch(opts, searchText);
    } else {
      setShowOptions(false);
    }

    return function () {
      abortCtrl && abortCtrl.abort();
    };
  }, [searchText]);
  var debounceSearch = (0,react.useCallback)((0,helperServices/* debounce */.Ds)(function (signal, text) {
    fetchData(signal, text);
  }, 200), []);

  var fetchData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signal, text) {
      var currentItemCategory, productSearchList, newList;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              currentItemCategory = -1;
              _context.next = 4;
              return (0,productListService/* getProductSearchList */.qZ)(text, currentItemCategory, signal);

            case 4:
              productSearchList = _context.sent;
              newList = productSearchList.map(function (option) {
                return _objectSpread(_objectSpread({}, option), {}, {
                  value: option.sku,
                  label: option.name
                });
              });
              setFilteredOptions(newList);
              setShowOptions(true);
              handleFilterError(false);
              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              setShowOptions(false);
              handleFilterError(true);
              (0,analyticsUtag/* link */.p4)(_objectSpread({
                page_name: "".concat(pageName),
                page_form_event: "error",
                page_errors: labels/* default.errors.lbl_deals_filter_error */.Z.errors.lbl_deals_filter_error,
                page_error_type: "page"
              }, (0,analyticsUtag/* getUtagData */.GS)(analyticsTags)));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function fetchData(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleKeypress = function handleKeypress(e) {
    if (e.keyCode === 13) {
      var abortCtrl = new AbortController();
      var opts = abortCtrl.signal;
      debounceSearch(opts, searchText);
    }
  };

  var handleOnChange = function handleOnChange(e) {
    setSearchText(e.target.value);
    setOptionSelected(false);
    handleSearchTextChange(e.target.value);
  };

  var handleOptionClick = function handleOptionClick(e, option) {
    try {
      var _option$item, _option$item2;

      handleSearchSelect({
        value: option.value,
        label: option.label,
        brandSku: (option === null || option === void 0 ? void 0 : (_option$item = option.item) === null || _option$item === void 0 ? void 0 : _option$item.manufacturer) || "",
        brandName: (option === null || option === void 0 ? void 0 : (_option$item2 = option.item) === null || _option$item2 === void 0 ? void 0 : _option$item2.manufacturer_label) || ""
      }); //pass selected value to caller

      handleSearchTextChange(option.label);
      setShowOptions(false);
      setSearchText(option.label);
      setOptionSelected(true);
      inputAutoFocus.current.focus();
      (0,analyticsUtag/* link */.p4)(_objectSpread({
        page_name: "".concat(pageName),
        search_event: "search",
        search_terms: option.label,
        search_category: "product search",
        search_type: "suggested searches",
        search_results: filteredOptions.length
      }, (0,analyticsUtag/* getUtagData */.GS)(analyticsTags)));
      setFilteredOptions([]);
    } catch (err) {
      setShowOptions(false);
      handleFilterError(true);
      (0,analyticsUtag/* link */.p4)(_objectSpread({
        page_name: "".concat(pageName),
        page_form_event: "error",
        page_errors: labels/* default.errors.lbl_deals_filter_error */.Z.errors.lbl_deals_filter_error,
        page_error_type: "page"
      }, (0,analyticsUtag/* getUtagData */.GS)(analyticsTags)));
    }
  };

  var handleCancel = function handleCancel() {
    setShowOptions(false);
    setSearchText("");
    handleSearchTextChange("");
    inputAutoFocus.current.focus();
  };

  var truncateString = function truncateString(str, stringLen) {
    return str.length > stringLen ? str.substring(0, stringLen) + "..." : str;
  };

  var handleClick = function handleClick() {
    if (!inputFocus) {
      var _pageName = (0,analyticsUtag/* getUtagData */.GS)(["page_name"]).page_name;
      (0,analyticsUtag/* link */.p4)(_objectSpread({
        page_name: "".concat(_pageName),
        page_tool_name: "".concat(_pageName, ": search filter"),
        page_tool_use: "use"
      }, (0,analyticsUtag/* getUtagData */.GS)(analyticsTags)));
      setInputFocus(true);
    }
  };

  var handleLostFocus = function handleLostFocus() {
    setInputFocus(false);
    setSearchIcon("default");
  };

  var handleFocus = function handleFocus() {
    setSearchIcon("focused");
  };

  var defaultSearchIcon = /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0H18V18H0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "7.125",
        cy: "7.125",
        r: "5.25",
        stroke: "#666",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        stroke: "#666",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5",
        d: "M10.837 10.837L16.125 16.125"
      })]
    })
  });

  var focusSearchIcon = /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0H18V18H0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "7.125",
        cy: "7.125",
        r: "5.25",
        stroke: "#00b0ca",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        stroke: "#00b0ca",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5",
        d: "M10.837 10.837L16.125 16.125"
      })]
    })
  });

  var closeSvg = /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 30 30",
    onClick: handleCancel,
    className: (SearchBoxAutoSuggest_module_default()).img,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0H30V30H0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        fillRule: "nonzero",
        d: "M7.946 6.897l.084.073L15 13.939l6.97-6.97c.293-.292.767-.292 1.06 0 .267.267.29.684.073.977l-.073.084L16.061 15l6.97 6.97c.292.293.292.767 0 1.06-.267.267-.684.29-.977.073l-.084-.073L15 16.061l-6.97 6.97c-.293.292-.767.292-1.06 0-.267-.267-.29-.684-.073-.977l.073-.084L13.939 15l-6.97-6.97c-.292-.293-.292-.767 0-1.06.267-.267.684-.29.977-.073z"
      })]
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((SearchBoxAutoSuggest_module_default())["search-box-autosuggest-container"]),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((SearchBoxAutoSuggest_module_default())["search-box"], " ").concat(showOptions && searchText ? (SearchBoxAutoSuggest_module_default())["no-border-radius-bottom"] : '', " ").concat(className),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (SearchBoxAutoSuggest_module_default()).img,
        children: [searchIcon == "default" && defaultSearchIcon, searchIcon == "focused" && focusSearchIcon]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        ref: inputAutoFocus,
        type: "text",
        name: searchText,
        className: "".concat((SearchBoxAutoSuggest_module_default())["search-input"], " ").concat(inputStyle),
        onChange: handleOnChange,
        value: searchText,
        onKeyDown: handleKeypress,
        onFocus: handleFocus,
        id: "search-box-input",
        placeholder: isMobile || isTablet ? "" : "Type here to search",
        onClick: handleClick,
        onBlur: handleLostFocus
      }), closeRequired && closeSvg]
    }), showAffordabilityLabel && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SearchBoxAutoSuggest_module_default()).info,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: infoIconPath,
        className: (SearchBoxAutoSuggest_module_default())["info-icon"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        className: (SearchBoxAutoSuggest_module_default())["info-label"],
        children: qualifyLabel
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((SearchBoxAutoSuggest_module_default())["search-box-autosuggest-items-container"]),
      children: showOptions && /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "".concat((SearchBoxAutoSuggest_module_default()).menu, " ").concat((SearchBoxAutoSuggest_module_default())["no-border-radius-top"]),
        children: [filteredOptions && filteredOptions.length > 0 && filteredOptions.slice(0, optionSize).map(function (option) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "".concat((SearchBoxAutoSuggest_module_default())["menu-item"]),
            onClick: function onClick(e) {
              return handleOptionClick(e, option);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              dangerouslySetInnerHTML: {
                __html: truncateString(option.label.replace(option.label.match(new RegExp(searchText, 'gi')), '<strong>' + option.label.match(new RegExp(searchText, 'gi')) + '</strong>'), 60)
              }
            })
          }, option.value);
        }), filteredOptions.length == 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "".concat((SearchBoxAutoSuggest_module_default())["menu-item"], " ").concat((SearchBoxAutoSuggest_module_default())["no-result"]),
          children: "No results found"
        })]
      })
    })]
  });
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    hideNavItems: state.navDetails.hideNavItems
  };
};

/* harmony default export */ var SearchBoxAutoSuggest_SearchBoxAutoSuggest = ((0,DependencyHelper.connect)(mapStateToProps, {}, null, {
  forwardRef: true
})(SearchBoxAutoSuggest));
;// CONCATENATED MODULE: ./components/organisms/ProductFilter/ProductFilter.jsx








var ProductFilter = function ProductFilter(_ref) {
  var _ref$closeRequired = _ref.closeRequired,
      closeRequired = _ref$closeRequired === void 0 ? true : _ref$closeRequired,
      className = _ref.className,
      onSearchTextSelect = _ref.onSearchTextSelect,
      handleError = _ref.handleError,
      isEligible = _ref.isEligible,
      qualifyLabel = _ref.qualifyLabel,
      brands = _ref.brands;

  var _useState = (0,react.useState)(""),
      searchText = _useState[0],
      setSearchText = _useState[1];

  var _useState2 = (0,react.useState)({}),
      acceptedSearchText = _useState2[0],
      setAcceptedSearchText = _useState2[1];

  var searchBoxRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    if (searchText !== "" && searchText == acceptedSearchText.label) {
      onSearchTextSelect(true, acceptedSearchText);

      if (searchBoxRef.current && searchBoxRef.current.clearText) {
        searchBoxRef.current.clearText();
      }
    }
  }, [acceptedSearchText]);

  var handleSearchTextChange = function handleSearchTextChange(val) {
    setSearchText(val);
  };

  var handleSearchSelect = function handleSearchSelect(val) {
    var brandId = [];

    if (val.brandName) {
      brandId = brands.filter(function (brand) {
        return brand.label.toLowerCase().indexOf(val.brandName.toLowerCase()) > -1;
      });
    } else {
      val.brandName = "";
    }

    val['brandId'] = brandId.length > 0 ? brandId[0].value : "";
    setSearchText(val.label);
    setAcceptedSearchText(val);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((ProductFilter_module_default())["search-container"], " ").concat(className, " d-none d-lg-block"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "".concat((ProductFilter_module_default())["filter-heading"]),
        id: "filter-by-product-heading",
        children: "Filter by product"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchBoxAutoSuggest_SearchBoxAutoSuggest, {
        closeRequired: closeRequired,
        handleSearchSelect: handleSearchSelect,
        handleSearchTextChange: handleSearchTextChange,
        ref: searchBoxRef,
        handleFilterError: handleError,
        showAffordabilityLabel: isEligible,
        qualifyLabel: qualifyLabel
      })]
    })
  });
};

/* harmony default export */ var ProductFilter_ProductFilter = (ProductFilter);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
;// CONCATENATED MODULE: ./components/organisms/ProductFilter/ProductFilterMobile.jsx










var ProductFilterMobile = function ProductFilterMobile(_ref) {
  var _ref$closeRequired = _ref.closeRequired,
      closeRequired = _ref$closeRequired === void 0 ? true : _ref$closeRequired,
      className = _ref.className,
      hideFilter = _ref.hideFilter,
      resetClickHandler = _ref.resetClickHandler,
      onSearchTextSelect = _ref.onSearchTextSelect,
      handleError = _ref.handleError,
      isEligible = _ref.isEligible,
      qualifyLabel = _ref.qualifyLabel,
      selectedFilter = _ref.selectedFilter,
      brands = _ref.brands;

  var _useState = (0,react.useState)(true),
      disabled = _useState[0],
      setDisabled = _useState[1];

  var _useState2 = (0,react.useState)(""),
      searchText = _useState2[0],
      setSearchText = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      acceptedSearchText = _useState3[0],
      setAcceptedSearchText = _useState3[1];

  var searchBoxRef = (0,react.useRef)();
  var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;

  var handleSearchSelect = function handleSearchSelect(val) {
    var brandId = [];

    if (val.brandName) {
      brandId = brands.filter(function (brand) {
        return brand.label.toLowerCase().indexOf(val.brandName.toLowerCase()) > -1;
      });
    } else {
      val.brandName = "";
    }

    val["brandId"] = brandId.length > 0 ? brandId[0].value : "";
    setSearchText(val.label);
    setAcceptedSearchText(val);
    setDisabled(false);
  };

  var handleSearchTextChange = function handleSearchTextChange(val) {
    if (val.trim().length < 3) {
      setDisabled(true);
    }
  };

  var ctaButtonClick = function ctaButtonClick() {
    if (searchText !== "" && searchText == acceptedSearchText.label) {
      onSearchTextSelect(true, acceptedSearchText);

      if (searchBoxRef.current && searchBoxRef.current.clearText) {
        searchBoxRef.current.clearText();
      }
    }

    hideFilter();
  };

  var resetSearch = function resetSearch() {
    searchBoxRef.current.clearText();
    resetClickHandler();
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": reset search filter")
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((ProductFilter_module_default()).navGutter, " ").concat(className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Filter by product",
      backbtn: hideFilter,
      resetClickHandler: resetSearch,
      filterType: "filter_by_product",
      selectedFilter: selectedFilter
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((ProductFilter_module_default())["px-xxs-buffer"]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: "".concat((ProductFilter_module_default())["search-container"]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SearchBoxAutoSuggest_SearchBoxAutoSuggest, {
          closeRequired: closeRequired,
          className: "".concat((ProductFilter_module_default())["search-box"]),
          handleSearchSelect: handleSearchSelect,
          handleSearchTextChange: handleSearchTextChange,
          ref: searchBoxRef,
          handleFilterError: handleError,
          showAffordabilityLabel: isEligible,
          qualifyLabel: qualifyLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
          variant: "solid red",
          className: "".concat((ProductFilter_module_default()).showResultsBtn, " ").concat(disabled ? (ProductFilter_module_default()).disabled : ""),
          handleClick: ctaButtonClick,
          disabled: disabled,
          children: "Show results"
        })]
      })
    })]
  });
};

/* harmony default export */ var ProductFilter_ProductFilterMobile = (ProductFilterMobile);
// EXTERNAL MODULE: ./Redux/actions/navAction.js
var navAction = __webpack_require__(42220);
;// CONCATENATED MODULE: ./components/organisms/dealGridSearchContainer/DealGridSearchContainer.jsx


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function DealGridSearchContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DealGridSearchContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DealGridSearchContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DealGridSearchContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










































var DealGridSearchContainer = function DealGridSearchContainer(props) {
  var _props$priceValue, _props$priceValue2, _props$selectedCatego3, _props$selectedCatego4, _props$brands, _props$priceRange, _props$priceValue3, _props$priceValue4, _props$priceValue5, _props$promotions, _props$contracttype, _props$plantype, _props$promoValue$4, _props$promoValue$5, _props$vmValue$6, _props$vmValue$7, _props$airValue$5, _props$airValue$6, _props$promoValue$6, _props$promoValue$7, _props$vmValue$8, _props$vmValue$9, _props$airValue$7, _props$airValue$8, _props$promoValue3, _props$promoValue3$, _props$promoValue$8, _props$promoValue4, _props$promoValue4$, _props$promoValue$9, _props$vmValue5, _props$vmValue5$, _props$vmValue$10, _props$vmValue6, _props$vmValue6$, _props$vmValue$11, _props$airValue$9, _props$airValue$10, _props$contractdurati, _props$planname, _props$accessories, _props$priceValue6, _props$priceValue7, _props$priceValue8, _props$brands2, _props$promotions2, _props$promoValue5, _props$promoValue5$, _props$promoValue$10, _props$promoValue6, _props$promoValue6$, _props$promoValue$11, _props$vmValue7, _props$vmValue7$, _props$vmValue$12, _props$vmValue8, _props$vmValue8$, _props$vmValue$13, _props$airValue$11, _props$airValue$12, _props$accessories2;

  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < constants/* MOBILE_WIDTH */.P_;

  var _useState = (0,react.useState)(false),
      showBrand = _useState[0],
      setShowBrand = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showCate = _useState2[0],
      setShowCate = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showPrice = _useState3[0],
      setShowPrice = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showPromo = _useState4[0],
      setShowPromo = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      showContractType = _useState5[0],
      setShowContractType = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      showPlanType = _useState6[0],
      setshowPlanType = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      showPlanName = _useState7[0],
      setshowPlanName = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      showAccessories = _useState8[0],
      setshowAccessoories = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      showcontractDuration = _useState9[0],
      setshowContractDuration = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      showSubCategory = _useState10[0],
      setShowSubCategory = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      showData = _useState11[0],
      setShowData = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      showDataVmAirtime = _useState12[0],
      setShowDataVmAirtime = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      showVoiceMinutes = _useState13[0],
      setShowVoiceMinutes = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      showAirtime = _useState14[0],
      setShowAirtime = _useState14[1];

  var _useState15 = (0,react.useState)(false),
      showFilterByProduct = _useState15[0],
      setShowFilterByProduct = _useState15[1];

  var _useState16 = (0,react.useState)(""),
      selectedType = _useState16[0],
      setSelectedType = _useState16[1];

  var _useState17 = (0,react.useState)(false),
      isMounted = _useState17[0],
      setIsMounted = _useState17[1];

  var _useState18 = (0,react.useState)({
    originalSelectection: {},
    intermrdiateSelection: {}
  }),
      tempSelectedFilter = _useState18[0],
      setTempSelectedFilter = _useState18[1];

  (0,react.useEffect)(function () {
    props.displayHideFooter(props.hide);
  });
  (0,react.useEffect)(function () {
    setShowFilterByProduct(props.showProductFilter ? props.showProductFilter : false);
  }, [props.showProductFilter]);
  (0,react.useEffect)(function () {
    if (props.hide && (!showBrand || !showPromo || !showContractType || !showPlanType || !showcontractDuration || !showPlanName || !showDataVmAirtime)) {
      if (!isMounted) {
        setIsMounted(true);
        setTempSelectedFilter({
          originalSelectection: DealGridSearchContainer_objectSpread({}, props.selectedFilter),
          intermrdiateSelection: DealGridSearchContainer_objectSpread({}, props.selectedFilter)
        });
      } else {
        var originalValue = props.selectedFilter !== tempSelectedFilter.originalSelectection ? props.selectedFilter : tempSelectedFilter.originalSelectection;
        setTempSelectedFilter({
          originalSelectection: DealGridSearchContainer_objectSpread({}, originalValue),
          intermrdiateSelection: DealGridSearchContainer_objectSpread({}, props.selectedFilter)
        });
      }
    }
  }, [props.hide, showBrand, showPromo, showContractType, showPlanType, showcontractDuration, showPlanName, showDataVmAirtime]);

  var _handleCategorySelect = function handleCategorySelect(category) {
    props.onCategoryChange(category);
  };

  var selectPrice = function selectPrice(value) {
    props.onPriceChange(value);
  };

  var selectPriceMobile = function selectPriceMobile(value, type) {
    setSelectedType(type);
    props.onPriceChange(value, false);
  };

  var selectData = function selectData(value) {
    props.onDataChange(value);
  };

  var selectDataMobile = function selectDataMobile(value) {
    props.onDataChange(value, false);
  };

  var selectAirTime = function selectAirTime(value) {
    props.onAirTimeChange(value);
  };

  var selectAirTimeMobile = function selectAirTimeMobile(value) {
    props.onAirTimeChange(value, false);
  };

  var selectVoiceMinutes = function selectVoiceMinutes(value) {
    props.onVoiceMinutesChange(value);
  };

  var selectVoiceMinutesMobile = function selectVoiceMinutesMobile(value) {
    props.onVoiceMinutesChange(value, false);
  };

  var selectContractType = function selectContractType(flag, value) {
    hideContractTypes();
    props.onContractTypeChange(flag, value);
  };

  var selectSubCategoryChange = function selectSubCategoryChange(flag, value) {
    props.onSubCategoryChange(flag, value);
  };

  var allProductsClickHandler = function allProductsClickHandler() {
    props.onFilterReset();
  };

  var toggleBrand = function toggleBrand() {
    return setShowBrand(!showBrand);
  };

  var hideBrands = function hideBrands() {
    return setShowBrand(false);
  };

  var toggleCategory = function toggleCategory() {
    return setShowCate(!showCate);
  };

  var hideCategories = function hideCategories() {
    return setShowCate(false);
  };

  var togglePrice = function togglePrice() {
    return setShowPrice(!showPrice);
  };

  var hidePrice = function hidePrice() {
    return setShowPrice(false);
  };

  var toggleData = function toggleData() {
    return setShowData(!showData);
  };

  var toggleDataVmAirtime = function toggleDataVmAirtime() {
    return setShowDataVmAirtime(!showDataVmAirtime);
  };

  var hideDataVmAirtime = function hideDataVmAirtime() {
    return setShowDataVmAirtime(false);
  };

  var toggleVoiceMinutes = function toggleVoiceMinutes() {
    return setShowVoiceMinutes(!showVoiceMinutes);
  };

  var hideVoiceMinutes = function hideVoiceMinutes() {
    return setShowVoiceMinutes(false);
  };

  var toggleAirtime = function toggleAirtime() {
    return setShowAirtime(!showAirtime);
  };

  var hideAirtime = function hideAirtime() {
    return setShowAirtime(false);
  };

  var togglePromotions = function togglePromotions() {
    return setShowPromo(!showPromo);
  };

  var hidePromo = function hidePromo() {
    return setShowPromo(false);
  };

  var toggleContractTypes = function toggleContractTypes() {
    return setShowContractType(!showContractType);
  };

  var hideContractTypes = function hideContractTypes() {
    return setShowContractType(false);
  };

  var togglePlanTypes = function togglePlanTypes() {
    return setshowPlanType(!showPlanType);
  };

  var hidePlanType = function hidePlanType() {
    return setshowPlanType(false);
  };

  var togglePlanNames = function togglePlanNames() {
    return setshowPlanName(!showPlanName);
  };

  var hidePlanName = function hidePlanName() {
    return setshowPlanName(false);
  };

  var toggleAccessories = function toggleAccessories() {
    return setshowAccessoories(!showAccessories);
  };

  var hideAccessories = function hideAccessories() {
    return setshowAccessoories(false);
  };

  var toggleContractDuration = function toggleContractDuration() {
    return setshowContractDuration(!showcontractDuration);
  };

  var hideContractDuration = function hideContractDuration() {
    return setshowContractDuration(false);
  };

  var toggleSubCategory = function toggleSubCategory() {
    return setShowSubCategory(!showSubCategory);
  };

  var hideSubCategory = function hideSubCategory() {
    return setShowSubCategory(false);
  };

  var breadcrumbs = (0,breadcrumbService/* breadcrumbGenerator */.G)().deals.reverse();
  var section_lvls = {};
  var index = 0;

  var _iterator = _createForOfIteratorHelper(breadcrumbs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      index = index + 1;
      if (index > 4) break;
      section_lvls["page_site_section_lvl_".concat(index)] = item.label;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var analyticsData = function analyticsData() {
    var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    analyticsUtag/* link */.p4(DealGridSearchContainer_objectSpread({
      page_name: "shopping: deals grid: browse all deals",
      page_channel: "shopping",
      page_tool_event: "use",
      page_tool_name: filter === "" ? "shopping: deals grid: browse all deals: reset all filters" : "shopping: deals grid: browse all deals: reset ".concat(filter),
      page_master_tab: "personal"
    }, section_lvls));
  };

  var resetClickHandler = function resetClickHandler() {
    var newIntermediateSel = tempSelectedFilter.intermrdiateSelection;

    if (showBrand) {
      newIntermediateSel.brands = [];
      setTempSelectedFilter(DealGridSearchContainer_objectSpread(DealGridSearchContainer_objectSpread({}, tempSelectedFilter), {}, {
        intermrdiateSelection: newIntermediateSel
      }));
      analyticsData("brands");
    } else if (showPromo) {
      newIntermediateSel.promotions = [];
      setTempSelectedFilter(DealGridSearchContainer_objectSpread(DealGridSearchContainer_objectSpread({}, tempSelectedFilter), {}, {
        intermrdiateSelection: newIntermediateSel
      }));
      analyticsData("promotions");
    } else if (showPrice) {
      props.onFilterReset("price");
      analyticsData("price");
    } else if (showPlanType) {
      analyticsData("plan type");
      newIntermediateSel.plantypes = [];
      setTempSelectedFilter(DealGridSearchContainer_objectSpread(DealGridSearchContainer_objectSpread({}, tempSelectedFilter), {}, {
        intermrdiateSelection: newIntermediateSel
      }));
    } else if (showContractType) {
      newIntermediateSel.contracttype = [];
      setTempSelectedFilter(DealGridSearchContainer_objectSpread(DealGridSearchContainer_objectSpread({}, tempSelectedFilter), {}, {
        intermrdiateSelection: newIntermediateSel
      }));
      analyticsData("contract type");
      hideContractTypes();
    } else if (showData) {
      (0,filterDealService/* getDealFilterByData */.m)({}).then(props === null || props === void 0 ? void 0 : props.onFilterChange);
      analyticsData("data");
    } else if (showDataVmAirtime) {
      var newValue = DealGridSearchContainer_objectSpread({}, tempSelectedFilter.intermrdiateSelection);

      newValue === null || newValue === void 0 ? true : delete newValue.promo_data;
      newValue === null || newValue === void 0 ? true : delete newValue.minutes;
      newValue === null || newValue === void 0 ? true : delete newValue.airtime;
      setTempSelectedFilter({
        originalSelectection: tempSelectedFilter.originalSelectection,
        intermrdiateSelection: newValue
      });
      props.setSelectedFilter(newValue);
      analyticsData("data");
    } else if (showVoiceMinutes) {
      analyticsData("voice minutes");
      (0,filterDealService/* getDealFilterByVoiceMinutes */.vi)({}).then(props === null || props === void 0 ? void 0 : props.onFilterChange);
    } else if (showAirtime) {
      (0,filterDealService/* getDealFilterByAirTime */.QW)({}).then(props === null || props === void 0 ? void 0 : props.onFilterChange);
      analyticsData("airtime");
    } else if (showcontractDuration) {
      newIntermediateSel.contractduration = [];
      setTempSelectedFilter(DealGridSearchContainer_objectSpread(DealGridSearchContainer_objectSpread({}, tempSelectedFilter), {}, {
        intermrdiateSelection: newIntermediateSel
      }));
      analyticsData("contract duration");
    } else if (showPlanName) {
      newIntermediateSel.plannames = [];
      setTempSelectedFilter(DealGridSearchContainer_objectSpread(DealGridSearchContainer_objectSpread({}, tempSelectedFilter), {}, {
        intermrdiateSelection: newIntermediateSel
      }));
      analyticsData("plan name");
    } else if (showCate) {
      (0,filterDealService/* getDealFilterByCategory */.Ph)("").then(props === null || props === void 0 ? void 0 : props.onFilterChange);
      analyticsData("categories");
    } else if (showFilterByProduct) {
      (0,filterDealService/* getDealFilterByProductNames */.j_)([]).then(props === null || props === void 0 ? void 0 : props.onFilterChange);
    } else {
      props.onFilterReset();
      setTempSelectedFilter({
        originalSelectection: {},
        intermrdiateSelection: {}
      });
      analyticsData();
    }
  };

  var isBrandChecked = function isBrandChecked(brand) {
    return (0,helperServices/* isValueSelected */.$w)(props === null || props === void 0 ? void 0 : props.selectedFilter, brand, "brands");
  };

  var isPromotionChecked = function isPromotionChecked(promo) {
    return (0,helperServices/* isValueSelected */.$w)(props === null || props === void 0 ? void 0 : props.selectedFilter, promo, "promotions");
  };

  var isContractTypeChecked = function isContractTypeChecked(contract) {
    return (0,helperServices/* isValueSelected */.$w)(props === null || props === void 0 ? void 0 : props.selectedFilter, contract, "contracttype");
  };

  var isPlanTypeChecked = function isPlanTypeChecked(planType) {
    return (0,helperServices/* isValueSelected */.$w)(props === null || props === void 0 ? void 0 : props.selectedFilter, planType, "plantypes");
  };

  var isPlanNameChecked = function isPlanNameChecked(planName) {
    return (0,helperServices/* isValueSelected */.$w)(props === null || props === void 0 ? void 0 : props.selectedFilter, planName, "plannames");
  };

  var isAccessoriesChecked = function isAccessoriesChecked(accessory) {
    return (0,helperServices/* isValueSelected */.$w)(props === null || props === void 0 ? void 0 : props.selectedFilter, accessory, "accessories");
  };

  var isContractDurationChecked = function isContractDurationChecked(duration) {
    return (0,helperServices/* isValueSelected */.$w)(props === null || props === void 0 ? void 0 : props.selectedFilter, duration, "contractduration");
  };

  if (showBrand && props.hide) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchItemContainer/* default */.Z, {
      brands: props.brands,
      hideBrands: hideBrands,
      brandSelectHandler: function brandSelectHandler(flag, brandObjObj) {
        return props === null || props === void 0 ? void 0 : props.onBrandChange(flag, brandObjObj, false);
      },
      isBrandChecked: isBrandChecked,
      resetClickHandler: resetClickHandler,
      selectedFilter: props.selectedFilter,
      tempSelectedFilter: tempSelectedFilter.intermrdiateSelection,
      setSelectedFilter: props === null || props === void 0 ? void 0 : props.setSelectedFilter
    });
  }

  if (showCate && props.hide) {
    var _props$selectedCatego;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Categories/* default */.Z, {
      categoriesList: props.categoriesList && props.categoriesList.categories ? props.categoriesList.categories : [],
      selectHandler: props.getSelectedCategory,
      selected: props === null || props === void 0 ? void 0 : (_props$selectedCatego = props.selectedCategory) === null || _props$selectedCatego === void 0 ? void 0 : _props$selectedCatego.id,
      hideCategories: hideCategories,
      resetClickHandler: resetClickHandler,
      isDealGridPage: props === null || props === void 0 ? void 0 : props.isDealGridPage,
      tempSelectedFilter: tempSelectedFilter.intermrdiateSelection
    });
  }

  if (showSubCategory && props.hide) {
    var _props$selectedCatego2;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(SubCategoryMobileItem/* default */.Z, {
      selectedSubCategory: props && props.selectedFilter ? props.selectedFilter.selectedSubCategory : "",
      subCategories: props === null || props === void 0 ? void 0 : (_props$selectedCatego2 = props.selectedCategory) === null || _props$selectedCatego2 === void 0 ? void 0 : _props$selectedCatego2.subCategories,
      hideSubCategory: hideSubCategory,
      subCategorySelectHandler: selectSubCategoryChange
    });
  }

  var priceMinValue = props !== null && props !== void 0 && (_props$priceValue = props.priceValue) !== null && _props$priceValue !== void 0 && _props$priceValue.minValue ? Number(props.priceValue.minValue) : 0;
  var priceMaxValue = props !== null && props !== void 0 && (_props$priceValue2 = props.priceValue) !== null && _props$priceValue2 !== void 0 && _props$priceValue2.maxValue ? Number(props.priceValue.maxValue) : props.maxPrice;

  if (showPrice && props.hide) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(PriceFilterMobile/* default */.Z, {
      min: priceMinValue,
      max: priceMaxValue,
      minValue: 0,
      maxValue: props === null || props === void 0 ? void 0 : props.maxPrice,
      valueRange: props.priceRange,
      missingValueRange: props === null || props === void 0 ? void 0 : props.missingPriceRange,
      onPriceChange: selectPriceMobile,
      hidePrice: hidePrice,
      resetClickHandler: resetClickHandler,
      priceType: types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
      hidePriceTypes: true,
      step: 30,
      selectedFilter: props.priceValue && Object.keys(props.priceValue).length !== 0,
      priceValue: props === null || props === void 0 ? void 0 : props.priceValue,
      resetPriceType: function resetPriceType() {
        return "";
      },
      resetPriceValue: props === null || props === void 0 ? void 0 : props.setPriceValue
    });
  }

  if (showDataVmAirtime && props.hide) {
    var _props$promoValue, _props$promoValue$, _props$promoValue$2, _props$promoValue2, _props$promoValue2$, _props$promoValue$3, _props$vmValue, _props$vmValue$, _props$vmValue$2, _props$vmValue2, _props$vmValue2$, _props$vmValue$3, _props$airValue$, _props$airValue$2;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(searchItemContainer_DataVmAirtimeMobileItem, {
        hideDataVmAirtime: hideDataVmAirtime,
        selectDataMobile: selectDataMobile,
        min: props !== null && props !== void 0 && (_props$promoValue = props.promoValue) !== null && _props$promoValue !== void 0 && (_props$promoValue$ = _props$promoValue[0]) !== null && _props$promoValue$ !== void 0 && _props$promoValue$.label ? Number(props === null || props === void 0 ? void 0 : (_props$promoValue$2 = props.promoValue[0]) === null || _props$promoValue$2 === void 0 ? void 0 : _props$promoValue$2.label) : 0,
        max: props !== null && props !== void 0 && (_props$promoValue2 = props.promoValue) !== null && _props$promoValue2 !== void 0 && (_props$promoValue2$ = _props$promoValue2[1]) !== null && _props$promoValue2$ !== void 0 && _props$promoValue2$.label ? Number(props === null || props === void 0 ? void 0 : (_props$promoValue$3 = props.promoValue[1]) === null || _props$promoValue$3 === void 0 ? void 0 : _props$promoValue$3.label) : constants/* MAX_DATA */.CS,
        minValue: constants/* MIN_DATA */.Kt,
        maxValue: constants/* MAX_DATA */.CS,
        hideVoiceMinutes: hideVoiceMinutes,
        selectVMMobile: selectVoiceMinutesMobile,
        minVm: props !== null && props !== void 0 && (_props$vmValue = props.vmValue) !== null && _props$vmValue !== void 0 && (_props$vmValue$ = _props$vmValue[0]) !== null && _props$vmValue$ !== void 0 && _props$vmValue$.label ? Number(props === null || props === void 0 ? void 0 : (_props$vmValue$2 = props.vmValue[0]) === null || _props$vmValue$2 === void 0 ? void 0 : _props$vmValue$2.label) : 0,
        maxVm: props !== null && props !== void 0 && (_props$vmValue2 = props.vmValue) !== null && _props$vmValue2 !== void 0 && (_props$vmValue2$ = _props$vmValue2[1]) !== null && _props$vmValue2$ !== void 0 && _props$vmValue2$.label ? Number(props === null || props === void 0 ? void 0 : (_props$vmValue$3 = props.vmValue[1]) === null || _props$vmValue$3 === void 0 ? void 0 : _props$vmValue$3.label) : constants/* MAX_MINUTES */.UT,
        minValueVm: constants/* MIN_MINUTES */.FW,
        maxValueVm: constants/* MAX_MINUTES */.UT,
        hideAirtimeMob: hideAirtime,
        selectAirtimeMob: selectAirTimeMobile,
        minAir: props && props !== null && props !== void 0 && props.airValue ? Number(props === null || props === void 0 ? void 0 : (_props$airValue$ = props.airValue[0]) === null || _props$airValue$ === void 0 ? void 0 : _props$airValue$.label) : 0,
        maxAir: props && props !== null && props !== void 0 && props.airValue ? Number(props === null || props === void 0 ? void 0 : (_props$airValue$2 = props.airValue[1]) === null || _props$airValue$2 === void 0 ? void 0 : _props$airValue$2.label) : constants/* MAX_AIRTIME */.Vr,
        minValueAir: constants/* MIN_AIRTIME */.hJ,
        maxValueAir: constants/* MAX_AIRTIME */.Vr,
        selectedFilter: props.selectedFilter,
        setSelectedFilter: props === null || props === void 0 ? void 0 : props.setSelectedFilter,
        tempSelectedFilter: tempSelectedFilter.intermrdiateSelection,
        resetClickHandler: resetClickHandler,
        step: 30
      })
    });
  }

  if (showVoiceMinutes && props.hide) {
    var _props$vmValue3, _props$vmValue3$, _props$vmValue$4, _props$vmValue4, _props$vmValue4$, _props$vmValue$5;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(searchItemContainer_VoiceMobileItem, {
      hideVoiceMinutes: hideVoiceMinutes,
      selectVMMobile: selectVoiceMinutes,
      min: props !== null && props !== void 0 && (_props$vmValue3 = props.vmValue) !== null && _props$vmValue3 !== void 0 && (_props$vmValue3$ = _props$vmValue3[0]) !== null && _props$vmValue3$ !== void 0 && _props$vmValue3$.label ? Number(props === null || props === void 0 ? void 0 : (_props$vmValue$4 = props.vmValue[0]) === null || _props$vmValue$4 === void 0 ? void 0 : _props$vmValue$4.label) : 0,
      max: props !== null && props !== void 0 && (_props$vmValue4 = props.vmValue) !== null && _props$vmValue4 !== void 0 && (_props$vmValue4$ = _props$vmValue4[1]) !== null && _props$vmValue4$ !== void 0 && _props$vmValue4$.label ? Number(props === null || props === void 0 ? void 0 : (_props$vmValue$5 = props.vmValue[1]) === null || _props$vmValue$5 === void 0 ? void 0 : _props$vmValue$5.label) : constants/* MAX_MINUTES */.UT,
      minValue: constants/* MIN_MINUTES */.FW,
      maxValue: constants/* MAX_MINUTES */.UT,
      selectedFilter: props.selectedFilter,
      resetClickHandler: resetClickHandler,
      step: 30
    });
  }

  if (showAirtime && props.hide) {
    var _props$airValue$3, _props$airValue$4;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(searchItemContainer_AirtimeMobileItem, {
      hideAirtimeMob: hideAirtime,
      selectAirtimeMobile: selectAirTime,
      min: props && props !== null && props !== void 0 && props.airValue ? props === null || props === void 0 ? void 0 : (_props$airValue$3 = props.airValue[0]) === null || _props$airValue$3 === void 0 ? void 0 : _props$airValue$3.label : 0,
      max: props && props !== null && props !== void 0 && props.airValue ? props === null || props === void 0 ? void 0 : (_props$airValue$4 = props.airValue[1]) === null || _props$airValue$4 === void 0 ? void 0 : _props$airValue$4.label : constants/* MAX_AIRTIME */.Vr,
      minValue: constants/* MIN_AIRTIME */.hJ,
      maxValue: constants/* MAX_AIRTIME */.Vr,
      selectedFilter: props.selectedFilter,
      resetClickHandler: resetClickHandler,
      step: 30
    });
  }

  if (showPromo && props.hide) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(PromoMobile/* default */.Z, {
      hidePromo: hidePromo,
      promotions: props.promotions ? props.promotions : "",
      promotionClickHandler: function promotionClickHandler(flag, promotionObj) {
        return props === null || props === void 0 ? void 0 : props.onPromotionChange(flag, promotionObj, false);
      },
      isPromotionChecked: isPromotionChecked,
      resetClickHandler: resetClickHandler,
      selectedFilter: props.selectedFilter,
      setSelectedFilter: props === null || props === void 0 ? void 0 : props.setSelectedFilter,
      tempSelectedFilter: tempSelectedFilter.intermrdiateSelection
    });
  }

  if (showContractType && props.hide) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(contractTypeMobile, {
      hideContractType: hideContractTypes,
      filteredContractType: props.selectedFilter.contracttype,
      contracttypes: props.contracttype ? props.contracttype : "",
      contracttypeClickHandler: function contracttypeClickHandler(flag, contractValue) {
        return props === null || props === void 0 ? void 0 : props.onContractTypeChange(flag, contractValue, false);
      },
      isContractTypeChecked: isContractTypeChecked,
      resetClickHandler: resetClickHandler,
      selectedFilter: props === null || props === void 0 ? void 0 : props.selectedFilter,
      setSelectedFilter: props === null || props === void 0 ? void 0 : props.setSelectedFilter,
      tempSelectedFilter: tempSelectedFilter.intermrdiateSelection
    });
  }

  if (showPlanType && props.hide) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(planTypeMobile, {
      hidePlanType: hidePlanType,
      plantype: props.plantype ? props.plantype : "",
      plantypeClickHandler: function plantypeClickHandler(flag, planValue) {
        return props === null || props === void 0 ? void 0 : props.onPlanTypeChange(flag, planValue, false);
      },
      isPlanTypeChecked: isPlanTypeChecked,
      resetClickHandler: resetClickHandler,
      selectedFilter: props === null || props === void 0 ? void 0 : props.selectedFilter,
      setSelectedFilter: props === null || props === void 0 ? void 0 : props.setSelectedFilter,
      tempSelectedFilter: tempSelectedFilter.intermrdiateSelection
    });
  }

  if (showPlanName && props.hide) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(planNameMobile, {
      hidePlanName: hidePlanName,
      planname: props.planname ? props.planname : "",
      plannameClickHandler: function plannameClickHandler(flag, planValue) {
        return props === null || props === void 0 ? void 0 : props.onPlanNameChange(flag, planValue, false);
      },
      isPlanNameChecked: isPlanNameChecked,
      resetClickHandler: resetClickHandler,
      selectedFilter: props.selectedFilter,
      setSelectedFilter: props === null || props === void 0 ? void 0 : props.setSelectedFilter,
      tempSelectedFilter: tempSelectedFilter.intermrdiateSelection
    });
  }

  if (showAccessories && props.hide) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(accessoriesMobile, {
      hideAccessories: hideAccessories,
      accessoriesMob: props.accessories ? props.accessories : "",
      accessoriesClickHandler: props === null || props === void 0 ? void 0 : props.onAccessoriesChange,
      isAccessoriesChecked: isAccessoriesChecked,
      resetClickHandler: resetClickHandler
    });
  }

  if (showcontractDuration && props.hide) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(searchItemContainer_contractDurationMobile, {
      hideContractDuraiton: hideContractDuration,
      contarctDuraitonMob: props.contractduration ? props.contractduration : "",
      contractdurationClickHandler: function contractdurationClickHandler(flag, value) {
        return props === null || props === void 0 ? void 0 : props.onContractDurationChange(flag, value, false);
      },
      isContractDurationChecked: isContractDurationChecked,
      resetClickHandler: resetClickHandler,
      selectedFilter: props.selectedFilter,
      setSelectedFilter: props.setSelectedFilter,
      tempSelectedFilter: tempSelectedFilter.intermrdiateSelection
    });
  }

  if (showFilterByProduct && props.hide) {
    return (props === null || props === void 0 ? void 0 : props.productSearchOnDealGridEnabled) && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductFilter_ProductFilterMobile, {
      closeRequired: true,
      resetClickHandler: resetClickHandler,
      hideFilter: props.show,
      onSearchTextSelect: props.onProductFilterChange,
      handleError: props.onProductFilterError,
      isEligible: props.isEligible,
      qualifyLabel: labels/* default.lbl_affordability_product_filter */.Z.lbl_affordability_product_filter,
      selectedFilter: props.selectedFilter,
      brands: props.brands
    });
  }

  var backToDeals = function backToDeals() {
    props.show();
    props.toggleFilters(false);
    setIsMounted(false);
    props.setSelectedFilter(tempSelectedFilter.originalSelectection);
  };

  var handleShowResult = function handleShowResult() {
    props.show();
    props.handleApplyFilter();
    props.toggleFilters(false);
    setIsMounted(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: props.hide ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (DealGridSearchContainer_module_default())["nav-gutter"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
          headingName: "Filter deals",
          backbtn: backToDeals,
          resetClickHandler: resetClickHandler,
          selectedFilter: props.selectedFilter.selectedCategory || props.selectedFilter.subCategories || props.selectedFilter.promotions || props.selectedFilter.brands || props.selectedFilter.price || props.selectedFilter.promo_data || props.selectedFilter.minutes || props.selectedFilter.airtime || props.selectedFilter.contracttype || props.selectedFilter.plantypes || props.selectedFilter.planname || props.selectedFilter.accessories || props.selectedFilter.contractduration
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
          headingName: "Filter deals",
          backbtn: backToDeals,
          resetClickHandler: resetClickHandler,
          selectedFilter: props.selectedFilter.selectedCategory || props.selectedFilter.subCategories || props.selectedFilter.promotions || props.selectedFilter.brands || props.selectedFilter.price || props.selectedFilter.promo_data || props.selectedFilter.minutes || props.selectedFilter.airtime || props.selectedFilter.contracttype || props.selectedFilter.plantypes || props.selectedFilter.planname || props.selectedFilter.accessories || props.selectedFilter.contractduration
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Products/* default */.Z, {
          selectedFilter: props.selectedFilter,
          categoriesList: props.categoriesList,
          category: toggleCategory,
          selectedProductID: props === null || props === void 0 ? void 0 : (_props$selectedCatego3 = props.selectedCategory) === null || _props$selectedCatego3 === void 0 ? void 0 : _props$selectedCatego3.id,
          hide: props.hide,
          selectedProductName: props === null || props === void 0 ? void 0 : (_props$selectedCatego4 = props.selectedCategory) === null || _props$selectedCatego4 === void 0 ? void 0 : _props$selectedCatego4.name,
          subCategory: toggleSubCategory,
          handleCategorySelect: function handleCategorySelect(category) {
            return _handleCategorySelect(category);
          },
          allProductsClickHandler: allProductsClickHandler,
          handleSubCategorySelect: function handleSubCategorySelect(subCategory) {
            return selectSubCategoryChange(true, subCategory);
          },
          isDealGridPage: props.isDealGridPage
        }), ((_props$brands = props.brands) === null || _props$brands === void 0 ? void 0 : _props$brands.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Brands/* default */.Z, {
          brands: props.brands,
          branditem: toggleBrand,
          filteredBrands: props.selectedFilter.brands,
          handleBrandSelect: props === null || props === void 0 ? void 0 : props.onBrandChange,
          displaySelectedBrands: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DealSliderFilter/* default */.Z, {
          selectedFilter: props === null || props === void 0 ? void 0 : props.selectedFilter,
          displaySlider: Number(priceMaxValue) != props.priceRange[((_props$priceRange = props.priceRange) === null || _props$priceRange === void 0 ? void 0 : _props$priceRange.length) - 1] || Number(priceMinValue) != Number(props.priceRange[0]),
          price: togglePrice,
          valueRange: props.priceRange,
          missingValueRange: props === null || props === void 0 ? void 0 : props.missingPriceRange,
          min: props !== null && props !== void 0 && (_props$priceValue3 = props.priceValue) !== null && _props$priceValue3 !== void 0 && _props$priceValue3.minValue ? Number(props.priceValue.minValue) : Number(props.priceRange[0]) || 0,
          max: props !== null && props !== void 0 && (_props$priceValue4 = props.priceValue) !== null && _props$priceValue4 !== void 0 && _props$priceValue4.maxValue ? Number((_props$priceValue5 = props.priceValue) === null || _props$priceValue5 === void 0 ? void 0 : _props$priceValue5.maxValue) : Number(props === null || props === void 0 ? void 0 : props.maxPrice),
          minValue: 0,
          maxValue: Number(props === null || props === void 0 ? void 0 : props.maxPrice),
          selectPrice: selectPrice,
          isDealGridPage: props.isDealGridPage,
          heading: "Price",
          type: "price"
        }), ((_props$promotions = props.promotions) === null || _props$promotions === void 0 ? void 0 : _props$promotions.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Promotions/* default */.Z, {
          promotions: props.promotions,
          filteredPromotions: props.selectedFilter.promotions,
          promo: togglePromotions,
          displaySelectedPromotion: true,
          handlePromotionSelect: props === null || props === void 0 ? void 0 : props.onPromotionChange
        }), ((_props$contracttype = props.contracttype) === null || _props$contracttype === void 0 ? void 0 : _props$contracttype.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(contractType_ContractType, {
          contracttypes: props.contracttype,
          filteredContractType: props.selectedFilter.contracttype,
          toggleContractTypes: toggleContractTypes,
          onContractTypeChange: selectContractType,
          contractsList: props === null || props === void 0 ? void 0 : props.contractsList,
          selectedFilter: props === null || props === void 0 ? void 0 : props.selectedFilter,
          displayContractType: true
        }), ((_props$plantype = props.plantype) === null || _props$plantype === void 0 ? void 0 : _props$plantype.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(planType_PlanType, {
          planType: props.plantype,
          filteredPlanType: props.selectedFilter.plantypes,
          plan: togglePlanTypes,
          handlePlanTypeSelect: props === null || props === void 0 ? void 0 : props.onPlanTypeChange,
          displayPlanType: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DealSliderFilter/* default */.Z, {
          selectedFilter: props.selectedFilter,
          displaySlider: props.promoValue && Number(props === null || props === void 0 ? void 0 : (_props$promoValue$4 = props.promoValue[1]) === null || _props$promoValue$4 === void 0 ? void 0 : _props$promoValue$4.label) != constants/* MAX_DATA */.CS || props.promoValue && Number(props === null || props === void 0 ? void 0 : (_props$promoValue$5 = props.promoValue[0]) === null || _props$promoValue$5 === void 0 ? void 0 : _props$promoValue$5.label) != 0 || props.vmValue && Number(props === null || props === void 0 ? void 0 : (_props$vmValue$6 = props.vmValue[1]) === null || _props$vmValue$6 === void 0 ? void 0 : _props$vmValue$6.label) != constants/* MAX_MINUTES */.UT || props.vmValue && Number(props === null || props === void 0 ? void 0 : (_props$vmValue$7 = props.vmValue[0]) === null || _props$vmValue$7 === void 0 ? void 0 : _props$vmValue$7.label) != 0 || props.airValue && Number(props === null || props === void 0 ? void 0 : (_props$airValue$5 = props.airValue[1]) === null || _props$airValue$5 === void 0 ? void 0 : _props$airValue$5.label) != constants/* MAX_AIRTIME */.Vr || props.airValue && Number(props === null || props === void 0 ? void 0 : (_props$airValue$6 = props.airValue[0]) === null || _props$airValue$6 === void 0 ? void 0 : _props$airValue$6.label) != 0 ? true : false,
          dispalyDataValue: props.promoValue && Number(props === null || props === void 0 ? void 0 : (_props$promoValue$6 = props.promoValue[1]) === null || _props$promoValue$6 === void 0 ? void 0 : _props$promoValue$6.label) != constants/* MAX_DATA */.CS || props.promoValue && Number(props === null || props === void 0 ? void 0 : (_props$promoValue$7 = props.promoValue[0]) === null || _props$promoValue$7 === void 0 ? void 0 : _props$promoValue$7.label) != 0 ? true : false,
          dispalyVmValue: props.vmValue && Number(props === null || props === void 0 ? void 0 : (_props$vmValue$8 = props.vmValue[1]) === null || _props$vmValue$8 === void 0 ? void 0 : _props$vmValue$8.label) != constants/* MAX_MINUTES */.UT || props.vmValue && Number(props === null || props === void 0 ? void 0 : (_props$vmValue$9 = props.vmValue[0]) === null || _props$vmValue$9 === void 0 ? void 0 : _props$vmValue$9.label) != 0 ? true : false,
          dispalyAirtimeValue: props.airValue && Number(props === null || props === void 0 ? void 0 : (_props$airValue$7 = props.airValue[1]) === null || _props$airValue$7 === void 0 ? void 0 : _props$airValue$7.label) != constants/* MAX_AIRTIME */.Vr || props.airValue && Number(props === null || props === void 0 ? void 0 : (_props$airValue$8 = props.airValue[0]) === null || _props$airValue$8 === void 0 ? void 0 : _props$airValue$8.label) != 0 ? true : false,
          price: toggleDataVmAirtime,
          min: props !== null && props !== void 0 && (_props$promoValue3 = props.promoValue) !== null && _props$promoValue3 !== void 0 && (_props$promoValue3$ = _props$promoValue3[0]) !== null && _props$promoValue3$ !== void 0 && _props$promoValue3$.label ? Number(props === null || props === void 0 ? void 0 : (_props$promoValue$8 = props.promoValue[0]) === null || _props$promoValue$8 === void 0 ? void 0 : _props$promoValue$8.label) : 0,
          max: props !== null && props !== void 0 && (_props$promoValue4 = props.promoValue) !== null && _props$promoValue4 !== void 0 && (_props$promoValue4$ = _props$promoValue4[1]) !== null && _props$promoValue4$ !== void 0 && _props$promoValue4$.label ? Number(props === null || props === void 0 ? void 0 : (_props$promoValue$9 = props.promoValue[1]) === null || _props$promoValue$9 === void 0 ? void 0 : _props$promoValue$9.label) : constants/* MAX_DATA */.CS,
          minValue: constants/* MIN_DATA */.Kt,
          maxValue: constants/* MAX_DATA */.CS,
          minVm: props !== null && props !== void 0 && (_props$vmValue5 = props.vmValue) !== null && _props$vmValue5 !== void 0 && (_props$vmValue5$ = _props$vmValue5[0]) !== null && _props$vmValue5$ !== void 0 && _props$vmValue5$.label ? Number(props === null || props === void 0 ? void 0 : (_props$vmValue$10 = props.vmValue[0]) === null || _props$vmValue$10 === void 0 ? void 0 : _props$vmValue$10.label) : 0,
          maxVm: props !== null && props !== void 0 && (_props$vmValue6 = props.vmValue) !== null && _props$vmValue6 !== void 0 && (_props$vmValue6$ = _props$vmValue6[1]) !== null && _props$vmValue6$ !== void 0 && _props$vmValue6$.label ? Number(props === null || props === void 0 ? void 0 : (_props$vmValue$11 = props.vmValue[1]) === null || _props$vmValue$11 === void 0 ? void 0 : _props$vmValue$11.label) : constants/* MAX_MINUTES */.UT,
          minValueVm: constants/* MIN_MINUTES */.FW,
          maxValueVm: constants/* MAX_MINUTES */.UT,
          minAir: props && props !== null && props !== void 0 && props.airValue ? props === null || props === void 0 ? void 0 : (_props$airValue$9 = props.airValue[0]) === null || _props$airValue$9 === void 0 ? void 0 : _props$airValue$9.label : 0,
          maxAir: props && props !== null && props !== void 0 && props.airValue ? props === null || props === void 0 ? void 0 : (_props$airValue$10 = props.airValue[1]) === null || _props$airValue$10 === void 0 ? void 0 : _props$airValue$10.label : constants/* MAX_AIRTIME */.Vr,
          minValueAir: constants/* MIN_AIRTIME */.hJ,
          maxValueAir: constants/* MAX_AIRTIME */.Vr,
          isDealGridPage: props.isDealGridPage,
          heading: "Monthly data / voice minutes / airtime",
          type: "datavmairtime",
          selectData: selectDataMobile
        }), ((_props$contractdurati = props.contractduration) === null || _props$contractdurati === void 0 ? void 0 : _props$contractdurati.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(contractDuration_ContractDuration, {
          contractdurationList: props.contractduration,
          displayContractDuration: true,
          filteredContractDuration: props.selectedFilter.contractduration,
          ContractDuration: toggleContractDuration,
          handleAccessoriesSelect: props === null || props === void 0 ? void 0 : props.onContractDurationChange
        }), ((_props$planname = props.planname) === null || _props$planname === void 0 ? void 0 : _props$planname.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(planName_PlanName, {
          displayPlanName: true,
          planName: props.planname,
          filteredPlanName: props.selectedFilter.plannames,
          planNames: togglePlanNames,
          handlePlannameSelect: props === null || props === void 0 ? void 0 : props.onPlanNameChange
        }), (props === null || props === void 0 ? void 0 : (_props$accessories = props.accessories) === null || _props$accessories === void 0 ? void 0 : _props$accessories.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(accessories_Accessories, {
          accessoriesList: props.accessories,
          displayAccessories: true,
          filteredAccessories: props.selectedFilter.accessories,
          Accessories: toggleAccessories,
          handleAccessoriesSelect: props === null || props === void 0 ? void 0 : props.onAccessoriesChange
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((DealGridSearchContainer_module_default())["show-results"], " pr-2"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (DealGridSearchContainer_module_default())["show-results__button"],
          onClick: handleShowResult,
          children: "Apply filters"
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((DealGridSearchContainer_module_default()).hide, " d-none d-lg-block"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [props.productSearchOnDealGridEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductFilter_ProductFilter, {
            closeRequired: true,
            onSearchTextSelect: props.onProductFilterChange,
            handleError: props.onProductFilterError,
            isEligible: props.isEligible,
            qualifyLabel: labels/* default.lbl_affordability_product_filter */.Z.lbl_affordability_product_filter,
            brands: props.brands
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Products/* default */.Z, {
            categoriesList: props.categoriesList,
            selectedFilter: props.selectedFilter,
            handleCategorySelect: function handleCategorySelect(category) {
              return _handleCategorySelect(category);
            },
            allProductsClickHandler: allProductsClickHandler,
            handleSubCategorySelect: function handleSubCategorySelect(subCategory) {
              return selectSubCategoryChange(true, subCategory);
            },
            isDealGridPage: props.isDealGridPage
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DealSliderFilter/* default */.Z, {
            price: togglePrice,
            min: props !== null && props !== void 0 && (_props$priceValue6 = props.priceValue) !== null && _props$priceValue6 !== void 0 && _props$priceValue6.minValue ? Number(props.priceValue.minValue) : 0,
            max: props !== null && props !== void 0 && (_props$priceValue7 = props.priceValue) !== null && _props$priceValue7 !== void 0 && _props$priceValue7.maxValue ? Number((_props$priceValue8 = props.priceValue) === null || _props$priceValue8 === void 0 ? void 0 : _props$priceValue8.maxValue) : Number(props === null || props === void 0 ? void 0 : props.maxPrice),
            minValue: 0,
            maxValue: Number(props === null || props === void 0 ? void 0 : props.maxPrice),
            selectPrice: selectPrice,
            isDealGridPage: props.isDealGridPage,
            heading: "Price",
            type: "price",
            valueRange: props.priceRange,
            missingValueRange: props === null || props === void 0 ? void 0 : props.missingPriceRange,
            selectedTypeValue: selectedType,
            resetClickHandler: resetClickHandler,
            showQualifyDeals: props.showQualifyDeals,
            qualifyLabel: "You can upgrade to a deal that falls within the above price range"
          }), ((_props$brands2 = props.brands) === null || _props$brands2 === void 0 ? void 0 : _props$brands2.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Brands/* default */.Z, {
            brands: props.brands,
            filteredBrands: props.selectedFilter.brands,
            handleBrandSelect: props === null || props === void 0 ? void 0 : props.onBrandChange
          }), ((_props$promotions2 = props.promotions) === null || _props$promotions2 === void 0 ? void 0 : _props$promotions2.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Promotions/* default */.Z, {
            promotions: props.promotions,
            filteredPromotions: props.selectedFilter.promotions,
            promo: togglePromotions,
            handlePromotionSelect: props === null || props === void 0 ? void 0 : props.onPromotionChange
          }), !isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(contractType_ContractType, {
            contracttypes: props.contracttype,
            filteredContractType: props.selectedFilter.contracttype,
            toggleContractTypes: toggleContractTypes,
            onContractTypeChange: selectContractType,
            contractsList: props.contractsList,
            selectedFilter: props.selectedFilter
          }) : "", /*#__PURE__*/(0,jsx_runtime.jsx)(planType_PlanType, {
            planType: props.plantype,
            filteredPlanType: props.selectedFilter.plantypes,
            plan: togglePlanTypes,
            handlePlanTypeSelect: props === null || props === void 0 ? void 0 : props.onPlanTypeChange
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DealSliderFilter/* default */.Z, {
            price: toggleData,
            min: props !== null && props !== void 0 && (_props$promoValue5 = props.promoValue) !== null && _props$promoValue5 !== void 0 && (_props$promoValue5$ = _props$promoValue5[0]) !== null && _props$promoValue5$ !== void 0 && _props$promoValue5$.label ? Number(props === null || props === void 0 ? void 0 : (_props$promoValue$10 = props.promoValue[0]) === null || _props$promoValue$10 === void 0 ? void 0 : _props$promoValue$10.label) : 0,
            max: props !== null && props !== void 0 && (_props$promoValue6 = props.promoValue) !== null && _props$promoValue6 !== void 0 && (_props$promoValue6$ = _props$promoValue6[1]) !== null && _props$promoValue6$ !== void 0 && _props$promoValue6$.label ? Number(props === null || props === void 0 ? void 0 : (_props$promoValue$11 = props.promoValue[1]) === null || _props$promoValue$11 === void 0 ? void 0 : _props$promoValue$11.label) : constants/* MAX_DATA */.CS,
            minValue: constants/* MIN_DATA */.Kt,
            maxValue: constants/* MAX_DATA */.CS,
            selectData: selectData,
            isDealGridPage: props.isDealGridPage,
            heading: "Data",
            type: "data",
            selectedTypeValue: selectedType,
            resetClickHandler: resetClickHandler
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DealSliderFilter/* default */.Z, {
            price: toggleVoiceMinutes,
            min: props !== null && props !== void 0 && (_props$vmValue7 = props.vmValue) !== null && _props$vmValue7 !== void 0 && (_props$vmValue7$ = _props$vmValue7[0]) !== null && _props$vmValue7$ !== void 0 && _props$vmValue7$.label ? Number(props === null || props === void 0 ? void 0 : (_props$vmValue$12 = props.vmValue[0]) === null || _props$vmValue$12 === void 0 ? void 0 : _props$vmValue$12.label) : 0,
            max: props !== null && props !== void 0 && (_props$vmValue8 = props.vmValue) !== null && _props$vmValue8 !== void 0 && (_props$vmValue8$ = _props$vmValue8[1]) !== null && _props$vmValue8$ !== void 0 && _props$vmValue8$.label ? Number(props === null || props === void 0 ? void 0 : (_props$vmValue$13 = props.vmValue[1]) === null || _props$vmValue$13 === void 0 ? void 0 : _props$vmValue$13.label) : constants/* MAX_MINUTES */.UT,
            minValue: constants/* MIN_MINUTES */.FW,
            maxValue: constants/* MAX_MINUTES */.UT,
            selectVoiceMinutes: selectVoiceMinutes,
            isDealGridPage: props.isDealGridPage,
            heading: "Voice minutes",
            type: "vm",
            selectedTypeValue: selectedType,
            resetClickHandler: resetClickHandler
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DealSliderFilter/* default */.Z, {
            selectedFilter: props.selectedFilter,
            price: toggleAirtime,
            min: props && props !== null && props !== void 0 && props.airValue ? props === null || props === void 0 ? void 0 : (_props$airValue$11 = props.airValue[0]) === null || _props$airValue$11 === void 0 ? void 0 : _props$airValue$11.label : 0,
            max: props && props !== null && props !== void 0 && props.airValue ? props === null || props === void 0 ? void 0 : (_props$airValue$12 = props.airValue[1]) === null || _props$airValue$12 === void 0 ? void 0 : _props$airValue$12.label : constants/* MAX_AIRTIME */.Vr,
            minValue: constants/* MIN_AIRTIME */.hJ,
            maxValue: constants/* MAX_AIRTIME */.Vr,
            selectAirTime: selectAirTime,
            isDealGridPage: props.isDealGridPage,
            heading: "Airtime",
            type: "airtime",
            selectedTypeValue: selectedType,
            resetClickHandler: resetClickHandler
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(contractDuration_ContractDuration, {
            contractdurationList: props.contractduration,
            filteredContractDuration: props.selectedFilter.contractduration,
            ContractDuration: toggleContractDuration,
            handleContratcDurationSelect: props === null || props === void 0 ? void 0 : props.onContractDurationChange
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(planName_PlanName, {
            planName: props.planname,
            filteredPlanName: props.selectedFilter.plannames,
            planNames: togglePlanNames,
            handlePlannameSelect: props === null || props === void 0 ? void 0 : props.onPlanNameChange
          }), ((_props$accessories2 = props.accessories) === null || _props$accessories2 === void 0 ? void 0 : _props$accessories2.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(accessories_Accessories, {
            accessoriesList: props.accessories,
            filteredAccessories: props.selectedFilter.accessories,
            Accessories: toggleAccessories,
            handleAccessoriesSelect: props === null || props === void 0 ? void 0 : props.onAccessoriesChange
          })]
        })
      })
    })
  });
};

/* harmony default export */ var dealGridSearchContainer_DealGridSearchContainer = ((0,DependencyHelper.connect)(null, {
  displayHideFooter: footerAction/* displayHideFooter */.e,
  toggleFilters: navAction/* toggleFilters */.aD
})(DealGridSearchContainer));
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./components/atoms/whitePill/WhitePill.jsx
var WhitePill = __webpack_require__(53803);
// EXTERNAL MODULE: ./components/organisms/emptyProductsContainer/EmptyProductsContainer.jsx
var EmptyProductsContainer = __webpack_require__(36603);
// EXTERNAL MODULE: ./components/atoms/pageCounter/PageCounter.jsx
var PageCounter = __webpack_require__(45571);
// EXTERNAL MODULE: ./components/atoms/dropDown/DropDown.jsx
var DropDown = __webpack_require__(85092);
// EXTERNAL MODULE: ./components/organisms/SortContainer/SortContainer.jsx
var SortContainer = __webpack_require__(54954);
// EXTERNAL MODULE: ./components/molecules/dealCard/DealCard.jsx
var DealCard = __webpack_require__(8005);
// EXTERNAL MODULE: ./components/atoms/gridBanner/GridBanner.jsx
var GridBanner = __webpack_require__(13920);
// EXTERNAL MODULE: ./components/atoms/upgradeInfoBar/upgradeInfoBar.jsx
var upgradeInfoBar = __webpack_require__(29567);
// EXTERNAL MODULE: ./components/organisms/dealGridListContainer/DealGridListContainer.module.scss
var DealGridListContainer_module = __webpack_require__(56710);
var DealGridListContainer_module_default = /*#__PURE__*/__webpack_require__.n(DealGridListContainer_module);
// EXTERNAL MODULE: ./components/molecules/nativeSort/NativeSort.jsx + 1 modules
var NativeSort = __webpack_require__(7777);
// EXTERNAL MODULE: ./utils/miniAppUtil.js
var miniAppUtil = __webpack_require__(21909);
;// CONCATENATED MODULE: ./components/organisms/dealGridListContainer/DealGridListContainer.jsx


function DealGridListContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DealGridListContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DealGridListContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DealGridListContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function DealGridListContainer_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = DealGridListContainer_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function DealGridListContainer_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return DealGridListContainer_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DealGridListContainer_arrayLikeToArray(o, minLen); }

function DealGridListContainer_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






























var DealGridListContainer = function DealGridListContainer(props) {
  var _props$pageInfo, _props$items, _props$pageInfo2, _props$pageInfo3, _props$pageInfo4, _props$pageInfo5, _props$items2, _props$pageInfo7, _props$bannerData, _props$selectedPrice, _props$selectedPrice2, _props$selectedPrice3, _props$selectedPrice4, _props$selectedBrands, _props$selectedProduc, _props$selectedPromot, _props$selectedPlanty, _props$selectedPromoD, _props$selectedPromoD2, _props$selectedPromoD3, _props$selectedPromoD4, _props$selectedMinute, _props$selectedMinute2, _props$selectedMinute3, _props$selectedMinute4, _props$selectedMinute5, _props$selectedAirtim, _props$selectedAirtim2, _props$selectedAirtim3, _props$selectedAirtim4, _props$selectedPlanna, _props$selectedAccces, _props$selectedContra, _props$selectedContra2, _props$selectedPrice5, _props$selectedPrice6, _props$selectedPrice7, _props$selectedPrice8, _props$selectedBrands2, _props$selectedProduc2, _props$selectedPromot2, _props$selectedPlanty2, _props$selectedPromoD5, _props$selectedPromoD6, _props$selectedPromoD7, _props$selectedPromoD8, _props$selectedMinute6, _props$selectedMinute7, _props$selectedMinute8, _props$selectedMinute9, _props$selectedMinute10, _props$selectedAirtim5, _props$selectedAirtim6, _props$selectedAirtim7, _props$selectedAirtim8, _props$selectedPlanna2, _props$selectedAccces2, _props$selectedContra3, _props$selectedContra4, _props$items3, _props$bannerData2, _props$pageInfo8;

  var env = (config_default()).env;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var PAGE_SIZE = props === null || props === void 0 ? void 0 : (_props$pageInfo = props.pageInfo) === null || _props$pageInfo === void 0 ? void 0 : _props$pageInfo.page_size;
  var totalLength = props === null || props === void 0 ? void 0 : (_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.length;
  var totalPages = props === null || props === void 0 ? void 0 : (_props$pageInfo2 = props.pageInfo) === null || _props$pageInfo2 === void 0 ? void 0 : _props$pageInfo2.total_pages;
  var lastItem = ((props === null || props === void 0 ? void 0 : (_props$pageInfo3 = props.pageInfo) === null || _props$pageInfo3 === void 0 ? void 0 : _props$pageInfo3.current_page) - 1) * (props === null || props === void 0 ? void 0 : (_props$pageInfo4 = props.pageInfo) === null || _props$pageInfo4 === void 0 ? void 0 : _props$pageInfo4.page_size) + totalLength;
  var router = (0,DependencyHelper.useRouter)();
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < constants/* MOBILE_WIDTH */.P_;
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 768;
  var lblRecommendedForYou = props !== null && props !== void 0 && props.isDealGridPage ? labels/* default.sortKeys.lbl_recommended */.Z.sortKeys.lbl_recommended : labels/* default.lbl_recommend_for_you */.Z.lbl_recommend_for_you;

  var _useState = (0,react.useState)((props === null || props === void 0 ? void 0 : (_props$pageInfo5 = props.pageInfo) === null || _props$pageInfo5 === void 0 ? void 0 : _props$pageInfo5.current_page) || 1),
      page = _useState[0],
      setPage = _useState[1];

  (0,react.useEffect)(function () {
    props.displayHideFooter(props.hide);
  }, []);
  (0,react.useEffect)(function () {
    var _props$pageInfo6;

    setPage(props === null || props === void 0 ? void 0 : (_props$pageInfo6 = props.pageInfo) === null || _props$pageInfo6 === void 0 ? void 0 : _props$pageInfo6.current_page);
    setTimeout(lib/* forceVisible */.Iq, 1000);
  }, [props === null || props === void 0 ? void 0 : props.pageInfo]);

  function getSortParams() {
    var dropdownValues = [{
      label: lblRecommendedForYou
    }, {
      label: labels/* default.sortKeys.lbl_most_popular */.Z.sortKeys.lbl_most_popular
    }, {
      label: labels/* default.sortKeys.lbl_low_to_high */.Z.sortKeys.lbl_low_to_high
    }, {
      label: labels/* default.sortKeys.lbl_high_to_low */.Z.sortKeys.lbl_high_to_low
    }];
    return dropdownValues;
  }

  var dealSortValues = getSortParams();

  var handleSelected = function handleSelected(value) {
    props === null || props === void 0 ? void 0 : props.sortBy(true, value);
  };

  var handleSelectedMobile = function handleSelectedMobile(flag) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    props === null || props === void 0 ? void 0 : props.sortBy(flag, flag ? value : lblRecommendedForYou);
  };

  var increasePageCount = function increasePageCount() {
    if (page < totalPages) {
      props === null || props === void 0 ? void 0 : props.updateCurrentPage(page + 1);
      setPage(page + 1);

      if (props !== null && props !== void 0 && props.isDealGridPage) {
        window.scrollTo(0, 0);
      }

      if (props.pageName == "upgrade") {
        if (isMobile) {
          window.scrollTo(0, 100);
        } else {
          window.scrollTo(0, 600);
        }
      }
    }
  };

  var decreasePageCount = function decreasePageCount() {
    if (page > 1) {
      props === null || props === void 0 ? void 0 : props.updateCurrentPage(page - 1);
      setPage(page - 1);

      if (props !== null && props !== void 0 && props.isDealGridPage) {
        window.scrollTo(0, 0);
      }

      if (props.pageName == "upgrade") {
        if (isMobile) {
          window.scrollTo(0, 100);
        } else {
          window.scrollTo(0, 600);
        }
      }
    }
  };

  var _handleCurrentPageChange = function handleCurrentPageChange(page) {
    props === null || props === void 0 ? void 0 : props.updateCurrentPage(page);
    setPage(page);

    if (props !== null && props !== void 0 && props.isDealGridPage) {
      window.scrollTo(0, 0);
    }
  };

  var FilterText = (props === null || props === void 0 ? void 0 : (_props$items2 = props.items) === null || _props$items2 === void 0 ? void 0 : _props$items2.length) > 0 ? "".concat(((props === null || props === void 0 ? void 0 : (_props$pageInfo7 = props.pageInfo) === null || _props$pageInfo7 === void 0 ? void 0 : _props$pageInfo7.current_page) - 1) * PAGE_SIZE + 1, " - ").concat(lastItem, " of\n\t").concat(props === null || props === void 0 ? void 0 : props.totalItemsCount, " ").concat(props.pageName == "upgrade" && isMobile ? "" : "results") : "Showing 0 of 0 results";

  var onSeeDetailsClick = function onSeeDetailsClick(item) {
    var contracts = item.contract_sku;

    if (!Array.isArray(contracts)) {
      contracts = ["".concat(contracts)];
    } else {
      var total = contracts.length;
      var contractPosition = contracts.indexOf(item.sku);

      if (contractPosition !== -1 && contractPosition !== total - 1) {
        var filteredContracts = contracts.filter(function (contract) {
          return contract !== item.sku;
        });
        filteredContracts.push(item.sku);
        contracts = filteredContracts;
      }
    }

    (0,helperServices/* showSpinner */.yh)();
    router.push({
      pathname: "".concat(urlPrefix, "/deal-details-page/").concat(item.url_key),
      query: props !== null && props !== void 0 && props.buyOption ? {
        buyOption: props !== null && props !== void 0 && props.defaultUpgrade ? "upgrade" : props === null || props === void 0 ? void 0 : props.buyOption
      } : props !== null && props !== void 0 && props.defaultUpgrade ? {
        buyOption: "upgrade"
      } : null
    }).then(function () {
      window.scrollTo(0, 0);
      (0,helperServices/* hideSpinner */.v3)();
    });
    return (props === null || props === void 0 ? void 0 : props.onSeeDetailsClick) && props.onSeeDetailsClick(item);
  };

  var breadcrumbs = (0,breadcrumbService/* breadcrumbGenerator */.G)().deals.reverse();
  var section_lvls = {};
  var index = 0;

  var _iterator = DealGridListContainer_createForOfIteratorHelper(breadcrumbs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      index = index + 1;
      if (index > 4) break;
      section_lvls["page_site_section_lvl_".concat(index)] = item.label;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var resetFilterHandler = function resetFilterHandler() {
    props === null || props === void 0 ? void 0 : props.clearCategories();
    props.onFilterReset();

    if (isMobile) {
      (0,analyticsUtag/* link */.p4)(DealGridListContainer_objectSpread({
        page_name: "shopping: deals grid: browse all deals",
        page_channel: "shopping",
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: browse all deals: reset all filters",
        page_master_tab: "personal"
      }, section_lvls));
    }
  };

  var handleRedirect = function handleRedirect() {
    var _props$bannerData$;

    (0,helperServices/* showSpinner */.yh)();
    var url = props === null || props === void 0 ? void 0 : (_props$bannerData$ = props.bannerData[0]) === null || _props$bannerData$ === void 0 ? void 0 : _props$bannerData$.banner_url;

    if (!url) {
      return;
    }

    var isMiniApp = (0,helperServices/* getCookieValue */.Do)("miniApp") === "true";

    if (isMiniApp) {
      (0,miniAppUtil/* openBreakoutUrl */.W)(url);
      return;
    }

    window.location = "".concat(url);
  };

  var truncateString = function truncateString(str, stringLen) {
    return str.length > stringLen ? str.substring(0, stringLen) + "..." : str;
  };

  return props.hide && (props === null || props === void 0 ? void 0 : props.featureSelected) === "sort" ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (DealGridListContainer_module_default())["sort-gutter"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
      headingName: "Sort by",
      backbtn: props === null || props === void 0 ? void 0 : props.show,
      resetClickHandler: function resetClickHandler() {
        return handleSelectedMobile();
      }
    }), dealSortValues.map(function (sortLabel, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SortContainer/* default */.Z, {
        close: props === null || props === void 0 ? void 0 : props.show,
        boxHeading: sortLabel.label,
        selected: (props === null || props === void 0 ? void 0 : props.selectedSortVal) === sortLabel.label,
        selectHandler: function selectHandler(flag) {
          return handleSelectedMobile(flag, sortLabel.label);
        }
      }, "sort_order_".concat(index));
    })]
  }) : !props.hide && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
      className: "".concat(!(props !== null && props !== void 0 && (_props$bannerData = props.bannerData) !== null && _props$bannerData !== void 0 && _props$bannerData.length) && "mb-s", " ").concat(props !== null && props !== void 0 && props.isDealSelection ? (DealGridListContainer_module_default())["sort-deal-selection"] : "", " ").concat(props.pageName == "upgrade" ? (DealGridListContainer_module_default())["upgrade-row"] : ""),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
        xs: 12,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "d-flex mb-2",
          children: [(props === null || props === void 0 ? void 0 : props.showUpgradeInfoBar) && isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (DealGridListContainer_module_default())["info-banner"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeInfoBar/* default */.Z, {
              type: "info",
              message: labels/* default.lbl_upgrade_info_banner */.Z.lbl_upgrade_info_banner
            })
          }), (!isTablet || isMobile) && /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
            className: "".concat((DealGridListContainer_module_default())["page-info"], " ").concat((DealGridListContainer_module_default())["page-info-text"], "  ").concat(props.isDealSelection ? (DealGridListContainer_module_default())["page-info-text-btm"] : "", " d-inline-flex align-items-center ml-0 pl-0 ").concat(props.pageName == "upgrade" ? (DealGridListContainer_module_default())["upgrade-page-info"] : ""),
            children: FilterText
          }), isTablet && !isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat((DealGridListContainer_module_default()).pillsDiv, " pl-0 w-100"),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
              className: "".concat((DealGridListContainer_module_default())["page-info"], " ").concat((DealGridListContainer_module_default())["page-info-text"], "  ").concat(props.isDealSelection ? (DealGridListContainer_module_default())["page-info-text-btm"] : "", " d-inline-flex align-items-center ml-0 pl-0 ").concat(props.pageName == "upgrade" ? (DealGridListContainer_module_default())["upgrade-page-info"] : ""),
              children: FilterText
            }), (props === null || props === void 0 ? void 0 : props.selectedPrice) && !(Number(props === null || props === void 0 ? void 0 : (_props$selectedPrice = props.selectedPrice) === null || _props$selectedPrice === void 0 ? void 0 : _props$selectedPrice.minValue).toFixed() == 0 && (props === null || props === void 0 ? void 0 : (_props$selectedPrice2 = props.selectedPrice) === null || _props$selectedPrice2 === void 0 ? void 0 : _props$selectedPrice2.maxValue) == props.originalMax) && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
              className: (DealGridListContainer_module_default()).pillSpacing,
              style: {
                marginRight: "8px"
              },
              name: "R".concat(props === null || props === void 0 ? void 0 : (_props$selectedPrice3 = props.selectedPrice) === null || _props$selectedPrice3 === void 0 ? void 0 : _props$selectedPrice3.minValue, " PM - R").concat(props === null || props === void 0 ? void 0 : (_props$selectedPrice4 = props.selectedPrice) === null || _props$selectedPrice4 === void 0 ? void 0 : _props$selectedPrice4.maxValue, " PM"),
              removeBtnHandler: function removeBtnHandler() {
                return props === null || props === void 0 ? void 0 : props.onPriceChange();
              }
            }), props === null || props === void 0 ? void 0 : (_props$selectedBrands = props.selectedBrands) === null || _props$selectedBrands === void 0 ? void 0 : _props$selectedBrands.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onBrandChange(false, item);
                }
              }, "selected_brand_".concat(item.label));
            }), props === null || props === void 0 ? void 0 : (_props$selectedProduc = props.selectedProducts) === null || _props$selectedProduc === void 0 ? void 0 : _props$selectedProduc.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: truncateString(item.label, 25),
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onProductFilterChange(false, item);
                }
              }, "selected_product_".concat(item.value));
            }), props === null || props === void 0 ? void 0 : (_props$selectedPromot = props.selectedPromotions) === null || _props$selectedPromot === void 0 ? void 0 : _props$selectedPromot.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onPromotionChange(false, item);
                }
              }, "selected_promotion_".concat(item.sku));
            }), props === null || props === void 0 ? void 0 : (_props$selectedPlanty = props.selectedPlantype) === null || _props$selectedPlanty === void 0 ? void 0 : _props$selectedPlanty.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onPlanTypeChange(false, item);
                }
              }, "selected_plan_type_".concat(item.sku));
            }), (props === null || props === void 0 ? void 0 : props.selectedPromoData) && !(Number(props === null || props === void 0 ? void 0 : (_props$selectedPromoD = props.selectedPromoData[0]) === null || _props$selectedPromoD === void 0 ? void 0 : _props$selectedPromoD.label).toFixed() == 0 && (props === null || props === void 0 ? void 0 : (_props$selectedPromoD2 = props.selectedPromoData[1]) === null || _props$selectedPromoD2 === void 0 ? void 0 : _props$selectedPromoD2.label) == constants/* MAX_DATA */.CS) && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
              className: (DealGridListContainer_module_default()).pillSpacing,
              style: {
                marginRight: "8px"
              },
              name: "".concat(props === null || props === void 0 ? void 0 : (_props$selectedPromoD3 = props.selectedPromoData[0]) === null || _props$selectedPromoD3 === void 0 ? void 0 : _props$selectedPromoD3.label, "GB - ").concat(props === null || props === void 0 ? void 0 : (_props$selectedPromoD4 = props.selectedPromoData[1]) === null || _props$selectedPromoD4 === void 0 ? void 0 : _props$selectedPromoD4.label, "GB"),
              removeBtnHandler: function removeBtnHandler() {
                return props === null || props === void 0 ? void 0 : props.onDataChange();
              }
            }), (props === null || props === void 0 ? void 0 : props.selectedMinutesData) && !(Number(props === null || props === void 0 ? void 0 : (_props$selectedMinute = props.selectedMinutesData[0]) === null || _props$selectedMinute === void 0 ? void 0 : _props$selectedMinute.label).toFixed() == 0 && (props === null || props === void 0 ? void 0 : (_props$selectedMinute2 = props.selectedMinutesData[1]) === null || _props$selectedMinute2 === void 0 ? void 0 : _props$selectedMinute2.label) == constants/* MAX_MINUTES */.UT) && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
              className: (DealGridListContainer_module_default()).pillSpacing,
              style: {
                marginRight: "8px"
              },
              name: "".concat(props === null || props === void 0 ? void 0 : (_props$selectedMinute3 = props.selectedMinutesData[0]) === null || _props$selectedMinute3 === void 0 ? void 0 : _props$selectedMinute3.label, " min - ").concat((props === null || props === void 0 ? void 0 : (_props$selectedMinute4 = props.selectedMinutesData[1]) === null || _props$selectedMinute4 === void 0 ? void 0 : _props$selectedMinute4.label) == constants/* MAX_MINUTES */.UT ? "Unlimited" : "".concat(props === null || props === void 0 ? void 0 : (_props$selectedMinute5 = props.selectedMinutesData[1]) === null || _props$selectedMinute5 === void 0 ? void 0 : _props$selectedMinute5.label, " min")),
              removeBtnHandler: function removeBtnHandler() {
                return props === null || props === void 0 ? void 0 : props.onMinutesChange();
              }
            }), (props === null || props === void 0 ? void 0 : props.selectedAirtimeData) && !(Number(props === null || props === void 0 ? void 0 : (_props$selectedAirtim = props.selectedAirtimeData[0]) === null || _props$selectedAirtim === void 0 ? void 0 : _props$selectedAirtim.label).toFixed() == 0 && (props === null || props === void 0 ? void 0 : (_props$selectedAirtim2 = props.selectedAirtimeData[1]) === null || _props$selectedAirtim2 === void 0 ? void 0 : _props$selectedAirtim2.label) == constants/* MAX_AIRTIME */.Vr) && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
              className: (DealGridListContainer_module_default()).pillSpacing,
              style: {
                marginRight: "8px"
              },
              name: "R".concat(props === null || props === void 0 ? void 0 : (_props$selectedAirtim3 = props.selectedAirtimeData[0]) === null || _props$selectedAirtim3 === void 0 ? void 0 : _props$selectedAirtim3.label, " - R").concat(props === null || props === void 0 ? void 0 : (_props$selectedAirtim4 = props.selectedAirtimeData[1]) === null || _props$selectedAirtim4 === void 0 ? void 0 : _props$selectedAirtim4.label),
              removeBtnHandler: function removeBtnHandler() {
                return props === null || props === void 0 ? void 0 : props.onAirtimeChange();
              }
            }), props === null || props === void 0 ? void 0 : (_props$selectedPlanna = props.selectedPlanname) === null || _props$selectedPlanna === void 0 ? void 0 : _props$selectedPlanna.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onPlanNameChange(false, item);
                }
              }, "selected_plan_name_".concat(item.sku));
            }), props === null || props === void 0 ? void 0 : (_props$selectedAccces = props.selectedAcccessories) === null || _props$selectedAccces === void 0 ? void 0 : _props$selectedAccces.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onAccessoriesChange(false, item);
                }
              }, "selected_accessories_".concat(item.sku));
            }), props === null || props === void 0 ? void 0 : (_props$selectedContra = props.selectedContractDuration) === null || _props$selectedContra === void 0 ? void 0 : _props$selectedContra.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: "".concat(item.label, " months"),
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onContractDurationChange(false, item);
                }
              }, "selected_contract_duration_".concat(item.sku));
            }), props === null || props === void 0 ? void 0 : (_props$selectedContra2 = props.selectedContractType) === null || _props$selectedContra2 === void 0 ? void 0 : _props$selectedContra2.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onContractTypeChange(false, item);
                }
              }, "selected_contract_type_".concat(item.sku));
            })]
          }), !isMobile && !isTablet && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat(props.pageName != "upgrade" ? (DealGridListContainer_module_default())["price-switch"] : "upgrade-dropdown", " ").concat(!isMobile ? "product-list-container deal-sort-dropdown" : "", " ").concat(props.pageName == "upgrade" ? (DealGridListContainer_module_default()).disabled : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
              className: (DealGridListContainer_module_default())["page-info-text"],
              children: "Sort by:"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
              data: dealSortValues,
              handleSelect: handleSelected,
              selectedValue: props === null || props === void 0 ? void 0 : props.selectedSortVal,
              customClass: props.page == "deal-list" ? (DealGridListContainer_module_default())["dropdown-item"] : (DealGridListContainer_module_default())["selection-drop-down"],
              menuClassName: "sort-menu",
              id: "deal-sort-menu"
            })]
          }), (isMobile || isTablet) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "".concat((DealGridListContainer_module_default())["deal-sort-native-container-class"], " ").concat(props.pageName == "upgrade" ? (DealGridListContainer_module_default()).disabled : ""),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(NativeSort/* default */.Z, {
              sortOptions: dealSortValues,
              handleSelect: handleSelected,
              selectedValue: props === null || props === void 0 ? void 0 : props.selectedSortVal,
              id: "deal-sort-menu-native"
            })
          })]
        }), (!isTablet || isMobile) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "d-flex",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat((DealGridListContainer_module_default()).pillsDiv, " pl-0 w-100"),
            children: [(props === null || props === void 0 ? void 0 : props.selectedPrice) && !(Number(props === null || props === void 0 ? void 0 : (_props$selectedPrice5 = props.selectedPrice) === null || _props$selectedPrice5 === void 0 ? void 0 : _props$selectedPrice5.minValue).toFixed() == 0 && (props === null || props === void 0 ? void 0 : (_props$selectedPrice6 = props.selectedPrice) === null || _props$selectedPrice6 === void 0 ? void 0 : _props$selectedPrice6.maxValue) == props.originalMax) && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
              className: (DealGridListContainer_module_default()).pillSpacing,
              style: {
                marginRight: "8px"
              },
              name: "R".concat(props === null || props === void 0 ? void 0 : (_props$selectedPrice7 = props.selectedPrice) === null || _props$selectedPrice7 === void 0 ? void 0 : _props$selectedPrice7.minValue, " PM - R").concat(props === null || props === void 0 ? void 0 : (_props$selectedPrice8 = props.selectedPrice) === null || _props$selectedPrice8 === void 0 ? void 0 : _props$selectedPrice8.maxValue, " PM"),
              removeBtnHandler: function removeBtnHandler() {
                return props === null || props === void 0 ? void 0 : props.onPriceChange();
              }
            }), props === null || props === void 0 ? void 0 : (_props$selectedBrands2 = props.selectedBrands) === null || _props$selectedBrands2 === void 0 ? void 0 : _props$selectedBrands2.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onBrandChange(false, item);
                }
              }, "selected_brand_".concat(item.label));
            }), props === null || props === void 0 ? void 0 : (_props$selectedProduc2 = props.selectedProducts) === null || _props$selectedProduc2 === void 0 ? void 0 : _props$selectedProduc2.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: truncateString(item.label, 25),
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onProductFilterChange(false, item);
                }
              }, "selected_product_".concat(item.value));
            }), props === null || props === void 0 ? void 0 : (_props$selectedPromot2 = props.selectedPromotions) === null || _props$selectedPromot2 === void 0 ? void 0 : _props$selectedPromot2.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onPromotionChange(false, item);
                }
              }, "selected_promotion_".concat(item.sku));
            }), props === null || props === void 0 ? void 0 : (_props$selectedPlanty2 = props.selectedPlantype) === null || _props$selectedPlanty2 === void 0 ? void 0 : _props$selectedPlanty2.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onPlanTypeChange(false, item);
                }
              }, "selected_plan_type_".concat(item.sku));
            }), (props === null || props === void 0 ? void 0 : props.selectedPromoData) && !(Number(props === null || props === void 0 ? void 0 : (_props$selectedPromoD5 = props.selectedPromoData[0]) === null || _props$selectedPromoD5 === void 0 ? void 0 : _props$selectedPromoD5.label).toFixed() == 0 && (props === null || props === void 0 ? void 0 : (_props$selectedPromoD6 = props.selectedPromoData[1]) === null || _props$selectedPromoD6 === void 0 ? void 0 : _props$selectedPromoD6.label) == constants/* MAX_DATA */.CS) && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
              className: (DealGridListContainer_module_default()).pillSpacing,
              style: {
                marginRight: "8px"
              },
              name: "".concat(props === null || props === void 0 ? void 0 : (_props$selectedPromoD7 = props.selectedPromoData[0]) === null || _props$selectedPromoD7 === void 0 ? void 0 : _props$selectedPromoD7.label, "GB - ").concat(props === null || props === void 0 ? void 0 : (_props$selectedPromoD8 = props.selectedPromoData[1]) === null || _props$selectedPromoD8 === void 0 ? void 0 : _props$selectedPromoD8.label, "GB"),
              removeBtnHandler: function removeBtnHandler() {
                return props === null || props === void 0 ? void 0 : props.onDataChange();
              }
            }), (props === null || props === void 0 ? void 0 : props.selectedMinutesData) && !(Number(props === null || props === void 0 ? void 0 : (_props$selectedMinute6 = props.selectedMinutesData[0]) === null || _props$selectedMinute6 === void 0 ? void 0 : _props$selectedMinute6.label).toFixed() == 0 && (props === null || props === void 0 ? void 0 : (_props$selectedMinute7 = props.selectedMinutesData[1]) === null || _props$selectedMinute7 === void 0 ? void 0 : _props$selectedMinute7.label) == constants/* MAX_MINUTES */.UT) && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
              className: (DealGridListContainer_module_default()).pillSpacing,
              style: {
                marginRight: "8px"
              },
              name: "".concat(props === null || props === void 0 ? void 0 : (_props$selectedMinute8 = props.selectedMinutesData[0]) === null || _props$selectedMinute8 === void 0 ? void 0 : _props$selectedMinute8.label, " min - ").concat((props === null || props === void 0 ? void 0 : (_props$selectedMinute9 = props.selectedMinutesData[1]) === null || _props$selectedMinute9 === void 0 ? void 0 : _props$selectedMinute9.label) == constants/* MAX_MINUTES */.UT ? "Unlimited" : "".concat(props === null || props === void 0 ? void 0 : (_props$selectedMinute10 = props.selectedMinutesData[1]) === null || _props$selectedMinute10 === void 0 ? void 0 : _props$selectedMinute10.label, " min")),
              removeBtnHandler: function removeBtnHandler() {
                return props === null || props === void 0 ? void 0 : props.onMinutesChange();
              }
            }), (props === null || props === void 0 ? void 0 : props.selectedAirtimeData) && !(Number(props === null || props === void 0 ? void 0 : (_props$selectedAirtim5 = props.selectedAirtimeData[0]) === null || _props$selectedAirtim5 === void 0 ? void 0 : _props$selectedAirtim5.label).toFixed() == 0 && (props === null || props === void 0 ? void 0 : (_props$selectedAirtim6 = props.selectedAirtimeData[1]) === null || _props$selectedAirtim6 === void 0 ? void 0 : _props$selectedAirtim6.label) == constants/* MAX_AIRTIME */.Vr) && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
              className: (DealGridListContainer_module_default()).pillSpacing,
              style: {
                marginRight: "8px"
              },
              name: "R".concat(props === null || props === void 0 ? void 0 : (_props$selectedAirtim7 = props.selectedAirtimeData[0]) === null || _props$selectedAirtim7 === void 0 ? void 0 : _props$selectedAirtim7.label, " - R").concat(props === null || props === void 0 ? void 0 : (_props$selectedAirtim8 = props.selectedAirtimeData[1]) === null || _props$selectedAirtim8 === void 0 ? void 0 : _props$selectedAirtim8.label),
              removeBtnHandler: function removeBtnHandler() {
                return props === null || props === void 0 ? void 0 : props.onAirtimeChange();
              }
            }), props === null || props === void 0 ? void 0 : (_props$selectedPlanna2 = props.selectedPlanname) === null || _props$selectedPlanna2 === void 0 ? void 0 : _props$selectedPlanna2.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onPlanNameChange(false, item);
                }
              }, "selected_plan_name_".concat(item.sku));
            }), props === null || props === void 0 ? void 0 : (_props$selectedAccces2 = props.selectedAcccessories) === null || _props$selectedAccces2 === void 0 ? void 0 : _props$selectedAccces2.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onAccessoriesChange(false, item);
                }
              }, "selected_accessories_".concat(item.sku));
            }), props === null || props === void 0 ? void 0 : (_props$selectedContra3 = props.selectedContractDuration) === null || _props$selectedContra3 === void 0 ? void 0 : _props$selectedContra3.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: "".concat(item.label, " months"),
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onContractDurationChange(false, item);
                }
              }, "selected_contract_duration_".concat(item.sku));
            }), props === null || props === void 0 ? void 0 : (_props$selectedContra4 = props.selectedContractType) === null || _props$selectedContra4 === void 0 ? void 0 : _props$selectedContra4.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
                className: (DealGridListContainer_module_default()).pillSpacing,
                style: {
                  marginRight: "8px"
                },
                name: item.label,
                removeBtnHandler: function removeBtnHandler() {
                  return props === null || props === void 0 ? void 0 : props.onContractTypeChange(false, item);
                }
              }, "selected_contract_type_".concat(item.sku));
            })]
          })
        })]
      })
    }), (props === null || props === void 0 ? void 0 : props.showUpgradeInfoBar) && !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (DealGridListContainer_module_default())["info-banner"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeInfoBar/* default */.Z, {
        type: "info",
        message: labels/* default.lbl_upgrade_info_banner */.Z.lbl_upgrade_info_banner
      })
    }), props !== null && props !== void 0 && props.items && props !== null && props !== void 0 && (_props$items3 = props.items) !== null && _props$items3 !== void 0 && _props$items3.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
      className: !props.isDealSelection ? "custom-grid-gutter mx-0" : "mx-0",
      children: [(props === null || props === void 0 ? void 0 : props.bannerData) && (props === null || props === void 0 ? void 0 : (_props$bannerData2 = props.bannerData) === null || _props$bannerData2 === void 0 ? void 0 : _props$bannerData2.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
        md: 12,
        className: "".concat((DealGridListContainer_module_default()).banner),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GridBanner/* default */.Z, {
          bannerData: props === null || props === void 0 ? void 0 : props.bannerData,
          redirectTo: handleRedirect
        })
      }), props.items.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          sm: 6,
          md: props.pageName == "upgrade" ? 6 : 4,
          lg: 4,
          xl: props.spanXl,
          className: props.isDealSelection ? (DealGridListContainer_module_default())["deal-cards-custom-spacing"] : "",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Link, {
            legacyBehavior: true,
            href: {
              pathname: "".concat(urlPrefix, "/deal-details-page/").concat(item.url_key)
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (DealGridListContainer_module_default())["dealcard-link"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(DealCard/* default */.Z, {
                  width: isMobile ? "14.12rem" : "auto",
                  height: "32.938rem",
                  img_width: "10rem",
                  maxHeight: "33.5rem",
                  img_height: "10rem",
                  width_mobile: "100%",
                  height_mobile: "29.313rem",
                  img_width_mobile: "7.5rem",
                  img_height_mobile: "7.5rem",
                  productName: item.name,
                  imgUrl: (0,helperServices/* getProductImageUrl */.G)(item, "image", "No_image"),
                  imgUrl_mobile: (0,helperServices/* getProductImageUrl */.G)(item, "small_image", "No_image_1"),
                  isOutOfStock: (0,helperServices/* checkIsOutOfStock */.zy)(item),
                  saveLabel: item === null || item === void 0 ? void 0 : item.save_monthly_recurring,
                  promotionLabel: (item === null || item === void 0 ? void 0 : item.promotion_tag) != null && item.promotion_tag_label ? item === null || item === void 0 ? void 0 : item.promotion_tag_label : '',
                  promotionLabelColor: item.promotion_tag_swatch,
                  promotionVariant: (0,helperServices/* getPromotionVariant */.HM)(item),
                  planName: item.package_description ? item.package_description : "",
                  highlights: (0,helperServices/* getHighlights */._Y)(item),
                  originalPrice: item.monthly_recurring ? item.monthly_recurring : "",
                  offerPrice: item.monthly_recurring ? item.monthly_recurring : "",
                  prevPrice: item.old_monthly_recurring ? item.old_monthly_recurring : "",
                  numberOfMonths: item.payment_terms_label,
                  buttonText: item.promotion_tag_label == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : !(props !== null && props !== void 0 && props.isDealSelection) ? labels/* default.lbl_see_details */.Z.lbl_see_details : labels/* default.lbl_deal_selection_page_card_btn */.Z.lbl_deal_selection_page_card_btn,
                  buttonHandler: function buttonHandler() {
                    return onSeeDetailsClick(item);
                  },
                  deal_end_date: item.deal_end_date,
                  deal_go_live_date: item.deal_go_live_date,
                  deal_label: item.deal_label,
                  is_deal_locked: item.is_deal_locked,
                  className: "deal-list-items",
                  campaignFlag: false
                })
              })
            })
          })
        }, item.sku);
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
      className: "".concat((DealGridListContainer_module_default()).containerheight, " custom-grid-empty-gutter"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyProductsContainer/* default */.Z, {
          resetFilter: resetFilterHandler,
          message: props.showQualifyDeals ? labels/* default.upgrade.lbl_deals_no_products */.Z.upgrade.lbl_deals_no_products : null,
          ctaHidden: props.showQualifyDeals
        })
      })
    }), totalPages > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(PageCounter/* default */.Z, {
      pageNumber: props === null || props === void 0 ? void 0 : (_props$pageInfo8 = props.pageInfo) === null || _props$pageInfo8 === void 0 ? void 0 : _props$pageInfo8.current_page,
      totalPages: totalPages,
      increasePageCount: increasePageCount,
      decreasePageCount: decreasePageCount,
      handleCurrentPageChange: function handleCurrentPageChange(cPage) {
        return _handleCurrentPageChange(cPage);
      },
      className: !isMobile ? "grid-pagination" : ""
    })]
  });
};

DealGridListContainer.defaultProps = {
  showUpgradeInfoBar: false
};
/* harmony default export */ var dealGridListContainer_DealGridListContainer = ((0,DependencyHelper.connect)(null, {
  displayHideFooter: footerAction/* displayHideFooter */.e
})(DealGridListContainer));
// EXTERNAL MODULE: ./components/molecules/product-range-section/productRange.jsx
var productRange = __webpack_require__(59564);
// EXTERNAL MODULE: ./components/molecules/buttonGroups/ButtonGroup.js
var ButtonGroup = __webpack_require__(76035);
// EXTERNAL MODULE: ./components/atoms/breadCrumb/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(55120);
// EXTERNAL MODULE: ./components/atoms/Seo/Seo.js
var Seo = __webpack_require__(22505);
// EXTERNAL MODULE: ./components/atoms/upgradeCheckBar/upgradeCheckBar.jsx
var upgradeCheckBar = __webpack_require__(42130);
// EXTERNAL MODULE: ./Redux/actions/upgradeAction.js
var upgradeAction = __webpack_require__(58486);
// EXTERNAL MODULE: ./services/renderComponent.js + 11 modules
var renderComponent = __webpack_require__(51859);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
// EXTERNAL MODULE: ./components/organisms/AffordabilityFilterToggle/AffordabilityFilterToggle.jsx
var AffordabilityFilterToggle = __webpack_require__(3304);
// EXTERNAL MODULE: ./services/upgradeService.js
var upgradeService = __webpack_require__(70098);
// EXTERNAL MODULE: ./utils/priceFilterUtils.js
var priceFilterUtils = __webpack_require__(96902);
;// CONCATENATED MODULE: ./pages/shopping/deals.js





function deals_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function deals_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? deals_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : deals_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function deals_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = deals_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function deals_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return deals_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return deals_arrayLikeToArray(o, minLen); }

function deals_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





































var bannerDataFetched = false;

var DealGridPage = function DealGridPage(props) {
  var _selectedFilter2, _productList$products2, _selectedFilter6, _selectedFilter7, _selectedFilter10, _selectedFilter11, _props$upgrade13, _props$upgrade14, _props$upgrade15, _selectedFilter14, _selectedFilter15, _props$metadata, _props$metadata2, _props$metadata3, _props$metadata4, _props$metadata5, _props$upgrade16, _props$upgrade16$cred, _props$upgrade17, _props$upgrade18, _props$upgrade18$cred, _selectedFilter16, _selectedFilter17, _selectedFilter18, _selectedFilter19, _selectedFilter20, _props$upgrade19, _selectedFilter21, _selectedFilter22, _selectedFilter23, _selectedFilter24, _selectedFilter25, _selectedFilter26, _selectedFilter27, _selectedFilter28, _selectedFilter29, _selectedFilter29$pro, _selectedFilter29$pro2, _selectedFilter30, _selectedFilter30$pro, _selectedFilter30$pro2, _selectedFilter31, _selectedFilter32, _selectedFilter32$min, _selectedFilter32$min2, _selectedFilter33, _selectedFilter33$min, _selectedFilter33$min2, _selectedFilter34, _selectedFilter35, _selectedFilter35$air, _selectedFilter35$air2, _selectedFilter36, _selectedFilter36$air, _selectedFilter36$air2, _selectedFilter37, _selectedFilter38, _productList$products3, _selectedFilter39, _selectedFilter40, _selectedFilter41, _selectedFilter42, _selectedFilter43, _selectedFilter44, _selectedFilter45, _selectedFilter46, _selectedFilter47, _selectedFilter48, _selectedFilter49, _selectedFilter49$pro, _selectedFilter49$pro2, _selectedFilter50, _selectedFilter50$pro, _selectedFilter50$pro2, _selectedFilter51, _selectedFilter52, _selectedFilter52$min, _selectedFilter52$min2, _selectedFilter53, _selectedFilter53$min, _selectedFilter53$min2, _selectedFilter54, _selectedFilter55, _selectedFilter55$air, _selectedFilter55$air2, _selectedFilter56, _selectedFilter56$air, _selectedFilter56$air2, _selectedFilter57, _selectedFilter58, _productList$products4, _productList$products5, _productList$products6, _props$sections;

  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 1024;
  var router = (0,next_router.useRouter)();
  var dispatch = (0,DependencyHelper.useDispatch)();
  var dynamicRoute = (0,helperServices/* dynamicBreadCrumb */.sz)();

  var _useState = (0,react.useState)(false),
      showComp = _useState[0],
      setShowComp = _useState[1];

  var _useState2 = (0,react.useState)(false),
      viewExecuted = _useState2[0],
      setViewExecuted = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      sectionLvls = _useState3[0],
      setSectionLvls = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      bannerData = _useState4[0],
      setBannerData = _useState4[1];

  var _useState5 = (0,react.useState)({}),
      productList = _useState5[0],
      setProductList = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      productListLoaded = _useState6[0],
      setProductListLoaded = _useState6[1];

  var _useState7 = (0,react.useState)(props.selectedFilter),
      selectedFilter = _useState7[0],
      setSelectedFilter = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      allBrands = _useState8[0],
      setAllBrands = _useState8[1];

  var _useState9 = (0,react.useState)([]),
      allPromotions = _useState9[0],
      setAllPromotions = _useState9[1];

  var _useState10 = (0,react.useState)([]),
      plantypes = _useState10[0],
      setPlantypes = _useState10[1];

  var _useState11 = (0,react.useState)([]),
      plannames = _useState11[0],
      setPlannames = _useState11[1];

  var _useState12 = (0,react.useState)([]),
      accessories = _useState12[0],
      setAccessories = _useState12[1];

  var _useState13 = (0,react.useState)([]),
      contractDuration = _useState13[0],
      setContractDuration = _useState13[1];

  var _useState14 = (0,react.useState)([]),
      contractType = _useState14[0],
      setContractType = _useState14[1];

  var _useState15 = (0,react.useState)({}),
      priceValue = _useState15[0],
      _setPriceValue = _useState15[1];

  var _useState16 = (0,react.useState)((0,helperServices/* getCurrentSortVal */.XH)(router.asPath, true)),
      sortProductsBy = _useState16[0],
      setSortProductsBy = _useState16[1];

  var _useState17 = (0,react.useState)("filter"),
      featureSelected = _useState17[0],
      setFeatureSelected = _useState17[1];

  var _useState18 = (0,react.useState)(false),
      isPageUpdated = _useState18[0],
      setIsPageUpdated = _useState18[1];

  var _useState19 = (0,react.useState)(false),
      updateContainer = _useState19[0],
      setUpdateContainer = _useState19[1];

  var _useState20 = (0,react.useState)({}),
      categoryList = _useState20[0],
      setCategoryList = _useState20[1];

  var _useState21 = (0,react.useState)([]),
      contractsList = _useState21[0],
      setContractsData = _useState21[1];

  var _useState22 = (0,react.useState)({}),
      viewData = _useState22[0],
      setViewData = _useState22[1];

  var _useState23 = (0,react.useState)(constants/* MAX_MONTHLY_RECURRING */._V),
      maxPrice = _useState23[0],
      setMaxPrice = _useState23[1];

  var _useState24 = (0,react.useState)(0),
      aggMaxPrice = _useState24[0],
      setAggMaxPrice = _useState24[1];

  var _useState25 = (0,react.useState)(0),
      aggMinPrice = _useState25[0],
      setAggMinPrice = _useState25[1];

  var _useState26 = (0,react.useState)(false),
      showQualifyDeals = _useState26[0],
      setShowQualifyDeals = _useState26[1];

  var _useState27 = (0,react.useState)(false),
      isProductsUpgrade = _useState27[0],
      setIsProductsUpgrade = _useState27[1];

  var _useState28 = (0,react.useState)(null),
      selectedCategory = _useState28[0],
      setSelectedCategory = _useState28[1];

  var _useState29 = (0,react.useState)([]),
      priceFilterData = _useState29[0],
      setPriceFilterData = _useState29[1];

  var _useState30 = (0,react.useState)([]),
      missingPriceFilterData = _useState30[0],
      setMissingPriceFilterData = _useState30[1];

  var _useState31 = (0,react.useState)([]),
      affordablePriceRange = _useState31[0],
      setAffordablePriceRange = _useState31[1];

  var _useState32 = (0,react.useState)([]),
      missingAffordablePriceRange = _useState32[0],
      setMissingAffordablePriceRange = _useState32[1];

  var _useState33 = (0,react.useState)([]),
      aggregators = _useState33[0],
      setAggregators = _useState33[1];

  var pageName = "shopping: deals grid: browse all deals";

  var _useState34 = (0,react.useState)(false),
      renderdEmpty = _useState34[0],
      setRenderdEmpty = _useState34[1];

  var _useState35 = (0,react.useState)(false),
      showFilterError = _useState35[0],
      setFilterError = _useState35[1];

  var _useState36 = (0,react.useState)(false),
      showFilterByProduct = _useState36[0],
      setShowFilterByProduct = _useState36[1];

  var _useState37 = (0,react.useState)(false),
      didMount = _useState37[0],
      setDidMount = _useState37[1];

  var _useState38 = (0,react.useState)("default"),
      initAggregationsType = _useState38[0],
      setInitAggregationsType = _useState38[1];

  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < constants/* MOBILE_WIDTH */.P_;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var legacyEnv = (config_default()).envConfigs[env].legacyEnv;

  var joinAllData = function joinAllData(array) {
    var newKeys = [].concat.apply([], array);
    var allkeys = newKeys.join(",");
    return allkeys;
  };

  (0,react.useEffect)(function () {
    setDidMount(true);
    initAggregations();
    window.addEventListener("popstate", onBackButtonClick);
    return function () {
      window.removeEventListener("popstate", onBackButtonClick);
    };
  }, []);
  (0,react.useEffect)(function () {
    var _selectedFilter;

    //Fetch updated max price in price filter based on selectedCategory MO-3427
    var curCategoryId = (_selectedFilter = selectedFilter) === null || _selectedFilter === void 0 ? void 0 : _selectedFilter.selectedCategory;

    if (curCategoryId && initAggregationsType == "default") {
      setInitAggregationsType("updated");
      initAggregations(true);
    }
  }, [(_selectedFilter2 = selectedFilter) === null || _selectedFilter2 === void 0 ? void 0 : _selectedFilter2.selectedCategory]);
  var breadcrumbs = (0,breadcrumbService/* breadcrumbGenerator */.G)().deals.reverse();

  var setPageSiteLevel = function setPageSiteLevel() {
    var section_lvls = {};
    var index = 0;

    var _iterator = deals_createForOfIteratorHelper(breadcrumbs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        index = index + 1;
        if (index > 4) break;
        section_lvls["page_site_section_lvl_".concat(index)] = item.label;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return section_lvls;
  };

  var isEligible = function isEligible() {
    var _props$upgrade, _props$upgrade2, _props$upgrade2$upgra, _props$upgrade3, _props$upgrade3$credi;

    return props.upgradeChecksEnabled && (props === null || props === void 0 ? void 0 : (_props$upgrade = props.upgrade) === null || _props$upgrade === void 0 ? void 0 : _props$upgrade.upgradeCheckDone) && (props === null || props === void 0 ? void 0 : (_props$upgrade2 = props.upgrade) === null || _props$upgrade2 === void 0 ? void 0 : (_props$upgrade2$upgra = _props$upgrade2.upgradeResponse) === null || _props$upgrade2$upgra === void 0 ? void 0 : _props$upgrade2$upgra.upgradeEligible) && (props === null || props === void 0 ? void 0 : (_props$upgrade3 = props.upgrade) === null || _props$upgrade3 === void 0 ? void 0 : (_props$upgrade3$credi = _props$upgrade3.creditFilters) === null || _props$upgrade3$credi === void 0 ? void 0 : _props$upgrade3$credi.total_monthly_payment) || props.isShowAffordDeal;
  };

  var handleRangeChange = function handleRangeChange(val) {
    var curRange = Number(val);
    var section_lvls = setPageSiteLevel();
    var total = categoryList !== null && categoryList !== void 0 && categoryList.categories ? categoryList.categories.length : 0;

    for (var i = 0; i < total; i++) {
      if (curRange === Number(categoryList.categories[i].id)) {
        var _selectedCategory;

        if (Number((_selectedCategory = selectedCategory) === null || _selectedCategory === void 0 ? void 0 : _selectedCategory.id) === curRange) {
          curRange = null;
        }

        analyticsUtag/* link */.p4(deals_objectSpread(deals_objectSpread({
          page_tool_event: "use",
          page_tool_name: "shopping: deals grid: deal range filter",
          filter_query: "".concat(categoryList.categories[i].name)
        }, section_lvls), analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "channel_type", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type"])));
        break;
      }
    }

    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      selectedCategory: curRange
    }));
    (0,filterDealService/* getDealFilterByRange */.fC)(curRange, showQualifyDeals).then(reloadPageData);
    return (props === null || props === void 0 ? void 0 : props.handleProductRange) && props.handleProductRange(curRange);
  };

  var toggleHandler = function toggleHandler(btnClicked) {
    setFeatureSelected(btnClicked);
    setShowComp(!showComp);
    props.toggleFilters(true);

    if (btnClicked.toLowerCase() === "search") {
      setShowFilterByProduct(true);
    } else {
      setShowFilterByProduct(false);
    }
  };

  var changeState = function changeState() {
    setShowComp(!showComp);
  };

  var updateFilterCriteria = function updateFilterCriteria() {
    if (selectedFilter.updateFilterCriteria || (allBrands === null || allBrands === void 0 ? void 0 : allBrands.length) === 0) {
      var plantypePresent = false;
      var plannamePresent = false;
      var accessoriesPresent = false;
      var contractDurationPresent = false;
      var contractTypePresent = false;

      if (productList && productList.products) {
        var _productList$products;

        var aggregations = productList === null || productList === void 0 ? void 0 : (_productList$products = productList.products) === null || _productList$products === void 0 ? void 0 : _productList$products.aggregations;
        (aggregations || []).map(function (item) {
          if (item.attribute_code.toLowerCase() === "plan_type") {
            setPlantypes(item.options);
            plantypePresent = true;
          }

          if (item.attribute_code.toLowerCase() === "plan_name") {
            setPlannames(item.options);
            plannamePresent = true;
          }

          if (item.attribute_code.toLowerCase() === "accessories") {
            setAccessories(item.options);
            accessoriesPresent = true;
          }

          if (item.attribute_code.toLowerCase() === "payment_terms") {
            setContractDuration(item.options);
            contractDurationPresent = true;
          }

          if (item.attribute_code.toLowerCase() === "contract_type") {
            setContractType(item.options);
            contractTypePresent = true;
          }
        });

        if (!plantypePresent) {
          setPlantypes([]);
        }

        if (!plannamePresent) {
          setPlannames([]);
        }

        if (!accessoriesPresent) {
          setAccessories([]);
        }

        if (!contractDurationPresent) {
          setContractDuration([]);
        }

        if (!contractTypePresent) {
          setContractType([]);
        }
      }
    }
  };

  var getCategoryGridData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var categoryListData, _categoryListData$err;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,productListService/* getAllCategories */.tG)(true, props === null || props === void 0 ? void 0 : props.defaultCategoryId);

            case 2:
              categoryListData = _context.sent;

              if (categoryListData && categoryListData.errors) {
                analyticsUtag/* link */.p4({
                  page_name: pageName,
                  page_form_event: "error",
                  page_errors: "".concat(categoryListData.errors[0] ? (_categoryListData$err = categoryListData.errors) === null || _categoryListData$err === void 0 ? void 0 : _categoryListData$err[0].message : ""),
                  page_errors_code: "dlp-dxl-g-ac-".concat(categoryListData.status)
                });
              }

              setCategoryList(categoryListData);
              return _context.abrupt("return", categoryListData);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getCategoryGridData() {
      return _ref.apply(this, arguments);
    };
  }();

  var isFilterApplied = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(sortParam) {
      var filter, _props$upgrade4, _props$upgrade4$credi, _props$upgrade5, _props$upgrade5$credi, _ref3, maxValue, minValue, productListData, _productListData, _productListData2, _productListData$erro;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              _context2.next = 3;
              return (0,filterDealService/* parseFilterQuery */.w6)(decodeURIComponent(window.location.search));

            case 3:
              filter = _context2.sent;

              if (filter.isShowQualifying) {
                setShowQualifyDeals(filter.isShowQualifying === "true");

                if (filter.isShowQualifying === "true" && (props === null || props === void 0 ? void 0 : (_props$upgrade4 = props.upgrade) === null || _props$upgrade4 === void 0 ? void 0 : (_props$upgrade4$credi = _props$upgrade4.creditFilters) === null || _props$upgrade4$credi === void 0 ? void 0 : _props$upgrade4$credi.financeIndicator) === "N") {
                  filter.deviceInstallment = Number(props === null || props === void 0 ? void 0 : (_props$upgrade5 = props.upgrade) === null || _props$upgrade5 === void 0 ? void 0 : (_props$upgrade5$credi = _props$upgrade5.creditFilters) === null || _props$upgrade5$credi === void 0 ? void 0 : _props$upgrade5$credi.deviceInstallment);
                }
              }

              if (filter !== null && filter !== void 0 && filter.monthly_recurring) {
                _ref3 = (filter === null || filter === void 0 ? void 0 : filter.monthly_recurring) || {}, maxValue = _ref3.maxValue, minValue = _ref3.minValue;

                _setPriceValue({
                  minValue: minValue,
                  maxValue: maxValue
                });
              }

              if (!(JSON.stringify(filter) != JSON.stringify(selectedFilter) || isPageUpdated)) {
                _context2.next = 23;
                break;
              }

              setSelectedFilter(selectedFilter = filter);

              if (!Object.keys(selectedFilter).length) {
                _context2.next = 17;
                break;
              }

              setProductListLoaded(false);
              _context2.next = 12;
              return (0,filterDealService/* getFilterDealList */.UA)(filter, sortParam, (0,helperServices/* getCurrentPageNumber */.GW)(router.asPath), labels/* default.pagination_max_items_per_page */.Z.pagination_max_items_per_page);

            case 12:
              productListData = _context2.sent;

              if (productListData) {
                setProductList(productListData);
                setProductListLoaded(true);
              }

              if ((_productListData = productListData) !== null && _productListData !== void 0 && _productListData.contract_type_desc) {
                setContractsData((_productListData2 = productListData) === null || _productListData2 === void 0 ? void 0 : _productListData2.contract_type_desc);
              }

              _context2.next = 22;
              break;

            case 17:
              setProductListLoaded(false);
              _context2.next = 20;
              return (0,filterDealService/* getDealList */.Ao)(sortParam, (0,helperServices/* getCurrentPageNumber */.GW)(router.asPath), labels/* default.pagination_max_items_per_page */.Z.pagination_max_items_per_page);

            case 20:
              productListData = _context2.sent;

              if (productListData) {
                setProductList(productListData);
                setProductListLoaded(true);
              }

            case 22:
              if (productListData && productListData.errors) {
                analyticsUtag/* link */.p4({
                  page_name: pageName,
                  page_form_event: "error",
                  page_errors: "".concat(productListData.errors[0] ? (_productListData$erro = productListData.errors) === null || _productListData$erro === void 0 ? void 0 : _productListData$erro[0].message : ""),
                  page_errors_code: "dlp-m-g-fd-".concat(productListData.status)
                });
              }

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function isFilterApplied(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var loadPageData = function loadPageData() {
    var currentSortVal = (0,helperServices/* getCurrentSortVal */.XH)(router.asPath, true);
    var sortParam = (0,filterDealService/* getSortQueryForDeals */.Uv)(currentSortVal);
    setSortProductsBy(currentSortVal);
    (0,helperServices/* updatePathInBreadCrumb */.DQ)(router);
    isFilterApplied(sortParam);
  };

  var reloadPageData = function reloadPageData() {
    (0,helperServices/* showSpinner */.yh)();
    setIsPageUpdated(true);
  };

  var handleResetFilter = function handleResetFilter(type) {
    if (type === "price") {
      if (isEligible()) {
        var curMaxPrice = getMaxPrice();
        var curPriceValue = {
          minValue: 0,
          maxValue: curMaxPrice
        };
        setShowQualifyDeals(true);
        setMaxPrice(curMaxPrice);

        _setPriceValue(curPriceValue);

        return (0,filterDealService/* getDealFilterByPrice */.GE)(deals_objectSpread(deals_objectSpread({}, curPriceValue), {}, {
          isShowQualifying: "true",
          skipPageNumber: true
        })).then(reloadPageData);
      } else {
        setMaxPrice(aggMaxPrice);

        _setPriceValue({
          minValue: 0,
          maxValue: aggMaxPrice
        });

        return (0,filterDealService/* getDealFilterByPrice */.GE)({
          skipPageNumber: true,
          minValue: aggMinPrice,
          maxValue: aggMaxPrice
        }).then(reloadPageData);
      }
    }

    if (isEligible()) {
      var _curMaxPrice = getMaxPrice();

      setShowQualifyDeals(true);
      setMaxPrice(_curMaxPrice);

      _setPriceValue({
        minValue: 0,
        maxValue: _curMaxPrice
      });

      return (0,filterDealService/* resetDealsToPrice */.T_)("monthly_recurring", 0, _curMaxPrice, router).then(reloadPageData);
    }

    setMaxPrice(aggMaxPrice);

    _setPriceValue({
      minValue: 0,
      maxValue: aggMaxPrice
    });

    if (!isMobile) {
      var section_lvls = setPageSiteLevel();
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_name: "shopping: deals grid: browse all deals",
        page_channel: "shopping",
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: browse all deals: reset all filters",
        page_master_tab: "personal"
      }, section_lvls));
    }

    return (0,filterDealService/* resetFilter */.sx)().then(reloadPageData);
  };

  var handleBrandChange = function handleBrandChange(flag, brandObjObj) {
    var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var brandArr = getSelectedBrands(flag, brandObjObj);
    var selectedBrands = brandArr.map(function (brand) {
      return brand.label;
    });

    if (flag) {
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: brand filter",
        filter_query: selectedBrands.toString()
      }, viewData));
    }

    if (reload) {
      (0,filterDealService/* getDealFilterByBrands */.Rl)(brandArr).then(reloadPageData);
    }
  };

  var getSelectedBrands = function getSelectedBrands(flag, brandObjObj) {
    var brandArr = (0,helperServices/* manipulateFilter */.Zf)(flag, selectedFilter, brandObjObj, "brands");
    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      brands: brandArr
    }));
    return brandArr;
  };

  var handlePromotionChange = function handlePromotionChange(flag, promotionObj) {
    var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var promotionArr = getSelectedPromotion(flag, promotionObj);
    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      promotions: promotionArr
    }));

    if (flag) {
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: promotions filter",
        filter_query: promotionObj === null || promotionObj === void 0 ? void 0 : promotionObj.label
      }, viewData));
    }

    if (reload) {
      (0,filterDealService/* getDealFilterByPromotions */.h3)(promotionArr).then(reloadPageData);
    }
  };

  var getSelectedPromotion = function getSelectedPromotion(flag, promotionObj) {
    var promotionArr = (0,helperServices/* manipulateFilter */.Zf)(flag, selectedFilter, promotionObj, "promotions");
    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      promotions: promotionArr
    }));
    return promotionArr;
  };

  var handleContractTypeChange = function handleContractTypeChange(flag, contractValue) {
    var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var ctypeArr = getSelectedContractType(flag, contractValue);

    if (flag) {
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: contract type filter",
        filter_query: contractValue === null || contractValue === void 0 ? void 0 : contractValue.label
      }, viewData));
    }

    if (reload) {
      (0,filterDealService/* getDealFilterByContractType */.m2)(ctypeArr).then(reloadPageData);
    }
  };

  var getSelectedContractType = function getSelectedContractType(flag, contractValue) {
    var ctypeArr = !flag ? [] : [contractValue];
    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      contracttype: ctypeArr
    }));
    return ctypeArr;
  };

  var handlePlanTypeChange = function handlePlanTypeChange(flag, planTypeValue) {
    var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var planTypeArr = getSelectedPlanType(flag, planTypeValue);

    if (flag) {
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: plan type filter",
        filter_query: planTypeValue === null || planTypeValue === void 0 ? void 0 : planTypeValue.label
      }, viewData));
    }

    if (reload) {
      (0,filterDealService/* getDealFilterByPlanType */.qf)(planTypeArr).then(reloadPageData);
    }
  };

  var getSelectedPlanType = function getSelectedPlanType(flag, planTypeValue) {
    var planTypeArr = (0,helperServices/* manipulateFilter */.Zf)(flag, selectedFilter, planTypeValue, "plantypes");
    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      plantypes: planTypeArr
    }));
    return planTypeArr;
  };

  var handlePlanNameChange = function handlePlanNameChange(flag, planNameValue) {
    var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var planNameArr = getSelectedPlanName(flag, planNameValue);

    if (flag) {
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: plan name filter",
        filter_query: planNameValue === null || planNameValue === void 0 ? void 0 : planNameValue.label
      }, viewData));
    }

    if (reload) {
      (0,filterDealService/* getDealFilterByPlanName */.Sq)(planNameArr).then(reloadPageData);
    }
  };

  var getSelectedPlanName = function getSelectedPlanName(flag, planNameValue) {
    var planNameArr = (0,helperServices/* manipulateFilter */.Zf)(flag, selectedFilter, planNameValue, "plannames");
    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      plannames: planNameArr
    }));
    return planNameArr;
  };

  var handleAccessoriesChange = function handleAccessoriesChange(flag, accessoriesObj) {
    var accessoriesArr = getSelectedAccessories(flag, accessoriesObj);
    (0,filterDealService/* getDealFilterByAccessories */.UM)(accessoriesArr).then(reloadPageData);

    if (flag) {
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: accessories filter",
        filter_query: accessoriesObj === null || accessoriesObj === void 0 ? void 0 : accessoriesObj.label
      }, viewData));
    }
  };

  var getSelectedAccessories = function getSelectedAccessories(flag, accessoriesObj) {
    var accessoriesArr = (0,helperServices/* manipulateFilter */.Zf)(flag, selectedFilter, accessoriesObj, "accessories");
    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      accessories: accessoriesArr
    }));
    return accessoriesArr;
  };

  var handleContractDurationChange = function handleContractDurationChange(flag, contractdurationObj) {
    var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var contractDurationArr = getSelectedContractDuration(flag, contractdurationObj);

    if (flag) {
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: contract duration type filter",
        filter_query: contractdurationObj === null || contractdurationObj === void 0 ? void 0 : contractdurationObj.label
      }, viewData));
    }

    if (reload) {
      (0,filterDealService/* getDealFilterByContractDuration */.aL)(contractDurationArr).then(reloadPageData);
    }
  };

  var getSelectedContractDuration = function getSelectedContractDuration(flag, contractdurationObj) {
    var contractDurationArr = (0,helperServices/* manipulateFilter */.Zf)(flag, selectedFilter, contractdurationObj, "contractduration");
    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      contractduration: contractDurationArr
    }));
    return contractDurationArr;
  };

  var handleCategoryChange = function handleCategoryChange(category) {
    getSelectedCategory(category);
    (0,filterDealService/* getDealFilterByCategory */.Ph)(category === null || category === void 0 ? void 0 : category.id, false, showQualifyDeals).then(reloadPageData);
  };

  var getSelectedCategory = function getSelectedCategory(category) {
    var _selectedCategory2;

    if (((_selectedCategory2 = selectedCategory) === null || _selectedCategory2 === void 0 ? void 0 : _selectedCategory2.id) !== (category === null || category === void 0 ? void 0 : category.id)) {
      setSelectedCategory(selectedCategory = category);
      updateCategoryOnFilter(category === null || category === void 0 ? void 0 : category.id);
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: category filter",
        filter_query: category === null || category === void 0 ? void 0 : category.name
      }, viewData));
    } else {
      setSelectedCategory(selectedCategory = null);
    }
  };

  var handleSubCategoryChange = function handleSubCategoryChange(flag, subCategoryObj) {
    var _selectedFilter3;

    var subCategoryArr = ((_selectedFilter3 = selectedFilter) !== null && _selectedFilter3 !== void 0 && _selectedFilter3.selectedSubCategory ? selectedFilter.selectedSubCategory : "") ? (0,toConsumableArray/* default */.Z)(selectedFilter.selectedSubCategory) : [];
    var isPresent = subCategoryArr.findIndex(function (item) {
      return Number(subCategoryObj.id) === Number(item);
    });

    if (isPresent === -1) {
      subCategoryArr.push(subCategoryObj.id.toString());
    } else {
      subCategoryArr.filter(function (item, index) {
        if (Number(item) === Number(subCategoryObj.id)) {
          subCategoryArr.splice(index, 1);
        }
      });
    }

    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      selectedSubCategory: subCategoryArr
    }));
    (0,filterDealService/* getDealFilterBySubCategory */.MT)(subCategoryArr, showQualifyDeals).then(reloadPageData);

    if (flag) {
      var _selectedCategory3;

      analyticsUtag/* link */.p4(deals_objectSpread({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: " + ((_selectedCategory3 = selectedCategory) === null || _selectedCategory3 === void 0 ? void 0 : _selectedCategory3.name) + " filter",
        filter_query: subCategoryObj === null || subCategoryObj === void 0 ? void 0 : subCategoryObj.name
      }, viewData));
    }
  };

  var handleDataChange = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(value) {
      var reload,
          reset,
          dataObj,
          _args3 = arguments;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              reload = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
              reset = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
              _context3.next = 4;
              return getSelectedData(value);

            case 4:
              dataObj = _context3.sent;
              analyticsUtag/* link */.p4(deals_objectSpread({
                page_tool_event: "use",
                page_tool_name: "shopping: deals grid: data filter",
                filter_query: "".concat(value.min || 0, ",").concat(value.max || constants/* MAX_DATA */.CS)
              }, viewData));

              if (reload) {
                (0,filterDealService/* getDealFilterByData */.m)(reset ? {} : dataObj).then(reloadPageData);
              }

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDataChange(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var getSelectedData = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(value) {
      var dataObj, dtArr;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dataObj = {
                minValue: value.min,
                maxValue: value.max
              };
              _context4.next = 3;
              return (0,filterDealService/* getFilterCriteriaFromValue */.L7)(value);

            case 3:
              dtArr = _context4.sent;
              setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
                promo_data: dtArr
              }));
              return _context4.abrupt("return", dataObj);

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function getSelectedData(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  var onResetData = function onResetData() {
    handleDataChange({
      min: 0,
      max: constants/* MAX_DATA */.CS
    }, true, true);
  };

  var handleAirTimeChange = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(value) {
      var reload,
          reset,
          airtimeObj,
          _args5 = arguments;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              reload = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;
              reset = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : false;
              _context5.next = 4;
              return getSelectedAirTime(value);

            case 4:
              airtimeObj = _context5.sent;
              analyticsUtag/* link */.p4(deals_objectSpread({
                page_tool_event: "use",
                page_tool_name: "shopping: deals grid: airtime filter",
                filter_query: "".concat(value.min || 0, ",").concat(value.max || constants/* MAX_AIRTIME */.Vr)
              }, viewData));

              if (reload) {
                (0,filterDealService/* getDealFilterByAirTime */.QW)(reset ? {} : airtimeObj).then(reloadPageData);
              }

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleAirTimeChange(_x4) {
      return _ref6.apply(this, arguments);
    };
  }();

  var getSelectedAirTime = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(value) {
      var airtimeObj, dtArr;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              airtimeObj = {
                minValue: value.min,
                maxValue: value.max
              };
              _context6.next = 3;
              return (0,filterDealService/* getFilterCriteriaFromValue */.L7)(value);

            case 3:
              dtArr = _context6.sent;
              setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
                airtime: dtArr
              }));
              return _context6.abrupt("return", airtimeObj);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function getSelectedAirTime(_x5) {
      return _ref7.apply(this, arguments);
    };
  }();

  var onResetAirtime = function onResetAirtime() {
    handleAirTimeChange({
      min: 0,
      max: constants/* MAX_AIRTIME */.Vr
    }, true, true);
  };

  var handleVoiceMinutesChange = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(value) {
      var reload,
          reset,
          voiceObj,
          _args7 = arguments;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              reload = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : true;
              reset = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : false;
              _context7.next = 4;
              return getSelectedVoiceMinutes(value);

            case 4:
              voiceObj = _context7.sent;
              analyticsUtag/* link */.p4(deals_objectSpread({
                page_tool_event: "use",
                page_tool_name: "shopping: deals grid: voice filter",
                filter_query: "".concat(value.min || 0, ",").concat(value.max || constants/* MAX_MINUTES */.UT)
              }, viewData));

              if (reload) {
                (0,filterDealService/* getDealFilterByVoiceMinutes */.vi)(reset ? {} : voiceObj).then(reloadPageData);
              }

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function handleVoiceMinutesChange(_x6) {
      return _ref8.apply(this, arguments);
    };
  }();

  var getSelectedVoiceMinutes = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(value) {
      var voiceObj, dtArr;
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              voiceObj = {
                minValue: value.min,
                maxValue: value.max
              };
              _context8.next = 3;
              return (0,filterDealService/* getFilterCriteriaFromValue */.L7)(value);

            case 3:
              dtArr = _context8.sent;
              setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
                minutes: dtArr
              }));
              return _context8.abrupt("return", voiceObj);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function getSelectedVoiceMinutes(_x7) {
      return _ref9.apply(this, arguments);
    };
  }();

  var onResetMinutes = function onResetMinutes() {
    handleVoiceMinutesChange({
      min: 0,
      max: constants/* MAX_MINUTES */.UT
    }, true, true);
  };

  var handlePriceChange = function handlePriceChange(value) {
    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var priceObj = getSelectedPrice(value);
    analyticsUtag/* link */.p4(deals_objectSpread({
      page_tool_event: "use",
      page_tool_name: "shopping: deals grid: price filter",
      filter_query: "".concat(priceObj.minValue || 0, ",").concat(priceObj.maxValue || aggMaxPrice)
    }, viewData));

    if (reload) {
      (0,filterDealService/* getDealFilterByPrice */.GE)(reset ? {} : priceObj).then(reloadPageData);
    }
  };

  var getSelectedPrice = function getSelectedPrice(value) {
    var _ref10 = value || {},
        min = _ref10.min,
        max = _ref10.max;

    var priceObj = {
      type: types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
      minValue: min,
      maxValue: max,
      isShowQualifying: showQualifyDeals ? "true" : "false",
      skipPageNumber: true
    };

    _setPriceValue({
      minValue: min,
      maxValue: max
    });

    return priceObj;
  };

  var onResetPrice = function onResetPrice() {
    handlePriceChange({
      min: 0,
      max: isEligible() && showQualifyDeals ? getMaxPrice() : aggMaxPrice
    });
  };

  var handleSortBy = function handleSortBy(flag, val) {
    setSortProductsBy(val);
    (0,filterDealService/* getDealsFilterBySort */.NP)(val).then(reloadPageData);

    if (flag) {
      analyticsUtag/* link */.p4(deals_objectSpread(deals_objectSpread(deals_objectSpread({}, viewData), analyticsUtag/* getUtagData */.GS(["channel_type"])), {}, {
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: sort filter",
        filter_query: val
      }));
    }
  };

  var handleSeeDetailsClick = function handleSeeDetailsClick(item) {
    var categories = item.categories;

    var analyticsData = deals_objectSpread({
      link_type: "use",
      link_name: "shopping: deal grid: view deal details",
      sales_product_category: [categories && categories[0] && categories[0].name],
      sales_product_id: [item === null || item === void 0 ? void 0 : item.name],
      sales_product_price: [item === null || item === void 0 ? void 0 : item.monthly_recurring],
      sales_product_quantity: 1,
      sales_order_discount: [item === null || item === void 0 ? void 0 : item.save_monthly_recurring],
      sales_promo_name: [item === null || item === void 0 ? void 0 : item.promotion_tag_label]
    }, viewData);

    if (item !== null && item !== void 0 && item.deal_end_date) {
      analyticsData.deal_expiry = (0,helperServices/* getDealExpiryTime */.uJ)(item === null || item === void 0 ? void 0 : item.deal_end_date);
    }

    analyticsUtag/* link */.p4(analyticsData);
  };

  var handleProductFilterChange = function handleProductFilterChange(flag, productObj) {
    var productArr = (0,helperServices/* manipulateFilter */.Zf)(flag, selectedFilter, productObj, "search");
    var brandArr = (0,helperServices/* manipulateFilter */.Zf)(flag, selectedFilter, {
      label: productObj.brandName,
      value: productObj.brandId
    }, "brands");
    setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
      search: productArr
    }));

    if (productObj.brandId != "" && productObj.brandName != "") {
      setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
        brands: brandArr
      }));
    }

    if (flag) {
      (0,filterDealService/* getDealFilterByProductNames */.j_)(productArr, brandArr).then(reloadPageData);
    } else {
      (0,filterDealService/* getDealFilterByProductNames */.j_)(productArr).then(reloadPageData);
    }

    var selectedProducts = productArr.map(function (product) {
      return product.label;
    });

    if (flag) {
      analyticsUtag/* link */.p4(deals_objectSpread({
        page_name: "shopping: deals grid: filter by product",
        search_event: "search",
        search_terms: selectedProducts.toString(),
        search_category: "product search",
        search_type: "full searches",
        search_results: productList.products.total_count
      }, viewData));
    }
  };

  var handleProductFilterError = function handleProductFilterError(value) {
    setFilterError(value);
  };

  var filteredCategory = (0,filterService/* getFilteredCategory */.WV)(selectedFilter, categoryList);
  var filteredCategories = (0,filterService/* getFilteredCategories */.RB)(selectedFilter, categoryList);

  var doAnUpgradeCheck = function doAnUpgradeCheck() {
    analyticsUtag/* link */.p4({
      page_name: pageName,
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": do an upgrade check")
    });

    if (props !== null && props !== void 0 && props.upgradeChecksEnabled) {
      props.updateUpgradeRedirect("", labels/* default.upgrade.lbl_see_deals_btn */.Z.upgrade.lbl_see_deals_btn);

      if (props.userLoggedIn) {
        if (props.eligibleUpgradeList.length > 1) {
          props.updateJourneyStatus(null, upgradeService/* upgradeStages.ELIGIBLE_NUMBER_SELECT */.wv.ELIGIBLE_NUMBER_SELECT);
        } else if (props.eligibleUpgradeList.length == 1) {
          props.updateJourneyStatus(props.eligibleUpgradeList[0].resultCode, upgradeService/* upgradeStages.UPGRADE_RESULT */.wv.UPGRADE_RESULT);
          props.updateSelectedData(props.eligibleUpgradeList[0]);
        }
      }

      props.displayHideUpgradeModal(true);
    } else {
      router.push("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/shopping/upgrades-check"));
    }
  };

  var getMaxPrice = function getMaxPrice() {
    if (isEligible()) {
      var _props$upgrade6, _props$upgrade6$credi;

      if (props !== null && props !== void 0 && (_props$upgrade6 = props.upgrade) !== null && _props$upgrade6 !== void 0 && (_props$upgrade6$credi = _props$upgrade6.creditFilters) !== null && _props$upgrade6$credi !== void 0 && _props$upgrade6$credi.financeIndicator) {
        var _props$upgrade7, _props$upgrade7$credi;

        var total_monthly_payment = Number(props === null || props === void 0 ? void 0 : (_props$upgrade7 = props.upgrade) === null || _props$upgrade7 === void 0 ? void 0 : (_props$upgrade7$credi = _props$upgrade7.creditFilters) === null || _props$upgrade7$credi === void 0 ? void 0 : _props$upgrade7$credi.total_monthly_payment) || 0;

        if (total_monthly_payment > aggMaxPrice) {
          return aggMaxPrice;
        } else {
          return total_monthly_payment.toFixed();
        }
      } else {
        return aggMaxPrice;
      }
    } else {
      return aggMaxPrice;
    }
  };

  var handleShowQualifyDeals = function handleShowQualifyDeals(flag) {
    if (props.isShowAffordDeal) {
      dispatch({
        type: actionTypes/* SET_CREDIT_SELECTED_AFFORD_DEAL */._c,
        payload: flag
      });
    }

    if (!flag) {
      setMaxPrice(aggMaxPrice);

      _setPriceValue({
        minValue: aggMinPrice,
        maxValue: aggMaxPrice
      });

      setShowQualifyDeals(false);
      setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
        isShowQualifying: "false"
      }));
      (0,filterDealService/* getDealFilterByPrice */.GE)({
        minValue: aggMinPrice,
        maxValue: aggMaxPrice,
        isShowQualifying: "false",
        skipPageNumber: true
      }).then(reloadPageData);
      analyticsUtag/* link */.p4({
        page_name: pageName,
        page_tool_event: "use",
        page_tool_name: "".concat(pageName, ": deselect deals I qualify for")
      });
    } else {
      analyticsUtag/* link */.p4({
        page_name: pageName,
        page_tool_event: "use",
        page_tool_name: "".concat(pageName, ": select deals I qualify for")
      });
      var curMaxPrice = getMaxPrice();
      setMaxPrice(Number(curMaxPrice));

      _setPriceValue({
        minValue: affordablePriceRange.length ? affordablePriceRange[0] : aggMinPrice,
        maxValue: curMaxPrice
      });

      setShowQualifyDeals(true);
      setSelectedFilter(deals_objectSpread(deals_objectSpread({}, selectedFilter), {
        isShowQualifying: "true"
      }));
      (0,filterDealService/* getDealFilterByPrice */.GE)({
        minValue: affordablePriceRange.length ? affordablePriceRange[0] : aggMinPrice,
        maxValue: curMaxPrice,
        isShowQualifying: "true",
        skipPageNumber: true
      }).then(reloadPageData);
    }

    setShowQualifyDeals(flag);
  };

  var updateCurrentPage = function updateCurrentPage(page) {
    (0,filterDealService/* getDealsFilterByPageNumber */.eG)(page).then(reloadPageData);
  };

  var clearCategorieFilters = function clearCategorieFilters() {
    setUpdateContainer(true);
  };

  (0,react.useEffect)(function () {
    (0,helperServices/* updateSessionStorage */.F$)("deals", router.asPath);
    reloadPageData();
  }, [router]);
  (0,react.useEffect)(function () {
    updateFilterCriteria();
  }, [productList === null || productList === void 0 ? void 0 : (_productList$products2 = productList.products) === null || _productList$products2 === void 0 ? void 0 : _productList$products2.aggregations]);
  (0,react.useEffect)(function () {
    analyticsUtag/* setAutoTagging */.fv(false);

    if (productListLoaded && Object.keys(dynamicRoute).length && !viewExecuted && !props.profileLoading && Object.keys(selectedFilter).length && Object.keys(selectedFilter).length > 1) {
      var section_lvls = setPageSiteLevel();
      var userMetaData = analyticsUtag/* getProfileData */.$y(props.userLoggedIn, props.profileData);

      if (productList && productList.products && productList.products.items && productList.products.items.length) {
        analyticsUtag/* view */.ei(deals_objectSpread(deals_objectSpread({
          page_event: "view",
          page_name: pageName,
          page_channel: "shopping",
          channel_type: "Monthly",
          page_master_tab: "personal"
        }, section_lvls), userMetaData));
        setViewData(deals_objectSpread(deals_objectSpread({
          page_name: pageName,
          page_channel: "shopping",
          channel_type: "Monthly",
          page_master_tab: "personal"
        }, section_lvls), userMetaData));
      } else {
        analyticsUtag/* view */.ei(deals_objectSpread(deals_objectSpread({
          page_event: "view",
          page_name: pageName,
          page_form_event: "error",
          channel_type: "Monthly",
          page_errors: "We couldn't find any results for your selected filters. Try widen your search by changing some of your selections, or reset all filters below.",
          page_channel: "shopping",
          page_master_tab: "personal"
        }, sectionLvls), userMetaData));
        setViewData(deals_objectSpread(deals_objectSpread({
          page_name: pageName,
          channel_type: "Monthly",
          page_channel: "shopping",
          page_master_tab: "personal"
        }, sectionLvls), userMetaData));
      }

      setViewExecuted(true);
      setSectionLvls(section_lvls);
    }
  }, [productListLoaded, props.profileLoading, props.userLoggedIn, props.profileData]);
  (0,react.useEffect)(function () {
    props.toggleFilters(false);
  }, []);
  (0,react.useEffect)(function () {
    var _selectedFilter4, _selectedFilter4$prom, _selectedFilter5, _selectedFilter5$bran;

    var selectedPromotionsData = ((_selectedFilter4 = selectedFilter) === null || _selectedFilter4 === void 0 ? void 0 : (_selectedFilter4$prom = _selectedFilter4.promotions) === null || _selectedFilter4$prom === void 0 ? void 0 : _selectedFilter4$prom.map(function (item) {
      return item.value;
    })) || [];
    var selectedBrandsData = ((_selectedFilter5 = selectedFilter) === null || _selectedFilter5 === void 0 ? void 0 : (_selectedFilter5$bran = _selectedFilter5.brands) === null || _selectedFilter5$bran === void 0 ? void 0 : _selectedFilter5$bran.map(function (item) {
      return item.value;
    })) || [];

    function getBannerData() {
      return _getBannerData.apply(this, arguments);
    }

    function _getBannerData() {
      _getBannerData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9() {
        var bannerResult, _bannerResult$errors;

        return regenerator_default().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                bannerDataFetched = true;
                _context9.next = 3;
                return ajaxServices/* default.fetchGraphQLGetRequest */.Z.fetchGraphQLGetRequest(queries/* BannerDetails */.zH, {
                  grid: props.gridId,
                  brand: "".concat(joinAllData(selectedBrandsData)),
                  promotion: "".concat(joinAllData(selectedPromotionsData))
                });

              case 3:
                bannerResult = _context9.sent;

                if (bannerResult) {
                  setBannerData((bannerResult === null || bannerResult === void 0 ? void 0 : bannerResult.banners) || []);

                  if (bannerResult.errors) {
                    analyticsUtag/* link */.p4({
                      page_name: pageName,
                      page_form_event: "error",
                      page_errors: "".concat(bannerResult.errors[0] ? (_bannerResult$errors = bannerResult.errors) === null || _bannerResult$errors === void 0 ? void 0 : _bannerResult$errors[0].message : ""),
                      page_errors_code: "dlp-m-g-bd-".concat(bannerResult.status)
                    });
                  }
                }

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
      return _getBannerData.apply(this, arguments);
    }

    if (props !== null && props !== void 0 && props.gridId) {
      if ((selectedBrandsData === null || selectedBrandsData === void 0 ? void 0 : selectedBrandsData.length) > 1) {
        setBannerData([]);
      } else {
        if (!bannerDataFetched) getBannerData();
      }
    }
  }, [(_selectedFilter6 = selectedFilter) === null || _selectedFilter6 === void 0 ? void 0 : _selectedFilter6.promotions, (_selectedFilter7 = selectedFilter) === null || _selectedFilter7 === void 0 ? void 0 : _selectedFilter7.brands, props === null || props === void 0 ? void 0 : props.gridId]);
  (0,react.useEffect)(function () {
    var _selectedFilter8, _selectedFilter9;

    var curCategoryId = ((_selectedFilter8 = selectedFilter) === null || _selectedFilter8 === void 0 ? void 0 : _selectedFilter8.selectedCategory) || ((_selectedFilter9 = selectedFilter) === null || _selectedFilter9 === void 0 ? void 0 : _selectedFilter9.selectedProductRange);

    if (categoryList && curCategoryId) {
      var _categoryList$categor;

      categoryList === null || categoryList === void 0 ? void 0 : (_categoryList$categor = categoryList.categories) === null || _categoryList$categor === void 0 ? void 0 : _categoryList$categor.map(function (category) {
        if (Number(category.id) === Number(curCategoryId)) {
          setSelectedCategory(selectedCategory = category);
        }
      });
    } else {
      setSelectedCategory(selectedCategory = null);
    }
  }, [categoryList, (_selectedFilter10 = selectedFilter) === null || _selectedFilter10 === void 0 ? void 0 : _selectedFilter10.selectedCategory, (_selectedFilter11 = selectedFilter) === null || _selectedFilter11 === void 0 ? void 0 : _selectedFilter11.selectedProductRange]);
  (0,react.useEffect)(function () {
    if (showComp) {
      window.scrollTo(0, 0);
    }

    props.displayHideUpgradeTopbanner(!showComp);
  }, [showComp]);
  (0,react.useEffect)(function () {
    var curMaxPrice = getMaxPrice(),
        curMin = 0,
        curMax = curMaxPrice;
    (0,helperServices/* showSpinner */.yh)();

    if (curMaxPrice) {
      (0,filterDealService/* parseFilterQuery */.w6)(decodeURIComponent(window.location.search)).then(function (filter) {
        getCategoryGridData().then(function (categoriesData) {
          var _categoriesData$categ;

          var categoryIdByName;
          categoriesData === null || categoriesData === void 0 ? void 0 : (_categoriesData$categ = categoriesData.categories) === null || _categoriesData$categ === void 0 ? void 0 : _categoriesData$categ.map(function (item) {
            if ((props === null || props === void 0 ? void 0 : props.categoryName) === item.name) {
              categoryIdByName = item.id;
            }
          });
          setSelectedFilter(filter);
          var priceObj = {
            minValue: Number(curMin),
            maxValue: Number(curMax)
          };

          if (filter !== null && filter !== void 0 && filter.monthly_recurring) {
            var _ref11 = (filter === null || filter === void 0 ? void 0 : filter.monthly_recurring) || {},
                maxValue = _ref11.maxValue,
                minValue = _ref11.minValue;

            priceObj.maxValue = maxValue;
            priceObj.minValue = minValue;
          }

          setMaxPrice(Number(curMaxPrice));

          _setPriceValue(priceObj);

          if (isEligible()) {
            var _props$upgrade8, _props$upgrade8$credi;

            initAggregationsMaxPrice(props === null || props === void 0 ? void 0 : (_props$upgrade8 = props.upgrade) === null || _props$upgrade8 === void 0 ? void 0 : (_props$upgrade8$credi = _props$upgrade8.creditFilters) === null || _props$upgrade8$credi === void 0 ? void 0 : _props$upgrade8$credi.total_monthly_payment);
            setShowQualifyDeals((filter === null || filter === void 0 ? void 0 : filter.isShowQualifying) == "false" ? false : true);
            (0,filterDealService/* getDealFilterByPrice */.GE)({
              minValue: priceObj.minValue,
              maxValue: priceObj.maxValue,
              type: types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
              isShowQualifying: filter !== null && filter !== void 0 && filter.isShowQualifying ? filter === null || filter === void 0 ? void 0 : filter.isShowQualifying : "true",
              skipPageNumber: false
            }).then(reloadPageData);
          } else {
            var _props$upgrade9;

            if (props !== null && props !== void 0 && (_props$upgrade9 = props.upgrade) !== null && _props$upgrade9 !== void 0 && _props$upgrade9.msisdn) {
              curMaxPrice = aggMaxPrice;
            }

            if (isEligible() && affordablePriceRange.length == 0) {
              var _props$upgrade10, _props$upgrade10$cred;

              initAggregationsMaxPrice(props === null || props === void 0 ? void 0 : (_props$upgrade10 = props.upgrade) === null || _props$upgrade10 === void 0 ? void 0 : (_props$upgrade10$cred = _props$upgrade10.creditFilters) === null || _props$upgrade10$cred === void 0 ? void 0 : _props$upgrade10$cred.total_monthly_payment);
            }

            setShowQualifyDeals(false);

            if (!isEligible() && Object.keys(filter).length === 1) {
              (0,filterDealService/* getDealFilterByCategory */.Ph)(categoryIdByName).then(reloadPageData); // DCEC-10254 - for performance ticket -> on page load by default phone & sim category will be selected
            } else if (!isEligible() && (filter === null || filter === void 0 ? void 0 : filter.isShowQualifying) == "true") {
              (0,filterDealService/* resetFilter */.sx)().then(reloadPageData);
            } else {
              setIsPageUpdated(true);
            }
          }
        });
      });
    }
  }, [priceFilterData]);
  (0,react.useEffect)(function () {
    if (isEligible() && !isProductsUpgrade && didMount) {
      var _props$upgrade11, _props$upgrade12, _props$upgrade12$cred;

      if (Object.keys(props === null || props === void 0 ? void 0 : (_props$upgrade11 = props.upgrade) === null || _props$upgrade11 === void 0 ? void 0 : _props$upgrade11.creditFilters).length) setIsProductsUpgrade(true);
      var newpriceObj = {
        minValue: 0,
        maxValue: Number(getMaxPrice())
      };
      initAggregationsMaxPrice(props === null || props === void 0 ? void 0 : (_props$upgrade12 = props.upgrade) === null || _props$upgrade12 === void 0 ? void 0 : (_props$upgrade12$cred = _props$upgrade12.creditFilters) === null || _props$upgrade12$cred === void 0 ? void 0 : _props$upgrade12$cred.total_monthly_payment);
      setMaxPrice(Number(getMaxPrice()));

      _setPriceValue(newpriceObj);

      setShowQualifyDeals(true);
      (0,filterDealService/* getDealFilterByPrice */.GE)({
        minValue: newpriceObj.minValue,
        maxValue: newpriceObj.maxValue,
        type: types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
        isShowQualifying: "true",
        skipPageNumber: false
      }).then(reloadPageData);
    }
  }, [(_props$upgrade13 = props.upgrade) === null || _props$upgrade13 === void 0 ? void 0 : _props$upgrade13.upgradeCheckDone, (_props$upgrade14 = props.upgrade) === null || _props$upgrade14 === void 0 ? void 0 : _props$upgrade14.selectedUpgradeResponse, (_props$upgrade15 = props.upgrade) === null || _props$upgrade15 === void 0 ? void 0 : _props$upgrade15.creditFilters.financeIndicator]);

  var onBackButtonClick = function onBackButtonClick() {
    if (!isPageUpdated) setIsPageUpdated(true);
  };

  (0,react.useEffect)(function () {
    if (isPageUpdated) {
      setIsPageUpdated(false);
      loadPageData();
      setTimeout(lib/* forceCheck */.be, 1000);
    }
  }, [isPageUpdated]);
  (0,react.useEffect)(function () {
    var section_lvls = setPageSiteLevel();

    if (productList && productList.products && productList.products.items && productList.products.items.length) {
      setRenderdEmpty(false);
    } else {
      if (!renderdEmpty && productList && productList.products && productList.products.total_count == 0) {
        analyticsUtag/* link */.p4(deals_objectSpread({
          page_name: pageName,
          page_form_event: "error",
          page_errors: "We couldn't find any results for your selected filters. Try widen your search by changing some of your selections, or reset all filters below.",
          page_channel: "shopping",
          page_master_tab: "personal"
        }, section_lvls));
        setRenderdEmpty(true);
      }
    }
  }, [productList]);

  var initAggregations = /*#__PURE__*/function () {
    var _ref12 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10() {
      var callFunc,
          _products$products,
          _products$products$ag,
          _products$products2,
          _products$products2$a,
          _products$products2$a2,
          _products$products3,
          _products$products3$a,
          _products$products3$a2,
          products,
          priceAggregation,
          brandAggregation,
          promotionAggregation,
          _priceAggregation$opt,
          localPriceFilterData,
          getNotAllowedRangesData,
          _products$products4,
          _args10 = arguments;

      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              callFunc = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : false;

              if (!(!priceFilterData || (priceFilterData === null || priceFilterData === void 0 ? void 0 : priceFilterData.length) == 0 || callFunc)) {
                _context10.next = 11;
                break;
              }

              _context10.next = 4;
              return (0,filterDealService/* getDealAggregations */.mI)({
                selectedFilter: selectedFilter
              });

            case 4:
              products = _context10.sent;
              priceAggregation = products === null || products === void 0 ? void 0 : (_products$products = products.products) === null || _products$products === void 0 ? void 0 : (_products$products$ag = _products$products.aggregations) === null || _products$products$ag === void 0 ? void 0 : _products$products$ag.find(function (agg) {
                return agg.attribute_code === "monthly_recurring_bucket" || agg.attribute_code === "monthly_recurring";
              });
              brandAggregation = products === null || products === void 0 ? void 0 : (_products$products2 = products.products) === null || _products$products2 === void 0 ? void 0 : (_products$products2$a = _products$products2.aggregations) === null || _products$products2$a === void 0 ? void 0 : (_products$products2$a2 = _products$products2$a.find(function (agg) {
                return agg.attribute_code === "manufacturer";
              })) === null || _products$products2$a2 === void 0 ? void 0 : _products$products2$a2.options;
              promotionAggregation = products === null || products === void 0 ? void 0 : (_products$products3 = products.products) === null || _products$products3 === void 0 ? void 0 : (_products$products3$a = _products$products3.aggregations) === null || _products$products3$a === void 0 ? void 0 : (_products$products3$a2 = _products$products3$a.find(function (agg) {
                return agg.attribute_code === "promotion_tag";
              })) === null || _products$products3$a2 === void 0 ? void 0 : _products$products3$a2.options;
              updateFilters({
                brandAggregation: brandAggregation,
                promotionAggregation: promotionAggregation
              });

              if (priceAggregation) {
                localPriceFilterData = (0,priceFilterUtils/* getPriceFilterDataFromOptions */.kD)((_priceAggregation$opt = priceAggregation === null || priceAggregation === void 0 ? void 0 : priceAggregation.options) !== null && _priceAggregation$opt !== void 0 ? _priceAggregation$opt : []);
                getNotAllowedRangesData = (0,priceFilterUtils/* getNotAllowedRanges */.Lp)((priceAggregation === null || priceAggregation === void 0 ? void 0 : priceAggregation.options) || []);

                if (localPriceFilterData.length) {
                  setAggMaxPrice(localPriceFilterData[localPriceFilterData.length - 1]);
                  setMaxPrice(localPriceFilterData[localPriceFilterData.length - 1]);
                  setAggMinPrice(localPriceFilterData[0]);
                }

                setPriceFilterData(localPriceFilterData);
                setMissingPriceFilterData(getNotAllowedRangesData);
              }

              if (products) {
                setAggregators(products === null || products === void 0 ? void 0 : (_products$products4 = products.products) === null || _products$products4 === void 0 ? void 0 : _products$products4.aggregations);
              }

            case 11:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function initAggregations() {
      return _ref12.apply(this, arguments);
    };
  }();

  var initAggregationsMaxPrice = /*#__PURE__*/function () {
    var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11(maxPriceValue) {
      var _products$products5, _products$products5$a, _products$products6, _products$products6$a, _products$products6$a2, _products$products7, _products$products7$a, _products$products7$a2, products, priceAggregation, brandAggregation, promotionAggregation, localPriceFilterData, affordablePriceFilterData, getNotAllowedRangesData;

      return regenerator_default().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!maxPriceValue) {
                _context11.next = 9;
                break;
              }

              _context11.next = 3;
              return (0,filterDealService/* getDealAggregations */.mI)({
                selectedFilter: selectedFilter,
                maxPrice: Number(maxPriceValue)
              });

            case 3:
              products = _context11.sent;
              priceAggregation = products === null || products === void 0 ? void 0 : (_products$products5 = products.products) === null || _products$products5 === void 0 ? void 0 : (_products$products5$a = _products$products5.aggregations) === null || _products$products5$a === void 0 ? void 0 : _products$products5$a.find(function (agg) {
                return agg.attribute_code === "monthly_recurring_bucket" || "monthly_recurring";
              });
              brandAggregation = products === null || products === void 0 ? void 0 : (_products$products6 = products.products) === null || _products$products6 === void 0 ? void 0 : (_products$products6$a = _products$products6.aggregations) === null || _products$products6$a === void 0 ? void 0 : (_products$products6$a2 = _products$products6$a.find(function (agg) {
                return agg.attribute_code === "manufacturer";
              })) === null || _products$products6$a2 === void 0 ? void 0 : _products$products6$a2.options;
              promotionAggregation = products === null || products === void 0 ? void 0 : (_products$products7 = products.products) === null || _products$products7 === void 0 ? void 0 : (_products$products7$a = _products$products7.aggregations) === null || _products$products7$a === void 0 ? void 0 : (_products$products7$a2 = _products$products7$a.find(function (agg) {
                return agg.attribute_code === "promotion_tag";
              })) === null || _products$products7$a2 === void 0 ? void 0 : _products$products7$a2.options;

              if (priceAggregation) {
                localPriceFilterData = (0,priceFilterUtils/* getPriceFilterDataFromOptions */.kD)((priceAggregation === null || priceAggregation === void 0 ? void 0 : priceAggregation.options) || []);
                affordablePriceFilterData = (0,priceFilterUtils/* getAffordablePriceFilterDataFromOptions */.b0)(localPriceFilterData, Number(maxPriceValue), aggMaxPrice);
                getNotAllowedRangesData = (0,priceFilterUtils/* getNotAllowedRanges */.Lp)((priceAggregation === null || priceAggregation === void 0 ? void 0 : priceAggregation.options) || []);
                setAffordablePriceRange(affordablePriceFilterData);
                setMissingAffordablePriceRange(getNotAllowedRangesData);
              }

              updateFilters({
                brandAggregation: brandAggregation,
                promotionAggregation: promotionAggregation
              });

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function initAggregationsMaxPrice(_x8) {
      return _ref13.apply(this, arguments);
    };
  }();

  var updateCategoryOnFilter = function updateCategoryOnFilter(categoryId) {
    var tempSelectedFilter = deals_objectSpread({}, selectedFilter);

    for (var key in tempSelectedFilter) {
      if (key != "updateFilterCriteria" && key != "isShowQualifying" && key != "monthly_recurring") {
        delete tempSelectedFilter[key];
      }
    }

    if (!categoryId) {
      setSelectedFilter.apply(void 0, (0,toConsumableArray/* default */.Z)(tempSelectedFilter));
    } else {
      setSelectedFilter(deals_objectSpread(deals_objectSpread({}, tempSelectedFilter), {
        selectedCategory: categoryId
      }));
    }
  };

  var handleApplyFilter = function handleApplyFilter() {
    var newSelectedFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedFilter || {};
    var selectedCategory = newSelectedFilters.selectedCategory,
        brands = newSelectedFilters.brands,
        promotions = newSelectedFilters.promotions,
        contractduration = newSelectedFilters.contractduration,
        contracttype = newSelectedFilters.contracttype,
        plannames = newSelectedFilters.plannames,
        plantypes = newSelectedFilters.plantypes,
        promo_data = newSelectedFilters.promo_data,
        minutes = newSelectedFilters.minutes,
        airtime = newSelectedFilters.airtime,
        search = newSelectedFilters.search;

    var _ref14 = priceValue || {},
        minValue = _ref14.minValue,
        maxValue = _ref14.maxValue;

    var filterHref = "";
    var str = "";

    if (selectedCategory) {
      str = (0,filterDealService/* getDealFilterByCategory */.Ph)(selectedCategory, true); //true-return href, false-router push

      if (str && str !== "") {
        filterHref += str;
      }
    }

    if (brands) {
      str = (0,filterDealService/* getDealFilterByBrands */.Rl)(brands, true); //true-return href, false-router push

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (promotions) {
      str = (0,filterDealService/* getDealFilterByPromotions */.h3)(promotions, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (contractduration) {
      str = (0,filterDealService/* getDealFilterByContractDuration */.aL)(contractduration, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (contracttype) {
      str = (0,filterDealService/* getDealFilterByContractType */.m2)(contracttype, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (plannames) {
      str = (0,filterDealService/* getDealFilterByPlanName */.Sq)(plannames, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (plantypes) {
      str = (0,filterDealService/* getDealFilterByPlanType */.qf)(plantypes, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (promo_data) {
      var promoVal = (0,filterDealService/* getMinMaxFromFilterArray */.$L)(promo_data);
      var dataObj = {
        minValue: promoVal.minValue,
        maxValue: promoVal.maxValue
      };
      str = (0,filterDealService/* getDealFilterByData */.m)(dataObj, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (minutes) {
      var minutesVal = (0,filterDealService/* getMinMaxFromFilterArray */.$L)(minutes);
      var _dataObj = {
        minValue: minutesVal.minValue,
        maxValue: minutesVal.maxValue
      };
      str = (0,filterDealService/* getDealFilterByVoiceMinutes */.vi)(_dataObj, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (airtime) {
      var airtimeVal = (0,filterDealService/* getMinMaxFromFilterArray */.$L)(airtime);
      var _dataObj2 = {
        minValue: airtimeVal.minValue,
        maxValue: airtimeVal.maxValue
      };
      str = (0,filterDealService/* getDealFilterByAirTime */.QW)(_dataObj2, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (search) {
      str = (0,filterDealService/* getDealFilterByProductNames */.j_)(search, [], true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (Object.keys(priceValue).length !== 0) {
      var priceObj = {
        type: types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
        minValue: minValue,
        maxValue: maxValue,
        skipPageNumber: true
      };
      str = (0,filterDealService/* getDealFilterByPrice */.GE)(priceObj, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (filterHref !== "") {
      filterHref = showQualifyDeals ? "".concat(filterHref, "&isShowQualifying=true") : "".concat(filterHref, "&isShowQualifying=false");
      var newHref = filterHref ? "".concat(types/* default.DEAL_GRID_PAGE */.Z.DEAL_GRID_PAGE, "?").concat(filterHref) : types/* default.DEAL_GRID_PAGE */.Z.DEAL_GRID_PAGE;
      DependencyHelper.Router.push(types/* default.DEAL_GRID_PAGE */.Z.DEAL_GRID_PAGE, newHref, {
        shallow: true
      }).then(reloadPageData);
    }
  };

  var getStatusFilter = function getStatusFilter(filter) {
    var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return deals_objectSpread(deals_objectSpread({}, filter), {}, {
      disabled: disabled
    });
  };

  var updateFilters = function updateFilters(_ref15) {
    var _ref15$brandAggregati = _ref15.brandAggregation,
        brandAggregation = _ref15$brandAggregati === void 0 ? [] : _ref15$brandAggregati,
        _ref15$promotionAggre = _ref15.promotionAggregation,
        promotionAggregation = _ref15$promotionAggre === void 0 ? [] : _ref15$promotionAggre;

    if (brandAggregation !== null && brandAggregation !== void 0 && brandAggregation.length) {
      if (allBrands.length) {
        setAllBrands(allBrands.map(function (brand) {
          if (brandAggregation.findIndex(function (newBrand) {
            return newBrand.value === brand.value;
          }) > -1) {
            return deals_objectSpread(deals_objectSpread({}, brand), {}, {
              disabled: false
            });
          } else {
            return deals_objectSpread(deals_objectSpread({}, brand), {}, {
              disabled: true
            });
          }
        }));
      } else {
        setAllBrands(brandAggregation === null || brandAggregation === void 0 ? void 0 : brandAggregation.map(function (brand) {
          return getStatusFilter(brand);
        }));
      }
    } else {
      if (allBrands.length) {
        setAllBrands(allBrands === null || allBrands === void 0 ? void 0 : allBrands.map(function (brand) {
          return getStatusFilter(brand, true);
        }));
      }
    }

    if (promotionAggregation !== null && promotionAggregation !== void 0 && promotionAggregation.length) {
      if (allPromotions.length) {
        setAllPromotions(allPromotions.map(function (promotion) {
          if (promotionAggregation.findIndex(function (newPromotion) {
            return newPromotion.value === promotion.value;
          }) > -1) {
            return deals_objectSpread(deals_objectSpread({}, promotion), {}, {
              disabled: false
            });
          } else {
            return deals_objectSpread(deals_objectSpread({}, promotion), {}, {
              disabled: true
            });
          }
        }));
      } else {
        setAllPromotions(promotionAggregation === null || promotionAggregation === void 0 ? void 0 : promotionAggregation.map(function (promotion) {
          return getStatusFilter(promotion);
        }));
      }
    } else {
      setAllPromotions(allPromotions === null || allPromotions === void 0 ? void 0 : allPromotions.map(function (promotion) {
        return getStatusFilter(promotion, true);
      }));
    }
  };

  var updateAggregations = /*#__PURE__*/function () {
    var _ref17 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee12(_ref16) {
      var minPrice, maxPrice, _products$products8, _products$products8$a, _products$products8$a2, _products$products9, _products$products9$a, _products$products9$a2, products, brandAggregation, promotionAggregation;

      return regenerator_default().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              minPrice = _ref16.minPrice, maxPrice = _ref16.maxPrice;

              if (!maxPrice) {
                _context12.next = 8;
                break;
              }

              _context12.next = 4;
              return (0,filterDealService/* getDealAggregations */.mI)({
                selectedFilter: selectedFilter,
                maxPrice: maxPrice,
                minPrice: minPrice
              });

            case 4:
              products = _context12.sent;
              brandAggregation = products === null || products === void 0 ? void 0 : (_products$products8 = products.products) === null || _products$products8 === void 0 ? void 0 : (_products$products8$a = _products$products8.aggregations) === null || _products$products8$a === void 0 ? void 0 : (_products$products8$a2 = _products$products8$a.find(function (agg) {
                return agg.attribute_code === "manufacturer";
              })) === null || _products$products8$a2 === void 0 ? void 0 : _products$products8$a2.options;
              promotionAggregation = products === null || products === void 0 ? void 0 : (_products$products9 = products.products) === null || _products$products9 === void 0 ? void 0 : (_products$products9$a = _products$products9.aggregations) === null || _products$products9$a === void 0 ? void 0 : (_products$products9$a2 = _products$products9$a.find(function (agg) {
                return agg.attribute_code === "promotion_tag";
              })) === null || _products$products9$a2 === void 0 ? void 0 : _products$products9$a2.options;
              updateFilters({
                brandAggregation: brandAggregation,
                promotionAggregation: promotionAggregation
              });

            case 8:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function updateAggregations(_x9) {
      return _ref17.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    var _selectedFilter12, _selectedFilter13;

    var curCategoryId = ((_selectedFilter12 = selectedFilter) === null || _selectedFilter12 === void 0 ? void 0 : _selectedFilter12.selectedCategory) || ((_selectedFilter13 = selectedFilter) === null || _selectedFilter13 === void 0 ? void 0 : _selectedFilter13.selectedProductRange);

    if (curCategoryId && priceValue !== null && priceValue !== void 0 && priceValue.maxValue && allBrands !== null && allBrands !== void 0 && allBrands.length) {
      updateAggregations({
        minPrice: priceValue.minValue,
        maxPrice: priceValue.maxValue
      });
    }
  }, [priceValue, (_selectedFilter14 = selectedFilter) === null || _selectedFilter14 === void 0 ? void 0 : _selectedFilter14.selectedCategory, (_selectedFilter15 = selectedFilter) === null || _selectedFilter15 === void 0 ? void 0 : _selectedFilter15.selectedProductRange]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* default */.Z, {
      title: props === null || props === void 0 ? void 0 : (_props$metadata = props.metadata) === null || _props$metadata === void 0 ? void 0 : _props$metadata.title,
      content: props === null || props === void 0 ? void 0 : (_props$metadata2 = props.metadata) === null || _props$metadata2 === void 0 ? void 0 : _props$metadata2.description,
      url: props === null || props === void 0 ? void 0 : (_props$metadata3 = props.metadata) === null || _props$metadata3 === void 0 ? void 0 : _props$metadata3.canonical_url,
      keywords: props === null || props === void 0 ? void 0 : (_props$metadata4 = props.metadata) === null || _props$metadata4 === void 0 ? void 0 : _props$metadata4.keywords,
      robots: props === null || props === void 0 ? void 0 : (_props$metadata5 = props.metadata) === null || _props$metadata5 === void 0 ? void 0 : _props$metadata5.robots
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      id: "product-list-container",
      className: "main-container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
        className: "custom-container ".concat(showComp ? "hide" : ""),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            md: 12,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb["default"], {
              list: (0,helperServices/* formatBreadCrumb */.x9)((0,breadcrumbService/* breadcrumbGenerator */.G)().deals)
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          children: categoryList && categoryList.categories && categoryList.categories.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            md: 12,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(productRange["default"], {
              selectedFilter: selectedFilter,
              categoryList: categoryList === null || categoryList === void 0 ? void 0 : categoryList.categories,
              handleContainer: handleRangeChange,
              handleSelected: handleRangeChange,
              heading: labels/* default.lbl_deal_range */.Z.lbl_deal_range,
              page: "deal-grid",
              emptyCategories: updateContainer
            })
          }) : ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            id: "deal-page-button-group",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BrowseContainer["default"], {
              isDeal: true,
              selectionFlag: filteredCategory && Object.keys(filteredCategory.length !== 0),
              heading: filteredCategory && filteredCategory.name ? filteredCategory.name : labels/* default.BreadCrumbLabels.lbl_browse_all_deals */.Z.BreadCrumbLabels.lbl_browse_all_deals,
              shortDescription: filteredCategory && filteredCategory.short_description ? filteredCategory.short_description : labels/* default.lbl_filter_text */.Z.lbl_filter_text,
              filterButton: !showComp && isTablet && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: "filter-btn-group deal-page-button",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                    md: 12,
                    className: "spacing",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                      className: "deal-filter-button-group-container",
                      children: [props.productSearchOnDealGridEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                        className: "deal-filter-button-group deal-button-group-spacing",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonGroup["default"], {
                          toggleComps: function toggleComps(val) {
                            toggleHandler(val);
                          },
                          noShadow: true,
                          hide: showComp,
                          selectedSortVal: sortProductsBy !== "" ? sortProductsBy : labels/* default.sortKeys.lbl_recommended */.Z.sortKeys.lbl_recommended,
                          buttonLabel: labels/* default.lbl_filter_device_mobile */.Z.lbl_filter_device_mobile,
                          filterType: "search"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                        className: "deal-filter-button-group",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonGroup["default"], {
                          headingName: "Filter Deals",
                          toggleComps: function toggleComps(val) {
                            toggleHandler(val);
                          },
                          noShadow: true,
                          hide: showComp,
                          selectedSortVal: sortProductsBy !== "" ? sortProductsBy : labels/* default.sortKeys.lbl_recommended */.Z.sortKeys.lbl_recommended,
                          buttonLabel: labels/* default.lbl_more_filters */.Z.lbl_more_filters
                        })
                      })]
                    })
                  })
                })
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          children: [isEligible() && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeCheckBar/* default */.Z, {
                  type: props.isShowAffordDeal ? "success" : "info",
                  className: "ecom-upgrade-banner",
                  message: props.isShowAffordDeal ? labels/* default.creditVetting.lbl_available_deals */.Z.creditVetting.lbl_available_deals : labels/* default.product_affordability.lbl_available_deals */.Z.product_affordability.lbl_available_deals
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
              className: "d-block d-lg-none",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(AffordabilityFilterToggle/* default */.Z, {
                  id: "chk_qualify_deals",
                  checkboxLabel: props.isShowAffordDeal ? labels/* default.creditVetting.lbl_qualify */.Z.creditVetting.lbl_qualify : labels/* default.product_affordability.lbl_qualify */.Z.product_affordability.lbl_qualify,
                  checkboxSubtext: props === null || props === void 0 ? void 0 : (_props$upgrade16 = props.upgrade) === null || _props$upgrade16 === void 0 ? void 0 : (_props$upgrade16$cred = _props$upgrade16.creditFilters) === null || _props$upgrade16$cred === void 0 ? void 0 : _props$upgrade16$cred.message,
                  handleCheck: handleShowQualifyDeals,
                  check: showQualifyDeals
                })
              })
            })]
          }), showFilterError && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            className: "d-block d-lg-none",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              md: 12,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: "deals-filter-error-message",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "".concat(imagePrefix, "/assets/images/warning-black.svg"),
                  width: 17,
                  height: 17,
                  className: "deals-filter-error-image"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [" ", labels/* default.errors.lbl_deals_filter_error */.Z.errors.lbl_deals_filter_error]
                })]
              })
            })
          })]
        }), !(props !== null && props !== void 0 && (_props$upgrade17 = props.upgrade) !== null && _props$upgrade17 !== void 0 && _props$upgrade17.upgradeCheckDone) && !props.isShowAffordDeal && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          className: "d-block d-lg-none mb-3 mt-3",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeCheckBar/* default */.Z, {
              id: "doAnUpgrade",
              message: labels/* default.upgrade.lbl_here_to_do_upgrade */.Z.upgrade.lbl_here_to_do_upgrade,
              btnLabel: labels/* default.upgrade.lbl_do_upgrade */.Z.upgrade.lbl_do_upgrade,
              btnHandler: doAnUpgradeCheck
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
        className: "custom-container",
        children: [!showComp && isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "filter-btn-group",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              md: 12,
              className: "spacing",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: "deal-filter-button-group-container",
                children: [props.productSearchOnDealGridEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: "deal-filter-button-group deal-button-group-spacing col-md-6 pl-0 pr-0",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonGroup["default"], {
                    toggleComps: function toggleComps(val) {
                      toggleHandler(val);
                    },
                    hide: showComp,
                    noShadow: true,
                    selectedSortVal: sortProductsBy !== "" ? sortProductsBy : labels/* default.sortKeys.lbl_recommended */.Z.sortKeys.lbl_recommended,
                    buttonLabel: labels/* default.lbl_filter_device_mobile */.Z.lbl_filter_device_mobile,
                    filterType: "search",
                    productSearchOnDealGridEnabled: props.productSearchOnDealGridEnabled
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: "deal-filter-button-group col-md-6 pl-0 pr-0",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonGroup["default"], {
                    headingName: "Filter Deals",
                    toggleComps: function toggleComps(val) {
                      toggleHandler(val);
                    },
                    hide: showComp,
                    noShadow: true,
                    selectedSortVal: sortProductsBy !== "" ? sortProductsBy : labels/* default.sortKeys.lbl_recommended */.Z.sortKeys.lbl_recommended,
                    buttonLabel: labels/* default.lbl_more_filters */.Z.lbl_more_filters
                  })
                })]
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: "d-none d-lg-block",
          children: [showFilterError && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              lg: 12,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: "deals-filter-error-message",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "".concat(imagePrefix, "/assets/images/warning-black.svg"),
                  width: 17,
                  height: 17,
                  className: "deals-filter-error-image"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [" ", labels/* default.errors.lbl_deals_filter_error */.Z.errors.lbl_deals_filter_error]
                })]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
              lg: 3,
              xl: 3,
              className: "pr1-0",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                children: isEligible() && /*#__PURE__*/(0,jsx_runtime.jsx)(AffordabilityFilterToggle/* default */.Z, {
                  id: "chk_qualify_deals",
                  checkboxLabel: props.isShowAffordDeal ? labels/* default.creditVetting.lbl_qualify */.Z.creditVetting.lbl_qualify : labels/* default.product_affordability.lbl_qualify */.Z.product_affordability.lbl_qualify,
                  checkboxSubtext: props === null || props === void 0 ? void 0 : (_props$upgrade18 = props.upgrade) === null || _props$upgrade18 === void 0 ? void 0 : (_props$upgrade18$cred = _props$upgrade18.creditFilters) === null || _props$upgrade18$cred === void 0 ? void 0 : _props$upgrade18$cred.message,
                  handleCheck: handleShowQualifyDeals,
                  check: showQualifyDeals
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                children: (aggregators === null || aggregators === void 0 ? void 0 : aggregators.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(dealGridSearchContainer_DealGridSearchContainer, {
                  brands: allBrands,
                  promotions: allPromotions,
                  plantype: plantypes,
                  planname: plannames,
                  accessories: accessories,
                  contractduration: contractDuration,
                  contracttype: contractType,
                  contractsList: contractsList,
                  selectedContractType: (_selectedFilter16 = selectedFilter) === null || _selectedFilter16 === void 0 ? void 0 : _selectedFilter16.contracttype,
                  selectedSubCategories: (_selectedFilter17 = selectedFilter) === null || _selectedFilter17 === void 0 ? void 0 : _selectedFilter17.selectedSubCategory,
                  selectedCategory: selectedCategory,
                  categoriesList: showComp ? categoryList : filteredCategories,
                  priceValue: priceValue,
                  priceRange: isEligible() && showQualifyDeals ? affordablePriceRange : priceFilterData,
                  missingPriceRange: isEligible() && showQualifyDeals ? missingAffordablePriceRange : missingPriceFilterData,
                  maxPrice: maxPrice,
                  vmValue: (_selectedFilter18 = selectedFilter) === null || _selectedFilter18 === void 0 ? void 0 : _selectedFilter18.minutes,
                  airValue: (_selectedFilter19 = selectedFilter) === null || _selectedFilter19 === void 0 ? void 0 : _selectedFilter19.airtime,
                  promoValue: (_selectedFilter20 = selectedFilter) === null || _selectedFilter20 === void 0 ? void 0 : _selectedFilter20.promo_data,
                  isDealGridPage: true,
                  showQualifyDeals: isEligible() && showQualifyDeals,
                  onPriceChange: handlePriceChange,
                  onBrandChange: handleBrandChange,
                  onPromotionChange: handlePromotionChange,
                  onContractTypeChange: handleContractTypeChange,
                  onPlanTypeChange: handlePlanTypeChange,
                  onPlanNameChange: handlePlanNameChange,
                  onAccessoriesChange: handleAccessoriesChange,
                  onContractDurationChange: handleContractDurationChange,
                  onDataChange: handleDataChange,
                  onAirTimeChange: handleAirTimeChange,
                  onVoiceMinutesChange: handleVoiceMinutesChange,
                  onCategoryChange: handleCategoryChange,
                  onSubCategoryChange: handleSubCategoryChange,
                  onFilterChange: reloadPageData,
                  onFilterReset: handleResetFilter,
                  selectedFilter: selectedFilter,
                  setSelectedFilter: setSelectedFilter,
                  onProductFilterError: handleProductFilterError,
                  onProductFilterChange: handleProductFilterChange,
                  getSelectedPromotion: getSelectedPromotion,
                  getSelectedBrands: getSelectedBrands,
                  getSelectedContractType: getSelectedContractType,
                  getSelectedPlanType: getSelectedPlanType,
                  getSelectedPlanName: getSelectedPlanName,
                  getSelectedContractDuration: getSelectedContractDuration,
                  setPriceValue: function setPriceValue() {
                    return _setPriceValue({
                      minValue: 0,
                      maxValue: constants/* MAX_MONTHLY_RECURRING */._V
                    });
                  },
                  isEligible: isEligible() && showQualifyDeals,
                  productSearchOnDealGridEnabled: props === null || props === void 0 ? void 0 : props.productSearchOnDealGridEnabled
                })
              })]
            }), productList && productList.products && productList.products.items ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
              lg: 9,
              xl: 9,
              className: "pl-0",
              children: [!(props !== null && props !== void 0 && (_props$upgrade19 = props.upgrade) !== null && _props$upgrade19 !== void 0 && _props$upgrade19.upgradeCheckDone) && !props.isShowAffordDeal && /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeCheckBar/* default */.Z, {
                id: "doAnUpgrade",
                message: labels/* default.upgrade.lbl_here_to_do_upgrade */.Z.upgrade.lbl_here_to_do_upgrade,
                btnLabel: labels/* default.upgrade.lbl_do_upgrade */.Z.upgrade.lbl_do_upgrade,
                btnHandler: doAnUpgradeCheck,
                className: "mb-3"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(dealGridListContainer_DealGridListContainer, {
                selectedBrands: (_selectedFilter21 = selectedFilter) === null || _selectedFilter21 === void 0 ? void 0 : _selectedFilter21.brands,
                selectedPromotions: (_selectedFilter22 = selectedFilter) === null || _selectedFilter22 === void 0 ? void 0 : _selectedFilter22.promotions,
                selectedPlantype: (_selectedFilter23 = selectedFilter) === null || _selectedFilter23 === void 0 ? void 0 : _selectedFilter23.plantypes,
                selectedPlanname: (_selectedFilter24 = selectedFilter) === null || _selectedFilter24 === void 0 ? void 0 : _selectedFilter24.plannames,
                selectedAcccessories: (_selectedFilter25 = selectedFilter) === null || _selectedFilter25 === void 0 ? void 0 : _selectedFilter25.accessories,
                selectedContractDuration: (_selectedFilter26 = selectedFilter) === null || _selectedFilter26 === void 0 ? void 0 : _selectedFilter26.contractduration,
                selectedContractType: (_selectedFilter27 = selectedFilter) === null || _selectedFilter27 === void 0 ? void 0 : _selectedFilter27.contracttype,
                selectedSortVal: sortProductsBy,
                selectedPrice: Number(priceValue === null || priceValue === void 0 ? void 0 : priceValue.minValue) > Number(aggMinPrice) || Number(priceValue === null || priceValue === void 0 ? void 0 : priceValue.maxValue) < Number(aggMaxPrice) ? (_selectedFilter28 = selectedFilter) === null || _selectedFilter28 === void 0 ? void 0 : _selectedFilter28.monthly_recurring : null,
                selectedPromoData: Number((_selectedFilter29 = selectedFilter) === null || _selectedFilter29 === void 0 ? void 0 : (_selectedFilter29$pro = _selectedFilter29.promo_data) === null || _selectedFilter29$pro === void 0 ? void 0 : (_selectedFilter29$pro2 = _selectedFilter29$pro[0]) === null || _selectedFilter29$pro2 === void 0 ? void 0 : _selectedFilter29$pro2.label) > Number(constants/* MIN_DATA */.Kt) || Number((_selectedFilter30 = selectedFilter) === null || _selectedFilter30 === void 0 ? void 0 : (_selectedFilter30$pro = _selectedFilter30.promo_data) === null || _selectedFilter30$pro === void 0 ? void 0 : (_selectedFilter30$pro2 = _selectedFilter30$pro[1]) === null || _selectedFilter30$pro2 === void 0 ? void 0 : _selectedFilter30$pro2.label) < Number(constants/* MAX_DATA */.CS) ? (_selectedFilter31 = selectedFilter) === null || _selectedFilter31 === void 0 ? void 0 : _selectedFilter31.promo_data : null,
                selectedMinutesData: Number((_selectedFilter32 = selectedFilter) === null || _selectedFilter32 === void 0 ? void 0 : (_selectedFilter32$min = _selectedFilter32.minutes) === null || _selectedFilter32$min === void 0 ? void 0 : (_selectedFilter32$min2 = _selectedFilter32$min[0]) === null || _selectedFilter32$min2 === void 0 ? void 0 : _selectedFilter32$min2.label) > Number(constants/* MIN_MINUTES */.FW) || Number((_selectedFilter33 = selectedFilter) === null || _selectedFilter33 === void 0 ? void 0 : (_selectedFilter33$min = _selectedFilter33.minutes) === null || _selectedFilter33$min === void 0 ? void 0 : (_selectedFilter33$min2 = _selectedFilter33$min[1]) === null || _selectedFilter33$min2 === void 0 ? void 0 : _selectedFilter33$min2.label) < Number(constants/* MAX_MINUTES */.UT) ? (_selectedFilter34 = selectedFilter) === null || _selectedFilter34 === void 0 ? void 0 : _selectedFilter34.minutes : null,
                selectedAirtimeData: Number((_selectedFilter35 = selectedFilter) === null || _selectedFilter35 === void 0 ? void 0 : (_selectedFilter35$air = _selectedFilter35.airtime) === null || _selectedFilter35$air === void 0 ? void 0 : (_selectedFilter35$air2 = _selectedFilter35$air[0]) === null || _selectedFilter35$air2 === void 0 ? void 0 : _selectedFilter35$air2.label) > Number(constants/* MIN_AIRTIME */.hJ) || Number((_selectedFilter36 = selectedFilter) === null || _selectedFilter36 === void 0 ? void 0 : (_selectedFilter36$air = _selectedFilter36.airtime) === null || _selectedFilter36$air === void 0 ? void 0 : (_selectedFilter36$air2 = _selectedFilter36$air[1]) === null || _selectedFilter36$air2 === void 0 ? void 0 : _selectedFilter36$air2.label) < Number(constants/* MAX_AIRTIME */.Vr) ? (_selectedFilter37 = selectedFilter) === null || _selectedFilter37 === void 0 ? void 0 : _selectedFilter37.airtime : null,
                selectedProducts: (_selectedFilter38 = selectedFilter) === null || _selectedFilter38 === void 0 ? void 0 : _selectedFilter38.search,
                items: productList === null || productList === void 0 ? void 0 : (_productList$products3 = productList.products) === null || _productList$products3 === void 0 ? void 0 : _productList$products3.items,
                isDealGridPage: true,
                sortBy: handleSortBy,
                pageInfo: productList.products.page_info,
                updateCurrentPage: updateCurrentPage,
                totalItemsCount: productList.products.total_count,
                bannerData: bannerData,
                spanXl: "4",
                clearCategories: clearCategorieFilters,
                showQualifyDeals: isEligible() && showQualifyDeals,
                defaultUpgrade: isEligible(),
                onBrandChange: handleBrandChange,
                onPromotionChange: handlePromotionChange,
                onContractTypeChange: handleContractTypeChange,
                onPlanTypeChange: handlePlanTypeChange,
                onPlanNameChange: handlePlanNameChange,
                onAccessoriesChange: handleAccessoriesChange,
                onContractDurationChange: handleContractDurationChange,
                onFilterChange: reloadPageData,
                onFilterReset: handleResetFilter,
                setSelectedFilter: setSelectedFilter,
                onSeeDetailsClick: handleSeeDetailsClick,
                onPriceChange: onResetPrice,
                onProductFilterChange: handleProductFilterChange,
                originalMax: getMaxPrice(),
                onDataChange: onResetData,
                onMinutesChange: onResetMinutes,
                onAirtimeChange: onResetAirtime
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {})]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: "".concat(showComp ? "" : "mt-3 ", "spacing-bottom d-block d-lg-none"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              className: (featureSelected === "filter" || featureSelected == "search") && "override",
              children: (featureSelected === "filter" || featureSelected === "search") && /*#__PURE__*/(0,jsx_runtime.jsx)(dealGridSearchContainer_DealGridSearchContainer, {
                className: "nav-gutter",
                categoriesList: showComp ? categoryList : filteredCategories,
                brands: allBrands,
                promotions: allPromotions,
                plantype: plantypes,
                planname: plannames,
                accessories: accessories,
                contractduration: contractDuration,
                contracttype: contractType,
                contractsList: contractsList,
                hide: showComp,
                show: changeState,
                selectedContractType: (_selectedFilter39 = selectedFilter) === null || _selectedFilter39 === void 0 ? void 0 : _selectedFilter39.contracttype,
                selectedSubCategories: (_selectedFilter40 = selectedFilter) === null || _selectedFilter40 === void 0 ? void 0 : _selectedFilter40.selectedSubCategory,
                selectedCategory: selectedCategory,
                priceValue: priceValue,
                priceRange: isEligible() && showQualifyDeals ? affordablePriceRange : priceFilterData,
                missingPriceRange: isEligible() && showQualifyDeals ? missingAffordablePriceRange : missingPriceFilterData,
                maxPrice: maxPrice,
                vmValue: selectedFilter.minutes,
                airValue: selectedFilter.airtime,
                promoValue: selectedFilter.promo_data,
                isDealGridPage: true,
                showQualifyDeals: isEligible() && showQualifyDeals,
                onPriceChange: handlePriceChange,
                onFilterChange: reloadPageData,
                onFilterReset: handleResetFilter,
                onBrandChange: handleBrandChange,
                onPromotionChange: handlePromotionChange,
                onContractTypeChange: handleContractTypeChange,
                onPlanTypeChange: handlePlanTypeChange,
                onPlanNameChange: handlePlanNameChange,
                onAccessoriesChange: handleAccessoriesChange,
                onContractDurationChange: handleContractDurationChange,
                onDataChange: handleDataChange,
                onAirTimeChange: handleAirTimeChange,
                onVoiceMinutesChange: handleVoiceMinutesChange,
                onSubCategoryChange: handleSubCategoryChange,
                onCategoryChange: handleCategoryChange,
                selectedFilter: selectedFilter,
                setSelectedFilter: setSelectedFilter,
                onProductFilterError: handleProductFilterError,
                onProductFilterChange: handleProductFilterChange,
                showProductFilter: showFilterByProduct,
                getSelectedPromotion: getSelectedPromotion,
                getSelectedBrands: getSelectedBrands,
                getSelectedContractType: getSelectedContractType,
                getSelectedPlanType: getSelectedPlanType,
                getSelectedPlanName: getSelectedPlanName,
                getSelectedContractDuration: getSelectedContractDuration,
                setPriceValue: function setPriceValue() {
                  return _setPriceValue(null);
                },
                getSelectedCategory: getSelectedCategory,
                handleApplyFilter: handleApplyFilter,
                isEligible: isEligible() && showQualifyDeals,
                productSearchOnDealGridEnabled: props === null || props === void 0 ? void 0 : props.productSearchOnDealGridEnabled
              })
            })
          }), productList && productList.products && productList.products.items ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(dealGridListContainer_DealGridListContainer, {
                selectedBrands: (_selectedFilter41 = selectedFilter) === null || _selectedFilter41 === void 0 ? void 0 : _selectedFilter41.brands,
                selectedPromotions: (_selectedFilter42 = selectedFilter) === null || _selectedFilter42 === void 0 ? void 0 : _selectedFilter42.promotions,
                selectedPlantype: (_selectedFilter43 = selectedFilter) === null || _selectedFilter43 === void 0 ? void 0 : _selectedFilter43.plantypes,
                selectedPlanname: (_selectedFilter44 = selectedFilter) === null || _selectedFilter44 === void 0 ? void 0 : _selectedFilter44.plannames,
                selectedAcccessories: (_selectedFilter45 = selectedFilter) === null || _selectedFilter45 === void 0 ? void 0 : _selectedFilter45.accessories,
                selectedContractDuration: (_selectedFilter46 = selectedFilter) === null || _selectedFilter46 === void 0 ? void 0 : _selectedFilter46.contractduration,
                selectedContractType: (_selectedFilter47 = selectedFilter) === null || _selectedFilter47 === void 0 ? void 0 : _selectedFilter47.contracttype,
                selectedSortVal: sortProductsBy,
                selectedPrice: Number(priceValue === null || priceValue === void 0 ? void 0 : priceValue.minValue) > Number(aggMinPrice) || Number(priceValue === null || priceValue === void 0 ? void 0 : priceValue.maxValue) < Number(aggMaxPrice) ? (_selectedFilter48 = selectedFilter) === null || _selectedFilter48 === void 0 ? void 0 : _selectedFilter48.monthly_recurring : null,
                selectedPromoData: Number((_selectedFilter49 = selectedFilter) === null || _selectedFilter49 === void 0 ? void 0 : (_selectedFilter49$pro = _selectedFilter49.promo_data) === null || _selectedFilter49$pro === void 0 ? void 0 : (_selectedFilter49$pro2 = _selectedFilter49$pro[0]) === null || _selectedFilter49$pro2 === void 0 ? void 0 : _selectedFilter49$pro2.label) > Number(constants/* MIN_DATA */.Kt) || Number((_selectedFilter50 = selectedFilter) === null || _selectedFilter50 === void 0 ? void 0 : (_selectedFilter50$pro = _selectedFilter50.promo_data) === null || _selectedFilter50$pro === void 0 ? void 0 : (_selectedFilter50$pro2 = _selectedFilter50$pro[1]) === null || _selectedFilter50$pro2 === void 0 ? void 0 : _selectedFilter50$pro2.label) < Number(constants/* MAX_DATA */.CS) ? (_selectedFilter51 = selectedFilter) === null || _selectedFilter51 === void 0 ? void 0 : _selectedFilter51.promo_data : null,
                selectedMinutesData: Number((_selectedFilter52 = selectedFilter) === null || _selectedFilter52 === void 0 ? void 0 : (_selectedFilter52$min = _selectedFilter52.minutes) === null || _selectedFilter52$min === void 0 ? void 0 : (_selectedFilter52$min2 = _selectedFilter52$min[0]) === null || _selectedFilter52$min2 === void 0 ? void 0 : _selectedFilter52$min2.label) > Number(constants/* MIN_MINUTES */.FW) || Number((_selectedFilter53 = selectedFilter) === null || _selectedFilter53 === void 0 ? void 0 : (_selectedFilter53$min = _selectedFilter53.minutes) === null || _selectedFilter53$min === void 0 ? void 0 : (_selectedFilter53$min2 = _selectedFilter53$min[1]) === null || _selectedFilter53$min2 === void 0 ? void 0 : _selectedFilter53$min2.label) < Number(constants/* MAX_MINUTES */.UT) ? (_selectedFilter54 = selectedFilter) === null || _selectedFilter54 === void 0 ? void 0 : _selectedFilter54.minutes : null,
                selectedAirtimeData: Number((_selectedFilter55 = selectedFilter) === null || _selectedFilter55 === void 0 ? void 0 : (_selectedFilter55$air = _selectedFilter55.airtime) === null || _selectedFilter55$air === void 0 ? void 0 : (_selectedFilter55$air2 = _selectedFilter55$air[0]) === null || _selectedFilter55$air2 === void 0 ? void 0 : _selectedFilter55$air2.label) > Number(constants/* MIN_AIRTIME */.hJ) || Number((_selectedFilter56 = selectedFilter) === null || _selectedFilter56 === void 0 ? void 0 : (_selectedFilter56$air = _selectedFilter56.airtime) === null || _selectedFilter56$air === void 0 ? void 0 : (_selectedFilter56$air2 = _selectedFilter56$air[1]) === null || _selectedFilter56$air2 === void 0 ? void 0 : _selectedFilter56$air2.label) < Number(constants/* MAX_AIRTIME */.Vr) ? (_selectedFilter57 = selectedFilter) === null || _selectedFilter57 === void 0 ? void 0 : _selectedFilter57.airtime : null,
                selectedProducts: (_selectedFilter58 = selectedFilter) === null || _selectedFilter58 === void 0 ? void 0 : _selectedFilter58.search,
                items: productList === null || productList === void 0 ? void 0 : (_productList$products4 = productList.products) === null || _productList$products4 === void 0 ? void 0 : _productList$products4.items,
                isDealGridPage: true,
                hide: showComp,
                sortBy: handleSortBy,
                show: changeState,
                featureSelected: featureSelected,
                pageInfo: productList === null || productList === void 0 ? void 0 : (_productList$products5 = productList.products) === null || _productList$products5 === void 0 ? void 0 : _productList$products5.page_info,
                totalItemsCount: productList === null || productList === void 0 ? void 0 : (_productList$products6 = productList.products) === null || _productList$products6 === void 0 ? void 0 : _productList$products6.total_count,
                updateCurrentPage: updateCurrentPage,
                bannerData: bannerData,
                clearCategories: clearCategorieFilters,
                showQualifyDeals: isEligible() && showQualifyDeals,
                defaultUpgrade: isEligible(),
                onBrandChange: handleBrandChange,
                onPromotionChange: handlePromotionChange,
                onContractTypeChange: handleContractTypeChange,
                onPlanTypeChange: handlePlanTypeChange,
                onPlanNameChange: handlePlanNameChange,
                onAccessoriesChange: handleAccessoriesChange,
                onContractDurationChange: handleContractDurationChange,
                onFilterChange: reloadPageData,
                onFilterReset: handleResetFilter,
                setSelectedFilter: setSelectedFilter,
                onSeeDetailsClick: handleSeeDetailsClick,
                onPriceChange: onResetPrice,
                onProductFilterChange: handleProductFilterChange,
                originalMax: getMaxPrice(),
                onDataChange: onResetData,
                onMinutesChange: onResetMinutes,
                onAirtimeChange: onResetAirtime
              })
            })
          }) : ""]
        })]
      }), props !== null && props !== void 0 && (_props$sections = props.sections) !== null && _props$sections !== void 0 && _props$sections.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "deal-promotion ".concat(!(props !== null && props !== void 0 && props.hidePromo) ? "d-block" : "d-none"),
          children: props.sections.map(function (component, index) {
            return (0,renderComponent/* renderComponent */.SO)(component, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "pb-l ".concat(props !== null && props !== void 0 && props.hidePromo ? "d-block" : "d-none")
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "pb-l"
      })]
    })]
  });
};

var deals_mapStateToProps = function mapStateToProps(state) {
  return {
    hidePromo: state.displayHideFooter.hideFooter,
    profileData: state.navDetails.profileData,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    profileLoading: state.navDetails.isProfileLoading,
    upgrade: state.upgrade,
    upgradeResponse: state.upgrade.upgradeResponse,
    eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
    resetDealGrid: state.upgrade.resetDealGrid,
    isShowAffordDeal: state.creditCheckDetails.isShowAffordDeal,
    isSelectedAffordDeal: state.creditCheckDetails.isSelectedAffordDeal
  };
};

var __N_SSP = true;
/* harmony default export */ var deals = ((0,es/* connect */.$j)(deals_mapStateToProps, {
  displayHideUpgradeModal: upgradeAction/* displayHideUpgradeModal */.ex,
  updateUpgradeRedirect: upgradeAction/* updateUpgradeRedirect */.z9,
  displayHideUpgradeTopbanner: upgradeAction/* displayHideUpgradeTopbanner */.Od,
  updateJourneyStatus: upgradeAction/* updateJourneyStatus */.aI,
  updateSelectedData: upgradeAction/* updateSelectedData */.x$,
  updateDealsReset: upgradeAction/* updateDealsReset */.wi,
  toggleFilters: navAction/* toggleFilters */.aD
})((0,next_router.withRouter)(DealGridPage)));

/***/ }),

/***/ 74425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ breadcrumbGenerator; }
/* harmony export */ });
/* harmony import */ var _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);



var breadcrumbGenerator = function breadcrumbGenerator(customBreadcrumb) {
  var _labels$Session_Keys, _getSessionStorage$, _labels$Session_Keys2;

  var productlistfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys === void 0 ? void 0 : _labels$Session_Keys.lbl_list_page_router_with_filters) ? (_getSessionStorage$ = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys2 = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys2 === void 0 ? void 0 : _labels$Session_Keys2.lbl_list_page_router_with_filters)[0]) === null || _getSessionStorage$ === void 0 ? void 0 : _getSessionStorage$.products : "/shopping/products";
  var dealfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") ? (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") : "/shopping/deals";
  var router = (0,_components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var breadcrumbconfig = {
    productlist: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/products",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }],
    cmsPage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.link,
      label: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.label
    }],
    productdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }],
    productcompare: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-compare",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_compare_products */ .Z.BreadCrumbLabels.lbl_compare_products
    }],
    deals: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }],
    dealdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }, {
      link: "/shopping/deal-details-page/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_deal_details */ .Z.BreadCrumbLabels.lbl_deal_details
    }],
    dealselection: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/".concat(router.query.id),
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }, {
      link: "/shopping/deal-selection",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lbl_select_deal */ .Z.lbl_select_deal
    }],
    orderhistory: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }],
    orderdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/view-order-details",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_details */ .Z.BreadCrumbLabels.lbl_order_details
    }],
    trackorder: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/track-my-order",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_track_order */ .Z.BreadCrumbLabels.lbl_track_order
    }],
    upgradePage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/upgrade",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_upgrade_page */ .Z.BreadCrumbLabels.lbl_upgrade_page
    }]
  };
  return breadcrumbconfig;
};

/***/ }),

/***/ 96902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ getNotAllowedRanges; },
/* harmony export */   "b0": function() { return /* binding */ getAffordablePriceFilterDataFromOptions; },
/* harmony export */   "kD": function() { return /* binding */ getPriceFilterDataFromOptions; }
/* harmony export */ });
/* unused harmony export findClosestPriceFilterValue */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);

var getPriceFilterDataFromOptions = function getPriceFilterDataFromOptions(options) {
  var localPriceFilterData = options.reduce(function (total, opt) {
    return total.concat(opt === null || opt === void 0 ? void 0 : opt.value.split("_").map(function (val) {
      return Number(val);
    }));
  }, []);
  return (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Set(localPriceFilterData));
};
var getNotAllowedRanges = function getNotAllowedRanges(options) {
  var localPriceFilterData = getPriceFilterDataFromOptions(options);
  var missingRangesArray = options.map(function (opt, index) {
    var _options;

    if (Number(opt.value.split("_")[1]) < Number((_options = options[index + 1]) === null || _options === void 0 ? void 0 : _options.value.split("_")[0])) {
      var _options2;

      return {
        min: localPriceFilterData.indexOf(Number(opt.value.split("_")[1])),
        max: localPriceFilterData.indexOf(Number((_options2 = options[index + 1]) === null || _options2 === void 0 ? void 0 : _options2.value.split("_")[0]))
      };
    }
  });
  var missingRanges = missingRangesArray.filter(function (val) {
    if (val) {
      return val;
    }
  });
  return missingRanges;
};
var findClosestPriceFilterValue = function findClosestPriceFilterValue(filterData, value) {
  var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!value) return value;
  var numericValue = Number(value);

  for (var i = 0; i < filterData.length; i++) {
    var currentFilterData = Number(filterData[i]);

    if (currentFilterData == numericValue) {
      return i;
    } // if we find bigger we need to stop, calculate distance and return the correct one


    if (filterData[i] > numericValue) {
      return min ? i - 1 : i;
    }
  }

  return filterData.length - 1;
};
var getAffordablePriceFilterDataFromOptions = function getAffordablePriceFilterDataFromOptions(options, max) {
  var fixedVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var newArr = options.filter(function (value) {
    return value <= max;
  });
  var newMax = Number(fixedVal) > Number(max) ? max.toFixed() : fixedVal;

  if (newArr.length == 0) {
    newArr = [0, Number(newMax)];
  } else if (newArr.length == 1 && newArr[0] === 0) {
    newArr.push(Number(newMax));
  }

  if (newArr[newArr.length - 1] < newMax) {
    newArr.push(Number(newMax));
  }

  return newArr;
};

/***/ }),

/***/ 33885:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/deals",
      function () {
        return __webpack_require__(71030);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"BreadCrumb_p-xxs__heuAZ","pl-xxs":"BreadCrumb_pl-xxs__Pq2yx","pr-xxs":"BreadCrumb_pr-xxs__LOdz9","pb-xxs":"BreadCrumb_pb-xxs__dYHA5","pt-xxs":"BreadCrumb_pt-xxs__I5eh2","m-xxs":"BreadCrumb_m-xxs__BV_wk","ml-xxs":"BreadCrumb_ml-xxs__AFLMm","mr-xxs":"BreadCrumb_mr-xxs__PCCSC","mb-xxs":"BreadCrumb_mb-xxs__afj_v","mt-xxs":"BreadCrumb_mt-xxs__hsFq1","px-xxs":"BreadCrumb_px-xxs__JeufQ","mx-xxs":"BreadCrumb_mx-xxs__6nDs8","my-xxs":"BreadCrumb_my-xxs__ExH3B","py-xxs":"BreadCrumb_py-xxs___yoiL","font-size-xxs":"BreadCrumb_font-size-xxs__G3b3k","p-xs":"BreadCrumb_p-xs__Ydf2v","pl-xs":"BreadCrumb_pl-xs__4KFtt","pr-xs":"BreadCrumb_pr-xs__j5LDB","pb-xs":"BreadCrumb_pb-xs__r7wlS","pt-xs":"BreadCrumb_pt-xs__lYyC_","m-xs":"BreadCrumb_m-xs__kqGup","ml-xs":"BreadCrumb_ml-xs__9fxNn","mr-xs":"BreadCrumb_mr-xs__MnHIX","mb-xs":"BreadCrumb_mb-xs__2kV_4","mt-xs":"BreadCrumb_mt-xs__TWQWC","px-xs":"BreadCrumb_px-xs__POnB8","mx-xs":"BreadCrumb_mx-xs__NWC0P","my-xs":"BreadCrumb_my-xs__Ov9pH","py-xs":"BreadCrumb_py-xs__6k99w","font-size-xs":"BreadCrumb_font-size-xs__TDTVR","p-ss":"BreadCrumb_p-ss__8nenT","pl-ss":"BreadCrumb_pl-ss__E6s6_","pr-ss":"BreadCrumb_pr-ss__bDcG5","pb-ss":"BreadCrumb_pb-ss__J6_Jj","pt-ss":"BreadCrumb_pt-ss__V9sXm","m-ss":"BreadCrumb_m-ss__MksLc","ml-ss":"BreadCrumb_ml-ss__IgrfK","mr-ss":"BreadCrumb_mr-ss__NBuN5","mb-ss":"BreadCrumb_mb-ss__eXzqE","mt-ss":"BreadCrumb_mt-ss__RtZGW","px-ss":"BreadCrumb_px-ss__iSdiI","mx-ss":"BreadCrumb_mx-ss__gmV4s","my-ss":"BreadCrumb_my-ss__vBgaK","py-ss":"BreadCrumb_py-ss__6S3aJ","font-size-ss":"BreadCrumb_font-size-ss__8a9R5","p-ms":"BreadCrumb_p-ms__ekoV9","pl-ms":"BreadCrumb_pl-ms__D7tmj","pr-ms":"BreadCrumb_pr-ms__e2sRD","pb-ms":"BreadCrumb_pb-ms__rnAj_","pt-ms":"BreadCrumb_pt-ms__ag7m4","m-ms":"BreadCrumb_m-ms__T9KF0","ml-ms":"BreadCrumb_ml-ms__5RRFE","mr-ms":"BreadCrumb_mr-ms__wfkjE","mb-ms":"BreadCrumb_mb-ms__NUSVf","mt-ms":"BreadCrumb_mt-ms__O7sWI","px-ms":"BreadCrumb_px-ms__4XByK","mx-ms":"BreadCrumb_mx-ms__Tnh9Z","my-ms":"BreadCrumb_my-ms__2jObH","py-ms":"BreadCrumb_py-ms__QLzHK","font-size-ms":"BreadCrumb_font-size-ms__Ii_oH","p-s":"BreadCrumb_p-s__Ao5TN","pl-s":"BreadCrumb_pl-s__kmzwv","pr-s":"BreadCrumb_pr-s__0GvID","pb-s":"BreadCrumb_pb-s__LMNvJ","pt-s":"BreadCrumb_pt-s__DN70M","m-s":"BreadCrumb_m-s__Gfub1","ml-s":"BreadCrumb_ml-s__T1n7a","mr-s":"BreadCrumb_mr-s__JM_qb","mb-s":"BreadCrumb_mb-s__Y9fra","mt-s":"BreadCrumb_mt-s__TgqdQ","px-s":"BreadCrumb_px-s__B4BJD","mx-s":"BreadCrumb_mx-s__ggx55","my-s":"BreadCrumb_my-s__VOnn0","py-s":"BreadCrumb_py-s__RJTVn","font-size-s":"BreadCrumb_font-size-s__OJxvW","p-m":"BreadCrumb_p-m__4jcNq","pl-m":"BreadCrumb_pl-m__qoFdT","pr-m":"BreadCrumb_pr-m__fCW0F","pb-m":"BreadCrumb_pb-m__4_21j","pt-m":"BreadCrumb_pt-m__1bU9M","m-m":"BreadCrumb_m-m__piMyJ","ml-m":"BreadCrumb_ml-m__oBCf_","mr-m":"BreadCrumb_mr-m__p9RbI","mb-m":"BreadCrumb_mb-m__W6HyL","mt-m":"BreadCrumb_mt-m__gibKu","px-m":"BreadCrumb_px-m__NFUVV","mx-m":"BreadCrumb_mx-m__ACbJ1","my-m":"BreadCrumb_my-m__IDE7l","py-m":"BreadCrumb_py-m__I1kXn","font-size-m":"BreadCrumb_font-size-m__5EbDy","p-l":"BreadCrumb_p-l___LdZT","pl-l":"BreadCrumb_pl-l__1c4Iu","pr-l":"BreadCrumb_pr-l__euf69","pb-l":"BreadCrumb_pb-l__naQqI","pt-l":"BreadCrumb_pt-l__2H63b","m-l":"BreadCrumb_m-l__LFNUk","ml-l":"BreadCrumb_ml-l__AUqRa","mr-l":"BreadCrumb_mr-l__d60lJ","mb-l":"BreadCrumb_mb-l__xoQ9d","mt-l":"BreadCrumb_mt-l__FpoKd","px-l":"BreadCrumb_px-l__R8GEA","mx-l":"BreadCrumb_mx-l__0zBpp","my-l":"BreadCrumb_my-l__tYR_K","py-l":"BreadCrumb_py-l__fWTn6","font-size-l":"BreadCrumb_font-size-l__kHO4q","p-xl":"BreadCrumb_p-xl__sVryE","pl-xl":"BreadCrumb_pl-xl__OKP64","pr-xl":"BreadCrumb_pr-xl__6IFNa","pb-xl":"BreadCrumb_pb-xl__WaJwF","pt-xl":"BreadCrumb_pt-xl__apbAF","m-xl":"BreadCrumb_m-xl__gKVFJ","ml-xl":"BreadCrumb_ml-xl__RboKO","mr-xl":"BreadCrumb_mr-xl__dpz2h","mb-xl":"BreadCrumb_mb-xl__uOh3J","mt-xl":"BreadCrumb_mt-xl__FFF7p","px-xl":"BreadCrumb_px-xl__ITzPQ","mx-xl":"BreadCrumb_mx-xl__x7GK3","my-xl":"BreadCrumb_my-xl__2QEJ2","py-xl":"BreadCrumb_py-xl__bNH7S","font-size-xl":"BreadCrumb_font-size-xl__QyImp","p-xxl":"BreadCrumb_p-xxl__5ZYd6","pl-xxl":"BreadCrumb_pl-xxl__TlpF5","pr-xxl":"BreadCrumb_pr-xxl__Jw5VV","pb-xxl":"BreadCrumb_pb-xxl__6i7kj","pt-xxl":"BreadCrumb_pt-xxl__s5KBw","m-xxl":"BreadCrumb_m-xxl__whIb2","ml-xxl":"BreadCrumb_ml-xxl__kkiO1","mr-xxl":"BreadCrumb_mr-xxl__Rqk9w","mb-xxl":"BreadCrumb_mb-xxl__UvCHx","mt-xxl":"BreadCrumb_mt-xxl__3CXiR","px-xxl":"BreadCrumb_px-xxl__t2uey","mx-xxl":"BreadCrumb_mx-xxl__72iew","my-xxl":"BreadCrumb_my-xxl__xu_qX","py-xxl":"BreadCrumb_py-xxl__KknxS","font-size-xxl":"BreadCrumb_font-size-xxl__l_W0q","overflow-hidden":"BreadCrumb_overflow-hidden__6Pek3","topMargin":"BreadCrumb_topMargin__h_vBW","breadcrumb-wrapper":"BreadCrumb_breadcrumb-wrapper__PXx8y","breadcrumb-list":"BreadCrumb_breadcrumb-list__bwQ2f","breadcrumb-item":"BreadCrumb_breadcrumb-item__8lNEe"};

/***/ }),

/***/ 56209:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-check-bar":"upgradeCheckBar_upgrade-check-bar__Qqp_9","message":"upgradeCheckBar_message__sBV34","ctaBtn":"upgradeCheckBar_ctaBtn__S1JhB","upgrade-check-bar-success":"upgradeCheckBar_upgrade-check-bar-success__938HG","upgrade-check-bar-info":"upgradeCheckBar_upgrade-check-bar-info__e2NVC"};

/***/ }),

/***/ 44472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-check-bar":"upgradeInfoBar_upgrade-check-bar__SmAjS","message":"upgradeInfoBar_message__XGXLl","ctaBtn":"upgradeInfoBar_ctaBtn__2aU9z","info-img":"upgradeInfoBar_info-img__t1b7B","upgrade-check-bar-success":"upgradeInfoBar_upgrade-check-bar-success___cE2w","upgrade-check-bar-info":"upgradeInfoBar_upgrade-check-bar-info__gmVEP"};

/***/ }),

/***/ 60741:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search-box-autosuggest-container":"SearchBoxAutoSuggest_search-box-autosuggest-container__1V4JW","search-box-autosuggest-items-container":"SearchBoxAutoSuggest_search-box-autosuggest-items-container__JY8jM","search-box":"SearchBoxAutoSuggest_search-box__FR7vz","img":"SearchBoxAutoSuggest_img__zCha7","search-input":"SearchBoxAutoSuggest_search-input__N0Ph9","search-options":"SearchBoxAutoSuggest_search-options__W34QH","menu":"SearchBoxAutoSuggest_menu__I37Ga","menu-item":"SearchBoxAutoSuggest_menu-item__LxFEs","menu-item__name":"SearchBoxAutoSuggest_menu-item__name__Hegto","green-icon":"SearchBoxAutoSuggest_green-icon__GCEo6","active":"SearchBoxAutoSuggest_active__J42ui","no-border-radius-top":"SearchBoxAutoSuggest_no-border-radius-top__AD7up","no-border-radius-bottom":"SearchBoxAutoSuggest_no-border-radius-bottom__RXEUK","info":"SearchBoxAutoSuggest_info__ksZ7s","info-icon":"SearchBoxAutoSuggest_info-icon__Zo_F8","info-label":"SearchBoxAutoSuggest_info-label__ZKiPw"};

/***/ }),

/***/ 1157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"priceHeading":"Contracttype_priceHeading__NiATV","priceLabel":"Contracttype_priceLabel__FZjBY","radiobtnDiv":"Contracttype_radiobtnDiv__h6UNm","description":"Contracttype_description__1Gner","title":"Contracttype_title__F8wjD","radiobtn":"Contracttype_radiobtn__fQbat","radio":"Contracttype_radio__KBSlY","price-label":"Contracttype_price-label__HcvN_","hideSlider":"Contracttype_hideSlider__EegUb"};

/***/ }),

/***/ 40658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"priceHeading":"DealSliderFilter_priceHeading__IkQRQ","priceLabel":"DealSliderFilter_priceLabel__fn7p0","hideSliderDeal":"DealSliderFilter_hideSliderDeal__Hee_t","radiobtn":"DealSliderFilter_radiobtn__DTu3M","radio":"DealSliderFilter_radio__0p86q","price-label":"DealSliderFilter_price-label__rC_hH","hideSlider":"DealSliderFilter_hideSlider__DeDX1","info":"DealSliderFilter_info__eQc_0","info-icon":"DealSliderFilter_info-icon__3ShaD","info-label":"DealSliderFilter_info-label__cWQjw"};

/***/ }),

/***/ 90609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error-card-block":"ErrorCard_error-card-block__a5i2d","error-sub-text":"ErrorCard_error-sub-text__SOeNv","error-card-image":"ErrorCard_error-card-image__UNBmk","error-card":"ErrorCard_error-card__uAWyz","error-card__heading":"ErrorCard_error-card__heading__BvUl0","error-card__subheading":"ErrorCard_error-card__subheading__JxMX_"};

/***/ }),

/***/ 67161:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"productRange_image__ni_DX","product-card-label":"productRange_product-card-label__kM09W","productlabel-card-styling":"productRange_productlabel-card-styling__pA01F","product-section-title":"productRange_product-section-title__CESon","product-range-card":"productRange_product-range-card__sdiMg","product-range-card-selected":"productRange_product-range-card-selected__BS0_y","product-card-label-selected":"productRange_product-card-label-selected__z1pko","product-card-container":"productRange_product-card-container__Z0rDm","hide":"productRange_hide___09Y3"};

/***/ }),

/***/ 41708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper-checkbox":"AffordabilityFilterToggle_wrapper-checkbox__aMtlJ","item-label":"AffordabilityFilterToggle_item-label__8Qt8a"};

/***/ }),

/***/ 78626:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"browse-container":"BrowseContainer_browse-container__rHp7_","browse-bar":"BrowseContainer_browse-bar__Tw1QZ","line":"BrowseContainer_line__1KK5g","browse-heading":"BrowseContainer_browse-heading__hkfMr","browse-heading-styling":"BrowseContainer_browse-heading-styling__r3SCe","browse-sub-heading":"BrowseContainer_browse-sub-heading__7vmNx","browse-deal-sub-heading":"BrowseContainer_browse-deal-sub-heading__pESsA","btn-group":"BrowseContainer_btn-group__TqUY4","hide":"BrowseContainer_hide__IvGww","browse-bar-tablet-styling":"BrowseContainer_browse-bar-tablet-styling__NcL1J","filter-button-tablet":"BrowseContainer_filter-button-tablet__FOvXo","search-filter-tablet":"BrowseContainer_search-filter-tablet__P9f41"};

/***/ }),

/***/ 22700:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search-container":"ProductFilter_search-container__yy1ae","filter-heading":"ProductFilter_filter-heading__R4ij7","showResultsBtn":"ProductFilter_showResultsBtn__rs8Hh","disabled":"ProductFilter_disabled__B_HIo","navGutter":"ProductFilter_navGutter__ULZWh","px-xxs-buffer":"ProductFilter_px-xxs-buffer__0jb3X","search-box":"ProductFilter_search-box__IsEWO"};

/***/ }),

/***/ 56710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product-card":"DealGridListContainer_product-card__eSlXf","page-info":"DealGridListContainer_page-info__V9bIK","page-info-text":"DealGridListContainer_page-info-text__3pE5I","page-info-text-btm":"DealGridListContainer_page-info-text-btm__QTIzW","price-switch":"DealGridListContainer_price-switch__VR4A9","dropdown-item":"DealGridListContainer_dropdown-item__v0arP","deal-sort-native-container-class":"DealGridListContainer_deal-sort-native-container-class__AFiyg","price-switch-text":"DealGridListContainer_price-switch-text__VCX1X","pillsDiv":"DealGridListContainer_pillsDiv__zRX5N","pillSpacing":"DealGridListContainer_pillSpacing__LeXfq","selection-drop-down":"DealGridListContainer_selection-drop-down__IOEJy","info-banner":"DealGridListContainer_info-banner__VE0_3","hide":"DealGridListContainer_hide__BMg41","sort-gutter":"DealGridListContainer_sort-gutter__ghxr1","banner":"DealGridListContainer_banner__ZjSxx","sort-deal-selection":"DealGridListContainer_sort-deal-selection__a7YVu","deal-cards-custom-spacing":"DealGridListContainer_deal-cards-custom-spacing__1ON1R","dealcard-link":"DealGridListContainer_dealcard-link__HcD_0","containerheight":"DealGridListContainer_containerheight__CxZOz","disabled":"DealGridListContainer_disabled__AoH_9","upgrade-row":"DealGridListContainer_upgrade-row__20sVq","upgrade-page-info":"DealGridListContainer_upgrade-page-info__SVsDO"};

/***/ }),

/***/ 89392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn-box":"DealGridSearchContainer_btn-box__NCYmL","hide":"DealGridSearchContainer_hide__0huxP","nav-gutter":"DealGridSearchContainer_nav-gutter__0sFAk","show-results":"DealGridSearchContainer_show-results__c1ftb","show-results__button":"DealGridSearchContainer_show-results__button__aD6HN","button":"DealGridSearchContainer_button__RB1FH","reset":"DealGridSearchContainer_reset__cl9IF"};

/***/ }),

/***/ 86295:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"PriceMobileItem_priceContainer__uo93x","radiobtn":"PriceMobileItem_radiobtn__EC8uG","radio":"PriceMobileItem_radio__4NymX","navGutter":"PriceMobileItem_navGutter__bRD4G","botton-box":"PriceMobileItem_botton-box__Jh4Xh","labelMain":"PriceMobileItem_labelMain__MjHsE"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1216,9322,4881,4309,8005,8282,4945,8375,9327,280,5887,5951,9774,2888,179], function() { return __webpack_exec__(33885); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);